import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { DataService } from 'src/app/core/services/data.service';
import { CommonService } from 'src/app/core/services/common.service';
import { DocumentService } from 'src/app/core/services/document.service';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ContractService } from 'src/app/core/services/contract.service';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import { WarningSmsContractService } from 'src/app/core/services/warning-sms-contract.service';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material';
import { NgxExtendedPdfViewerService, PagesLoadedEvent, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { PanelDocumentComponent } from '../../panel-document/panel-document.component';
import { DisplayTemplateComponent } from '../../display-template/display-template.component';
import { BehaviorSubject, forkJoin, Subject, Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { EnumContractType } from 'src/app/core/constants/contract';
import Utils from 'src/app/core/services/app-utils';
import { finalize, first, map, take } from 'rxjs/operators';
import { SelectDocumentTypeComponent } from '../../select-document-type/select-document-type.component';
import { CreateContractService } from 'src/app/core/services/create-contract.service';
import { DocumentEntity } from 'src/app/core/class/DocumentEntity';
import FileUtils, { ContentType } from 'src/app/core/services/file-utils';
import { Field } from 'src/app/shared/models/field.model';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { TranslateService } from '@ngx-translate/core';
import { DocumentTemplateService } from 'src/app/core/services/document-template.service';
import { FootNoteComponent } from '../document-form/footnote/footnote.component';
import { basename } from 'path';
import { HandsontableService } from 'src/app/core/services/handsontable.service';
import { FormControl, Validators } from '@angular/forms';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { EnvService } from 'src/app/core/services/env.service';
import { GeneralFormInfoComponent } from '../general-form-info/general-form-info.component';
import * as _ from 'lodash';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

import * as uuid from 'uuid';
import { RecordPartySignComponent } from '../record-party-sign/record-party-sign.component';
import { EnumRoleUser } from "src/app/core/constants/common";
import { ContractAttachments } from 'src/app/core/class/contract-attachments';
import { ViewFilePdfImgComponent } from 'src/app/shared/components/view-file-pdf-img/view-file-pdf-img.component';
import {SignDocumentService} from 'src/app/core/services/sign-document.service';
import {ImageGenerateService} from 'src/app/core/services/image-generate.service';
import {format} from 'date-fns';
import {
  ContentPosition,
  SignatureConfig
} from '../../sign-flow-document/signature-config.model';
import { getNegotiateCopyText, mapNegotiateMessage, MessageNegotiate } from 'src/app/core/services/negotiation-chat';
const FormActionType = 0;
const FileUploadType = 1;
declare var $: any;

@Component({
  selector: "app-preview-contract",
  templateUrl: "./preview-contract.component.html",
  styleUrls: ["./preview-contract.component.scss"],
})
export class PreviewContractComponent
  extends BaseComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @BlockUI() blockUI: NgBlockUI;
  selectFile: any;
  isCheckFormat: boolean = false;
  formatList: string[] = []
  isCheckFile: boolean = true
  totalPage: any;
  signatureSelected = null;
  signatureNeedShow = null;
  isOnAutoNumber: boolean = false;
  configAutoNumber: string;
  refreshContractCode = false;
  selectedFile: any = '';
  selectedFileSign: any = 0;
  isUpdate: any = false;
  size1MB = 1*1024*1024;
  isBuyContract1Mb: boolean = false;
  isBuyContract10Mb: boolean = false;
  renderSignOnce = 0
  renderFileOnce = 0
  @Input() maxSize: number = 10485760;
  @Input() checkMan: boolean = false;
  maxSizeError: string = '';
  listData:any = [];
  documentCodeNull = false;
  isReady = new EventEmitter();
  templateSize = '0'
  constructor(
    private apiService: ApiService,
    private dataService: DataService,
    private el: ElementRef,
    public commonService: CommonService,
    private documentService: DocumentService,
    public message: Message,
    public toastr: ToastrService,
    private route: ActivatedRoute,
    private breadcrumbsService: BreadcrumbsService,
    public notificationService: NotificationService,
    private contractService: ContractService,
    private router: Router,
    private dialog: MatDialog,
    private enterpriseService: EnterpriseService,
    private warningSmsContractService: WarningSmsContractService,
    private _location: Location,
    private createContractService: CreateContractService,
    private translateService: TranslateService,
    private documentTypeService: DocumentTypeService,
    private documentTemplateService: DocumentTemplateService,
    private cdr: ChangeDetectorRef,
    private handsontableService: HandsontableService,
    private pdfViewerService: NgxExtendedPdfViewerService,
    private env: EnvService,
    private zone: NgZone,
    private signDocumentService: SignDocumentService,
    private imageGenerateService: ImageGenerateService,
  ) {
    super(commonService, message);
    // this.document.id = this.route.snapshot.paramMap.get('id');
    // this.documentId = this.route.snapshot.paramMap.get('id');
    this.flagCopy = this.route.snapshot.queryParams.flagCopy;
    // this.typeCopy = parseInt(this.route.snapshot.queryParams.typeCopy, 16);
    // this.typeUpdate = parseInt(this.route.snapshot.queryParams.typeUpdate, 16);
    this.language = localStorage.getItem("__language") || "vi";

    // set menu trái là default Collapsed khi vào màn Lập hợp đồng
    // localStorage.setItem(this.SIDEBAR_CURRENT_STATUS, this.COLLAPSED);
    pdfDefaultOptions.renderInteractiveForms = false;
    this.isUpdate = this.route.snapshot.queryParams && (this.route.snapshot.queryParams.typeUpdate || (this.route.snapshot.queryParams.goFrom == 'mine' && !this.route.snapshot.queryParams.flagCopy  && !this.route.snapshot.queryParams.termination));
  }

  public isShowReferencePdf = false;
  public language: string;
  maxPageCurrent;
  @ViewChild(PanelDocumentComponent, {
    read: PanelDocumentComponent,
    static: true,
  })
  panelDocumentComponent;

  @ViewChild(DisplayTemplateComponent, {
    read: DisplayTemplateComponent,
    static: false,
  })
  displayTemplateComponent;

  @ViewChild('footNote', {
    static: true
  })
  public footNote: FootNoteComponent;
  @ViewChild(GeneralFormInfoComponent, {
    read: GeneralFormInfoComponent,
    static: true
  }) generalFormInfoComponent: GeneralFormInfoComponent;

  @ViewChild(RecordPartySignComponent, {
    read: RecordPartySignComponent,
    static: true
  }) recordPartySignComponent: RecordPartySignComponent;
  submit = new Subject();
  documentShare = new Subject();
  viewDocumentShare = new Subject();
  documentReferenceShare = new Subject();

  documentType: string;

  document: DocumentEntity;

  warningContractQuantity = false;

  firstLoad = true;

  currentTab = 0;

  // List cities
  cities: { id: number; name: ""; description: "" }[];

  // List districts
  districts: { id: number; cityId: number; name: ""; description: "" }[];

  // List wards
  wards: { id: number; districtId: number; name: ""; description: "" }[];

  // Id of current enterprise
  enterpriseId = localStorage.getItem("enterpriseId");

  // Default address of enterprise
  defaultAddress = {
    cityId: null,
    districtId: null,
    wardId: null,
    enterpriseId: null,
    address: "",
  };

  // Default enterprise's information
  defaultEnterprises = {
    id: null,
    name: "",
    enterpriseType: null,
    tenantId: 1,
    foreignName: "",
    parentId: null,
    abbreviation: "",
    taxCode: "",
    licenceDate: null,
    activeDate: null,
    phone: "",
    fax: "",
    primaryEmail: "",
    email: "",
    certificateId: null,
    certificateNo: "",
    issuedDate: null,
    issuedAt: "",
    expiryDate: null,
    accountNumber: "",
    bankName: "",
    bankBranch: "",
    representative: "",
    position: "",
    representativeCertificateId: null,
    representativeCertificateNo: "",
    representativeIssuedDate: null,
    representativeIssuedOn: "",
    status: true,
    version: null,
    birthday: null,
    sex: "",
    files: [],
    adminUser: "",
    addresses: [this.defaultAddress],
    attachments: [],
    parentName: "",
  };

  // Enterprise information
  enterprise = this.defaultEnterprises;

  // grab response data.
  documentTemplate = "";
  // Data for binding to template, when updating, this variable will receive the document data
  documentData: any;
  // Default data for binding to template, when updating, this variable will not be used
  defaultDocumentData: any;

  // searching paging.
  page: number;
  pageSize: number;
  currentPage: number;
  routeLink: "";
  enterpriseSearch: "";
  documentTypeSearch: "";
  nameOrCode: "";
  customerName: "";
  status: "";
  serviceType: "";
  taxCode: "";
  createdUser: "";
  createdTimeFrom: "";
  createdTimeTo: "";
  finishDateFrom: "";
  finishDateTo: "";
  sortDirection: "";
  sortColumn: "";
  openSelected: number;
  selectedNumberPage: number;
  listSignature: any[] = [];
  listFont = [
    { name: 'Roboto', value: 'Roboto' }
  ];
  selectedFont = '';
  listSignatureTable: any[] = [];
  listSignatureHeadRows: any[] = [];
  // control buttions.
  flagCopy: any;
  typeCopy: any;
  typeUpdate: any;
  EventWarningContractSubscription;
  panelSuccessSubscription: Subscription;
  onChangeTemplateSubscription: Subscription;
  subscriptions: Subscription = new Subscription();
  fileSizeUp: number = 0;
  /**
   * Flag for change detection in CanDeactivate
   */
  show = true;

  documentId = "";
  isShowMatRaised = "";

  // Check for form change
  isFormChanging = true;

  // Check is page from page view document
  pageView = false;

  /**
   * Url check error duplicate document code
   */
  urlApiDocumentUpload = "/contract/file";
  urlApiDocumentForm = "/contract";
  // Refresh input file
  @ViewChild("inputUpload", { read: "", static: false })
  inputUploadFile: ElementRef;

  // Button upload
  @ViewChild("btnUpload", { read: "", static: false }) btnUpload: ElementRef;

  // Button form
  @ViewChild("btnForm", { read: ElementRef, static: false })
  btnForm: ElementRef;
  private serviceTypeEntity: any;
  public pdfSrc: string;
  oldPdfSrc: string;
  isVisible = true;

  SIDEBAR_CURRENT_STATUS = "SidebarCurrentStatus";
  EXPANDED = "Expanded";
  COLLAPSED = "Collapsed";
  isHide = false;
  @Input() selectForm: boolean;

  createContractType = null;

  zoomLevel = 100;

  isSelectPosition = false;
  currentNodeSelected = null;

  private stampWrapper: HTMLDivElement;
  widthRectangle = 300;
  heightRectangle = 136;
  widthRectangleSignature = 170;
  heightRectangleSignature = 70;
  pageIndex = 1;

  listSign = [];
  signSelected = null;

  // ảnh ký mặc định fill vào khung chân ký (cache theo tên chủ thể)
  defaultSignImageCache: Map<string, string> = new Map();
  defaultSignImageReady = false;
  // chống gọi gen trùng khi 1 tên mới xuất hiện giữa chừng
  pendingSignImageGens: Map<string, Promise<string>> = new Map();

  listDataSign = { enterprise: [], customer: [] };
  listApproverSign = [];
  listCusApproverSign = [];

  tabMode: 'hide' | 'info' | 'sign' = 'info';

  signNeedShow: null;
  signApproverNeedShow: null;

  isMouseLeave: boolean = false;
  public listPdfSrc = {};
  BASE_URL = 'http://localhost:8091/api';
  authorization: any
  @ViewChild('navigation', { static: false }) navigation: ElementRef;

  signaturesFormPositions: any = [];

  fileUploads: File[] = [];
  orderCus: number = 0;
  activeFile: number = 0;
  maxSizeSystem: number = 0;
  biggerThan10MBFileSize: number;
  fileUploadSize: number = 0;
  size10MB = 10*1024*1024;
  size150MB = 150*1024*1024;
  isHaveUserSign = true;

  selected = new FormControl('TIMES_ROMAN', []);
  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll(
      ".mat-form-field-invalid .mat-input-element,.mat-select-invalid"
    );
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  /**
   * Init the component.
   */
  ngOnInit() {


    this.authorization = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }
    this.BASE_URL = this.env.is_private_app ? this.env.private_api_endpoint : this.env.public_api_endpoint;
    this.BASE_URL += '/file/view/contract'
    // (window as any).pdfWorkerSrc = '/assets/js/pdf.worker.js';
    // get data form for updating document case.
    // sửa hđ tính sau
    // if (this.document.id) {
    //   this.documentService.checkTemplate(this.document.id).subscribe(rs => {
    //     if (rs.code === ErrorCode.CopyNotPermission) {
    //       this.toastr.error(this.message.getMessage('messages.copy_not_permission'));
    //       this.router.navigate([`home-enterprise/search-my-created-document`]);
    //     }
    //   });
    //
    //   // include 2 parts:
    //   // 1. document json of form input.
    //   // 2. document reference of right panel.
    //   this.loadBreadcrumb();
    //   this.getDocumentById(this.document.id);
    //   // if(this.document.id){
    //   //   this.getDocumentEditById(this.document.id);
    //   // }
    // }

    // get query param from source screen.
    // this.grabQueryParam();
    // this.openTabSign()

    // init for form data.
    this.initFormData();

    // Load addresses
    this.loadAddresses();

    // Load enterprise
    // this.loadEnterprise(this.enterpriseId);

    // register event for signal.
    // this.registerEvents();

    this.addEventsCheckFormChange();

    // Handle error from server when add/edit documents
    this.apiService.addUrlToHandlingErrorRestApisPut(this.urlApiDocumentForm);
    this.apiService.addUrlToHandlingErrorRestApis(this.urlApiDocumentForm);
    this.apiService.addUrlToHandlingErrorRestApisPut(this.urlApiDocumentUpload);
    this.apiService.addUrlToHandlingErrorRestApis(this.urlApiDocumentUpload);

    // if (this.router.url.includes('/home-enterprise/add-document')
    //   || this.route.snapshot.queryParams.flagCopy
    //   || this.typeCopy !== 0) {
    // /**
    //  * Có thể không dùng QuantitySms đã có khi lấy thông tin document
    //  * */
    // this.warningSmsContractService.getDataQuantityAndWarningQuantitySmsContractOfEnterpriseByService();
    // this.EventWarningContractSubscription = this.warningSmsContractService.statusUpdated.subscribe(
    //   (warningContractQuantity) => {
    //     this.warningContractQuantity = warningContractQuantity;
    //     if (warningContractQuantity === true) {
    //       this.disableInput();
    //       const dialogRef = this.dialog.open(AlertComponent, {
    //         width: '370px',
    //         data: this.message.getMessage('messages.warning_out_of_contract_quantity')
    //       });
    //       dialogRef.afterClosed().subscribe(rs => {
    //         this.router.navigate(['home-enterprise/search-my-created-document']);
    //       });
    //     } else {
    //       // Redirect from Dashboard: default open select file or template list for selection
    //       this.getRedirectParam();
    //     }
    //   }
    // );
    // }
    this.subscribeValue();
    this.changeDataToTable();

    this.isShowMatRaised =
      this.createContractService.createContractType.getValue() === 1
        ? "local"
        : this.createContractService.createContractType.getValue() === 0
          ? "server"
          : "";
    document.addEventListener('mouseup', (eventMouseUp) => {
      if (this.isSelectPosition && this.isMouseLeave) {
        this.returnToPrevPosition();
        this.returnToPrevPositionSignContract();
      }
    });
    this.listDataSign.customer.forEach(ala => {
      if(!ala.isSetupSignFlow && ala.customerApproves){
        delete ala.customerApproves;
      }
    })
    localStorage.setItem('listDataSignCustomer',JSON.stringify(this.listDataSign.customer));
    localStorage.setItem('listDataSignEnterprise',JSON.stringify(this.listDataSign.enterprise));
    localStorage.setItem('listDataApproverSign',JSON.stringify(this.listApproverSign));
    localStorage.setItem('listDataSignApprove',JSON.stringify(this.createContractService.recordsPartySign.getValue()));
    this.getListData();
    this.createContractService.infoFileTemplate.subscribe(value => {
      console.log(value);
      this.createContractService.pdfSrcForm.subscribe(value2 => {
        if(value && value2){
          this.templateSize = value.size
          setTimeout(()=>{
            const fileUploadSrc = this.createContractService.fileUploadSrc.getValue()
            if(fileUploadSrc[0]){
              this.createContractService.pdfSrc.next(fileUploadSrc[0])
            }
          },100)
          this.addFileTemplate()
        }
      })

    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectForm) {
      const listBtn = document.querySelectorAll("button");
      if (this.selectForm) {
        listBtn.forEach((btn) => {
          if (btn.className.includes('mat-stroked-button-create-document')) {
            btn.classList.add("btn_glowing");
          }
        });
        setTimeout(() => {
          listBtn.forEach((btn) => {
            btn.classList.remove("btn_glowing");
          });
        }, 5000);
      }
    }
    // this.isShowMatRaised = (this.createContractService.createContractType.getValue() === 1) ? 'local' : ((this.createContractService.createContractType.getValue() === 0) ? 'server' : '');
  }
  private getBase64File(file: Blob): any {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => { resolve(reader.result); };
      reader.readAsDataURL(file);
    });
  }

  subscribeValue() {
    this.notificationService.subscribeErrorService();

    this.subscriptions.add(this.createContractService.pdfSrc.asObservable().subscribe(res => {
      if (res) {
        this.pdfSrc = res;
        this.oldPdfSrc = res;
        if (this.createContractService.isRenderNewFile && this.renderSignOnce == 0) {
          this.blockUI.start('');
          this.genSignatureData();
          // this.createContractService.isRenderNewFile = false;
        }
      }
    }));
    // merge 21511
    this.subscriptions.add(
      this.createContractService.isBuyContract1Mb.asObservable().subscribe((res) => {
        if (res) {
          this.isBuyContract1Mb = res;
        }
      })
    );
    this.subscriptions.add(
      this.createContractService.isBuyContract10Mb.asObservable().subscribe((res) => {
        if (res) {
          this.isBuyContract10Mb = res;
        }
      })
    );
// merge 21511
    this.subscriptions.add(
      this.createContractService.document.asObservable().subscribe((res) => {
        if (res) {
          this.document = null
          this.document = res;
          if(!this.isCallChatOnce){
            this.isCallChatOnce = true
            this.isNegotiate = res.negotiate || false
            if(this.isNegotiate && !this.flagCopy){
              this.getHistoryChat(true)
              if(this.intervalChat){
                clearInterval(this.intervalChat)
              } else {
                this.intervalChat = setInterval(()=>{
                  this.getHistoryChat()
                },10000)
              }
            }
          }
          this.document.dataDocumentParent = this.createContractService.dataReferenceContract.getValue();
          let lstReferenceContractId = [];
          if(this.createContractService.dataReferenceContract.getValue() && this.createContractService.dataReferenceContract.getValue().length > 0){
            this.createContractService.dataReferenceContract.getValue().forEach(ele => {
              lstReferenceContractId.push(ele.id);
            })
          }
          this.document.lstReferenceContractId = lstReferenceContractId;
          // console.log('document', this.document);
          if(this.document.id) {
            if(res.mainContractAttachments && res.mainContractAttachments.length) {
              const isOrderNull = res.mainContractAttachments.every((file) => file.attachmentOrder == null);
              if(isOrderNull) {
                this.document.mainContractAttachments = [...this.document.mainContractAttachments.map((file, index) => ({
                  ...file,
                  attachmentOrder: index
                }))];
              } else {
                this.document.mainContractAttachments.sort((a, b) => {
                  return a.attachmentOrder - b.attachmentOrder;
                });
              }
            }
          } else {
            setTimeout(() => {
              if(res.mainContractAttachments && res.mainContractAttachments.length) {
                const isOrderNull = res.mainContractAttachments.every((file) => file.attachmentOrder == null);
                if(isOrderNull) {
                  this.document.mainContractAttachments = [...this.document.mainContractAttachments.map((file, index) => ({
                    ...file,
                    attachmentOrder: index
                  }))];
                } else {
                  this.document.mainContractAttachments.sort((a, b) => {
                    return a.attachmentOrder - b.attachmentOrder;
                  });
                }
              }
            }, 0);
          }
          this.createContractService.contractCodePositions.subscribe(ref => {
            if (ref) {
              this.listSignature = ref.map((item, idx) => {
                return { id: `contract-code-config-${idx}`, page: item.pageIndex, ...item };
              });
              if (res.mainContractAttachments && res.mainContractAttachments.length) {
                this.listSignatureTable = ref.map((item, idx) => {
                  const fileDoc = res.mainContractAttachments.find(
                    file => file.id ? file.id === item['fileId'] : file.fileName === decodeURI(item['fileId']));
                  if (fileDoc) {
                    this.addListSignHeadRows(fileDoc['fileName']);
                  }
                  return {
                    id: item.id ? item.id : `contract-code-config-${idx}`,//set id vao listTable
                    fileName: fileDoc && fileDoc['id'] ? fileDoc['fileName'] : '',
                    fontFamily: item.fontFamily ? item.fontFamily : 'Times-Roman',
                    fileId: item.fileId,
                    fontSize: item.fontSize,
                    fontStyle: item.fontStyle,
                    page: item.pageIndex
                  }
                });
              }
            }
          })
          if (!res.mainContractAttachments) {
            this.createContractService.contractCodePositions.subscribe(rs => {
              if (!this.listSignatureTable.length) {
                this.listSignatureTable = rs;
                this.listSignatureTable.forEach(item => {
                  this.addListSignHeadRows(item.fileName ? item.fileName : this.getDecodeUri(item.fileId));
                })
              }
            })
          }
          if (
            this.document.filePath &&
            !this.createContractService.selectedTemplate.getValue() &&
            !this.createContractService.pdfSrc.getValue()
          ) {
            this.viewDocumentLink(this.document.mainContractAttachments)
            this.viewDocumentUploadFileUpload(this.document.id, this.document.mainContractAttachments);
          } else if (this.createContractService.selectedTemplate.getValue()) {
            if (this.document.mainContractAttachments && this.document.mainContractAttachments.length ) {
              this.document.filePath = this.document.mainContractAttachments.find(item => !item.source || item.source == 'FORM').path;
              if(!this.createContractService.pdfSrc.getValue() || this.isUpdate ){
                if (this.createContractService.renderFileOnce.getValue() > 0) {
                  return
                }
                this.createContractService.renderFileOnce.next(1)
                if(this.document.mainContractAttachments.length > 1){
                  this.viewDocumentLink(this.document.mainContractAttachments)
                  this.viewDocumentUploadFileUpload(this.document.id, this.document.mainContractAttachments);
                } else {
                  const form: any = this.document.mainContractAttachments.find(item => !item.source || item.source == 'FORM')
                  form.src = this.createContractService.pdfSrcForm.getValue()
                  if(!form.source){
                    form.source = 'FORM'
                  }
                  if(!form.attachmentOrder){
                    form.attachmentOrder = 0
                  }
                  const pdfFile: any = {
                    size: form.fileSize,
                    name: form.fileName,
                    type: "application/pdf",
                    webkitRelativePath: "",
                    source: "FORM",
                    id: form.id
                  }
                  this.createContractService.fileUploadArray.next([pdfFile])
                  this.createContractService.fileUploadSrc.next([form.src])
                  this.listPdfSrc[form.path] = form.src
                  this.createContractService.mainContractAttactment.next([form]);
                }
              }
            }
          };
        }
      })
    );
    this.subscriptions.add(
      this.createContractService.isOnAutoNumber.asObservable().subscribe((res) => {
        if (res) {
          this.isOnAutoNumber = res;
          this.generalFormInfoComponent.isOnAutoNumber = true;
          this.currentTab = 0;
        }
      })
    );
    this.subscriptions.add(
      this.createContractService.configAutoNumber.asObservable().subscribe((res) => {
        if (res) {
          this.configAutoNumber = res;
        }
      })
    );
    this.subscriptions.add(
      this.createContractService.refreshContractCode.asObservable().subscribe((res) => {
        if (res) {
          this.refreshContractCode = res;
        } else {
          this.refreshContractCode = false;
        }
      })
    );
    this.subscriptions.add(
      this.createContractService.fileSizeUp.asObservable().subscribe((res) => {
        if (res) {
          this.fileSizeUp = res;
        } else {
          this.fileSizeUp = 0;
        }
      })
    );
    // this.subscriptions.add(this.createContractService.isRecordsPartySignValid.asObservable()
    //   .subscribe((data) => {
    // console.log("DATA: ", data);
    // if (!this.isFormChanging) {
    //   return;
    // }
    // data: is transferred from right panel.
    // Check is upload
    // if (this.panelDocumentComponent.valueSelect === FileUploadType) {
    //   // Document is upload file.
    //   this.uploadFileBefore(data);
    // } else if (this.panelDocumentComponent.valueSelect === FormActionType) {
    //   // Document is form
    //   // get data in form json form on display template component and submit to server.
    //   this.displayTemplateComponent.getDocumentFormJsonData(
    //     (documentJsonForm, panelData) => {
    //       // Upload attachment for document if has file
    //       this.panelDocumentComponent.uploadFile((attachments) => {
    //         panelData.newUploadContractAttachments = attachments;
    //         // submit document to server for saving.
    //         this.submitDocumentFormToServer(documentJsonForm, panelData);
    //       }, () => {
    //         // submit document to server for saving.
    //         this.submitDocumentFormToServer(documentJsonForm, panelData);
    //       });
    //     },
    //     this.toastr,
    //     data);
    // }
    // }));

    // this.subscriptions.add(this.panelDocumentComponent.isShowReferencePdf.asObservable().subscribe(data => {
    //     this.isShowReferencePdf = data;
    //   })
    // );

    // this.dataService.closeDialogOutOfContractQuantity.subscribe({
    //   next: (v) => {
    //     if (v === true) {
    //       this.router.navigate(['home-enterprise/search-my-created-document']);
    //     }
    //   }
    // });

    this.subscriptions.add(
      this.commonService.getCurrentLanguage().subscribe((lang) => {
        if (lang !== this.language) {
          location.reload();
        }
      })
    );

    this.subscriptions.add(this.createContractService.isShowPopupPdf.subscribe(ref => {
      this.isHide = ref;
    }));
    this.subscriptions.add(this.createContractService.createContractType.subscribe(ref => {
      if(this.createContractType == 0 && ref == 1){
        this.createContractService.isChangeFile.next(true);
      }
      this.createContractType = ref;
    }))

    this.subscriptions.add(
      this.createContractService.recordsPartySign.subscribe(ref => {
        this.isHaveUserSign = !!ref;
        if (this.createContractType === 0) {
          this.renderSignViewWhenDataChange();
          const dataCustomer = ref.filter(item => {
            return !item.isCreatedSide
          })
          this.listDataSign.customer = dataCustomer;
          this.listSign.forEach(sign => {
            if (!sign.name && sign.enterpriseId) {
              const enterprise = this.listDataSign.customer.find(item => item.enterpriseId === sign.enterpriseId && item.userId === sign.userId);
              if (enterprise) {
                Object.keys(enterprise).forEach(key => {
                  sign[key] = enterprise[key];
                });
              }
            } else {
              const enterprise = this.listDataSign.customer.find(item => item.customerId === sign.customerId);
              if (enterprise) {
                Object.keys(enterprise).forEach(key => {
                  sign[key] = enterprise[key];
                });
              }
            }
          })
        }
        else {
          const dataCustomer = ref.filter(item => {
            return !item.isCreatedSide
          })
          this.listDataSign.customer = dataCustomer;
          this.listSign.forEach(sign => {
            if (!sign.name && sign.enterpriseId) {
              const enterprise = this.listDataSign.customer.find(item => item.enterpriseId === sign.enterpriseId && item.userId === sign.userId);
              if (enterprise) {
                Object.keys(enterprise).forEach(key => {
                  sign[key] = enterprise[key];
                });
              }
            } else {
              const enterprise = this.listDataSign.customer.find(item => item.customerId === sign.customerId);
              if (enterprise) {
                Object.keys(enterprise).forEach(key => {
                  sign[key] = enterprise[key];
                });
              }
            }
          })
        }
      })
    );
    this.subscriptions.add(
      this.createContractService.recordsUserPerformSign.subscribe(ref => {
        if (this.createContractType === 0) {
          this.renderSignViewWhenDataChange();
          this.footNote.showSignatureFromData();
          this.listDataSign.enterprise = ref.filter(item => {
            const createSide = this.createContractService.recordsPartySign.getValue().find(item => item.isCreatedSide);
            item.enterpriseId = createSide && createSide.enterpriseId ? createSide.enterpriseId : null;
            return item.role === EnumRoleUser.USER_SIGN;
          })
          this.listApproverSign = ref.filter(item => {
            return item.role === EnumRoleUser.USER_APPROVER && item.isSignDigitalCertificate && item.signConfig.showImage;
          })
          this.listSign.forEach(sign => {
            if (!sign.name && sign.enterpriseId) {
              const approver = this.listApproverSign.find(item => item.enterpriseId === sign.enterpriseId && item.userId === sign.userId);
              if (approver) {
                Object.keys(approver).forEach(key => {
                  sign[key] = approver[key];
                });
              }
              const enterprise = this.listDataSign.enterprise.find(item => item.enterpriseId === sign.enterpriseId && item.userId === sign.userId);
              if (enterprise) {
                Object.keys(enterprise).forEach(key => {
                  sign[key] = enterprise[key];
                });
              }
            }
          })
        } else {
          this.listDataSign.enterprise = ref.filter(item => {
            const createSide = this.createContractService.recordsPartySign.getValue().find(item => item.isCreatedSide);
            item.enterpriseId = createSide && createSide.enterpriseId ? createSide.enterpriseId : null;
            return item.role === EnumRoleUser.USER_SIGN;
          })
          this.listApproverSign = ref.filter(item => {
            return item.role === EnumRoleUser.USER_APPROVER && item.isSignDigitalCertificate && item.signConfig.showImage;
          })
          this.listSign.forEach(sign => {
            if (!sign.name && sign.enterpriseId) {
              const approver = this.listApproverSign.find(item => item.enterpriseId === sign.enterpriseId && item.userId === sign.userId);
              if (approver) {
                Object.keys(approver).forEach(key => {
                  sign[key] = approver[key];
                });
              }
              const enterprise = this.listDataSign.enterprise.find(item => item.enterpriseId === sign.enterpriseId && item.userId === sign.userId);
              if (enterprise) {
                Object.keys(enterprise).forEach(key => {
                  sign[key] = enterprise[key];
                });
              }
            }
          })
          localStorage.setItem('listDataSignCustomer1',JSON.stringify(this.listDataSign.customer));
          localStorage.setItem('listDataSignEnterprise1',JSON.stringify(this.listDataSign.enterprise));
          localStorage.setItem('listDataApproverSign1',JSON.stringify(this.listApproverSign));
          localStorage.setItem('listDataSignApprove1',JSON.stringify(this.createContractService.recordsPartySign.getValue()));
          this.getListData();
        }
        // chuẩn bị ảnh ký mặc định cho khung chân ký (cả 2 nhánh createContractType)
        this.prepareDefaultSignImages();
      })
    );
    this.subscriptions.add(
      this.createContractService.signPositions.subscribe(ref => {
        if (ref) {
          this.listSign = ref;
        }
      })
    );

    this.subscriptions.add(
      this.createContractService.isSignatureConfiguration.subscribe(ref => {
        if (ref === false) {
          this.currentTab = 1;
          this.createContractService.isSignatureConfiguration.next(null);
        }
      })
    )
    this.subscriptions.add(
      this.createContractService.isDuplicateCode.subscribe(ref => {
        if (ref) {
          this.createContractService.codeIsDuplicate.next(true);
          this.currentTab = 0;
        }
        if (ref && this.createContractService.currentStep.getValue() === 2) {
          this.tabMode = 'info';
          this.createContractService.isInvalidInfo.next(false);
        }
      })
    );
    this.subscriptions.add(
      this.createContractService.isInvalidInfo.subscribe(ref => {
        if (ref) {
          this.currentTab = 0;
        }
        if (ref && this.createContractService.currentStep.getValue() === 2) {
          this.tabMode = 'info';
          this.createContractService.isInvalidInfo.next(false);
        }
      })
    );

    this.subscriptions.add(this.createContractService.signatureData.subscribe(ref => {
      if (ref) {
        this.signaturesFormPositions = ref;
        this.renderSignViewWhenDataChange();
      }
    }));

    this.subscriptions.add(this.createContractService.mainContractAttactment.subscribe(ref => {
      if (ref && ref.length) {
        this.document.mainContractAttachments = []
        ref.forEach((file, indexMainContractAttachment) => {
          this.document.mainContractAttachments.push({
            ...file,
            id: file.id ? file.id : '',
            fileSize: file.file && file.file.size ? file.file.size : file.fileSize,
            fileName: file.file && file.file.name ? file.file.name : file.fileName,
            path: file.path,
            active: true,
            src: (file.source && file.source == 'FORM') ? this.createContractService.pdfSrcForm.getValue() : file.src
          });
          if(this.document.id) {
            this.createContractService.fileUploadSrc.getValue().forEach((src, indexFileUploadSrc) => {
              if(indexMainContractAttachment === indexFileUploadSrc) {
                this.listPdfSrc[file.path] = (file.source && file.source == 'FORM') ? this.createContractService.pdfSrcForm.getValue() : src;
                if(file.source && file.source == 'FORM'){
                  const fileUploadSrc = this.createContractService.fileUploadSrc.getValue()
                  fileUploadSrc.splice(indexMainContractAttachment, 1, this.createContractService.pdfSrcForm.getValue())
                  this.createContractService.fileUploadSrc.next(fileUploadSrc)

                }
              }
            })
          } else {
            if (file.src) {
              this.listPdfSrc[file.path] =  (file.source && file.source == 'FORM') ? this.createContractService.pdfSrcForm.getValue() : file.src;
              if(file.source && file.source == 'FORM'){
                const fileUploadSrc = this.createContractService.fileUploadSrc.getValue()
                fileUploadSrc.splice(indexMainContractAttachment, 1, this.createContractService.pdfSrcForm.getValue())
                this.createContractService.fileUploadSrc.next(fileUploadSrc)

              }
            }
          }
        })
      }
    }));
    this.subscriptions.add(this.createContractService.fileUploadArray.subscribe(ref => {
      if (ref) {
        this.fileUploads = ref;
        if (!ref.length) {
          // this.document.filePath = null;
          this.createContractService.document.next(this.document);
        }
        setTimeout(() => {
          const tabs = document.getElementsByClassName('tab');
          if (tabs) {
            Array.from({ length: tabs.length }, (v, i) => i).forEach(index => {
              const tab = tabs.item(index) as HTMLElement;
              tab.style.width = 100 / this.fileUploads.length + '%';
            })
          }
        }, 100);
      }
    }))
    this.subscriptions.add(
      this.createContractService.maxSizeSystem.subscribe((res) => {
        if (res) {
          this.maxSizeSystem = res;
        } else {
          this.maxSizeSystem = 0;
        }
        // merge 21511
        if (!this.isBuyContract10Mb && this.isBuyContract1Mb) {
          this.maxSizeError = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.size1MB / 1024 / 1024)));
        } else {
          this.maxSizeError = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024)));
        }
        // merge 21511
      })
    );
    this.subscriptions.add(
      this.createContractService.maxPerMainFile.subscribe((res) => {
        if (res) {
          this.maxPerMainFile = res;
        } else {
          this.maxPerMainFile = 0;
        }
        if (!this.isBuyContract10Mb && this.isBuyContract1Mb) {
          this.maxSizeError = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.size1MB / 1024 / 1024)));
        } else {
          this.maxSizeError = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024)));
        }
      })
    );
    this.subscriptions.add(
      this.createContractService.biggerThan10MBFileSize.subscribe((res) => {
        if (res) {
          this.biggerThan10MBFileSize = res;
        }
      })
    );
  }

  disableInput() {
    $("#frm_add_or_edit :input").prop("disabled", true);
    $("#frm_add_or_edit :button").prop("disabled", true);
    $("#frm_add_or_edit :checkbox").prop("disabled", true);
    $("#btn-cancel").prop("disabled", false);
  }

  addEventsCheckFormChange() {
    // Check form change real-time when press printable key
    document
      .getElementById("pdfContainer")
      .addEventListener("keydown", (event) => {
        const keycode = event.keyCode;
        const isPrintableKey =
          (keycode > 47 && keycode < 58) || // number keys
          keycode === 8 ||
          keycode === 46 || // remove keys
          (keycode > 64 && keycode < 91) || // letter keys
          (keycode > 95 && keycode < 112) || // numpad keys
          (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
          (keycode > 218 && keycode < 223) || // [\]' (in order)
          keycode === 32; // space break
        if (isPrintableKey) {
          this.isFormChanging = true;
        }
      });

    // Check form change in document content
    document.getElementById("pdfContainer").addEventListener("change", (_) => {
      this.isFormChanging = true;
    });
  }

  async viewDocumentLink(files) {
    if (files && files.length) {

      const firstFile = files[0];
      if(firstFile.source == 'FORM'){
        this.pdfSrc = this.createContractService.pdfSrcForm.getValue()
        this.viewDocumentUpload(firstFile);
      } else {
        this.pdfSrc = await this.viewDocumentUpload(firstFile);
      }
      // this.viewDocumentsUpload(this.document.id);
      // load các file còn lại
      let fileUpload = []
      firstFile['size'] = firstFile.fileSize
      fileUpload.push(firstFile)

      this.document.mainContractAttachments.forEach(file => {
        if (file.path != firstFile.path) {
          file['size'] = file.fileSize
          this.viewDocumentUpload(file);
          fileUpload.push(file)
        }
      });

      if (fileUpload.length > 0) {
        this.createContractService.fileUploadArray.next(fileUpload);
        this.createContractService.mainContractAttactment.next(fileUpload);
      }
    }
  }

  /**
   * every things ok now.
   */
  ngAfterViewInit() {
    // ẩn nút toggle từ menu trái
    document.getElementById("sidebarToggle").style.display = "none";



    console.log(this.listData);

  }

  /**
   * Destroy the component.
   */
  ngOnDestroy() {
    if (this.EventWarningContractSubscription) {
      this.EventWarningContractSubscription.unsubscribe();
    }
    this.apiService.removeUrlToHandlingErrorRestApis();
    this.notificationService.unsubscribeErrorService();
    this.subscriptions.unsubscribe();
    // this.createContractService.pdfSrc.next(null);
    // this.createContractService.signPositions.next([]);
    // this.panelSuccessSubscription.unsubscribe();
    // this.panelDocumentComponent.formChangesSubscription.unsubscribe();
    // this.panelDocumentComponent.onChangePanelData.unsubscribe();
    // this.onChangeTemplateSubscription.unsubscribe();
    document.removeEventListener('mouseup', () => { });
    if(this.intervalChat){
      clearInterval(this.intervalChat)
    }
  }

  /**
   * Submit create document
   */
  public onClickBtnSave() {
    // this.documentService.submit.next();
    // check validate right panel
    // after success of validating => signal event to this class for request upload to server for saving.
    this.panelDocumentComponent.submitValidate();
  }

  /**
   *  Back to page search
   */
  onClickBtnCancel() {
    let searchParams = {};
    if (this.pageSize > 0) {
      searchParams = {
        page: this.page,
        pageSize: this.pageSize,
        routeLink: this.routeLink,
        enterprise: this.enterpriseSearch,
        documentType: this.documentTypeSearch,
        nameOrCode: this.nameOrCode,
        customerName: this.customerName,
        status: this.status,
        serviceType: this.serviceType,
        taxCode: this.taxCode,
        createdUser: this.createdUser,
        createdTimeFrom: this.createdTimeFrom,
        createdTimeTo: this.createdTimeTo,
        finishDateFrom: this.finishDateFrom,
        finishDateTo: this.finishDateTo,
        pageView: this.pageView,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
      };
    }

    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: "350px",
        data: this.message.getMessage("messages.confirm_change_data"),
      });
      dialogRe.afterClosed().subscribe((rs) => {
        if (rs) {
          this.show = false;
          this.backNavigate(searchParams);
        }
        dialogRe.close();
      });
    } else {
      this.backNavigate(searchParams);
    }
  }

  /**
   * Set route when back navigate
   */
  backNavigate(searchParams) {
    this._location.back();
    // if (this.flagCopy && this.pageView) {
    //   this.router.navigate(['/home-enterprise/view-document/' + this.documentId], {
    //     queryParams: searchParams
    //   });
    // } else {
    //   const url = searchParams && searchParams.routeLink ? searchParams.routeLink : '/home-enterprise/search-my-created-document/';
    //   this.router.navigate([url], {
    //     queryParams: searchParams
    //   });
    // }
  }

  /**
   * Get document by id.
   * @param id the document id.
   */
  private getDocumentById(id: string) {
    if (id) {
      this.documentService.getDocumentById(id).subscribe((rs) => {
        if (!rs.data || !rs.data.contractDTO) {
          return 0;
        }
        this.document = rs.data.contractDTO;
        this.document.expiredDate =
          typeof this.document.expiredDate !== "undefined"
            ? new Date(rs.data.contractDTO.expiredDate)
            : null;
        // share file upload path to right panel.
        this.panelDocumentComponent.originalFileUpload = this.document.filePath;

        if (this.document.typeId === EnumContractType.FORM) {
          if (rs.data.contractDTO && rs.data.contractDTO.jsonData) {
            this.documentData = JSON.parse(rs.data.contractDTO.jsonData);
          }
        }

        // this.viewDocumentUpload(this.document.id);
        if (this.typeCopy && this.typeCopy !== 0) {
          this.document.newUploadContractAttachments = [];
          if (this.flagCopy) {
            this.panelDocumentComponent.bindDataToPanel(
              this.document,
              null,
              this.typeCopy,
              this.flagCopy
            );
          } else {
            this.panelDocumentComponent.bindDataToPanel(
              this.document,
              null,
              this.typeCopy
            );
          }
        } else {
          if (this.flagCopy) {
            this.panelDocumentComponent.bindDataToPanel(
              this.document,
              null,
              null,
              this.flagCopy
            );
          } else {
            this.panelDocumentComponent.bindDataToPanel(this.document, null);
          }
        }
        this.panelDocumentComponent.selectedDocumentType =
          rs.data.documentTypeEnterpriseDTO;
        this.panelDocumentComponent.onChangeAutoCompletedDocumentType([
          this.panelDocumentComponent.selectedDocumentType,
        ]);
        this.isShowMatRaised =
          this.document.typeId === 1
            ? "local"
            : this.document.typeId === 0
              ? "server"
              : "";
      });
    }
  }

  viewDocumentUploadFileUpload(id: string, mainContractAttachments: any[]) {
    return this.commonService.getViewPdfsForDocument(id).subscribe(async (res) => {
      // console.log(res.data);
      // console.log(this.document.mainContractAttachments);
      if (!res.data) {
        return;
      }
      const newData = [];
      this.document.mainContractAttachments.forEach((mainContractAttachment) => {
        res.data.forEach((data) => {
          if(mainContractAttachment.id === data.fileId) {
            newData.push(data);
          }
        })
      });
      res.data = [...newData];
      // console.log(res.data);
      const fileUpload = [];
      const fileSrc = [];
      for await (const [index, item] of res.data.entries()) {
        const attachment = mainContractAttachments.find(att => item.fileId === att.id);
        const file = new File([new Uint8Array(item.bytes)], attachment ? attachment.fileName : `file_${index}.pdf`, { type: 'application/pdf' }) as any;
        file.id = item.fileId;
        if(this.createContractService.createContractType.getValue() == 0){
          file.source = attachment.source
        }
        fileUpload.push(file);
        // merge 21511
        let infoFile = this.createContractService.infoFile.getValue() || [];
        fileUpload.forEach(file => {
            const reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onloadend = () => {
              let count = 0;
              let dataLoad:any = reader.result;
              let match = dataLoad.match(/Type\/Pages\/Count (\d+)/);
              if (match) {
                count = match[1];
              } else {
                count = dataLoad.match(/\/Type[\s]*\/Page[^s]/g) ? dataLoad.match(/\/Type[\s]*\/Page[^s]/g).length : 0;
              }
              if(file.source !== 'FORM'){
                if(count !== 0){
                  infoFile.push({
                  id: file.id,
                  numberPage: Number(count)
                })
                this.createContractService.infoFile.next(infoFile);
                } else {
                  const formData = new FormData;
                  formData.append('file', file)
                  this.blockUI.start()
                  this.documentService.getInfoFile(formData).pipe(finalize(()=>this.blockUI.stop())).subscribe(res => {
                    if(res.success){
                      infoFile.push({
                        id: file.id,
                        numberPage: Number(res.data.numberPage) || 0
                      })
                      this.createContractService.infoFile.next(infoFile);
                    } else {
                      this.toastr.error(res.message);
                    }
                  })
                }
              } else {
                infoFile.push(this.createContractService.infoFileTemplate.getValue())
              }
              this.createContractService.infoFile.next(infoFile);
            }
        });
        // merge 21511
        const base64 = await this.checkContentTypeThenAddFile(file);
        if(file.source == 'FORM'){
          fileSrc.push(this.createContractService.pdfSrcForm.getValue());
        } else {
          fileSrc.push(base64);
        }
      }
      if (fileUpload.length > 0) {
        this.createContractService.fileUploadArray.next(fileUpload);
        this.createContractService.fileUploadSrc.next(fileSrc);
        this.createContractService.pdfSrc.next(fileSrc[0]);
      }
    });
  }

  async viewDocumentUpload(file) {
    const data: ViewDocumentReferenceDto = {
      pdfFilePath: file.path,
      mainContractId: this.document.id,
      referenceContractId: "",
    };
    const queryString = Object.entries(data)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    // const res = await this.commonService.getViewPdfForDocumentByFilePath(data).toPromise();
    let pdfSrc;
    if (!file.src) {
      if (!this.env.pdfViewFullDownload && file.fileSize && file.fileSize > 10485760) {
        pdfSrc = `${this.BASE_URL}?${queryString}`;
        this.listPdfSrc[file.path] = file.source == 'FORM' ? this.createContractService.pdfSrcForm.getValue() : pdfSrc;
      } else {
        const res = await this.commonService.getViewPdfForDocumentByFilePath(data).toPromise();
        pdfSrc = await this.showPdf(res, file);
      }
    }
    return file.source == 'FORM' ? this.createContractService.pdfSrcForm.getValue() : pdfSrc;
  }

  /**
   * Process for uploading file case.
   * @param data the document data with with file path upload success.
   */
  private uploadFileBefore(data) {
    // check not exist file upload.
    if (!this.panelDocumentComponent.originalFileUpload) {
      if (!this.panelDocumentComponent.fileUpload) {
        if (
          !this.toastr.findDuplicate(
            this.message.getMessage("messages.no_file_upload"),
            true,
            true
          )
        ) {
          this.toastr.error(this.message.getMessage("messages.no_file_upload"));
        }
        return;
      }
    }

    if (this.panelDocumentComponent.fileUpload) {
      // upload file to server success and then submit document json with data file generated path.
      this.commonService
        .uploadFileDocument(this.panelDocumentComponent.fileUpload)
        .subscribe((rs) => {
          data.filePath = rs.data.path;
          data.fileNameUpdate = rs.data.fileName;
          data.fileSizeUpdate = rs.data.fileSize;
          this.processUploadAttachment(data);
        });
    } else {
      this.processUploadAttachment(data);
    }
  }

  /**
   * Process upload Attachment when has attach file from local
   * @param data Obj document
   */
  processUploadAttachment(data) {
    this.panelDocumentComponent.uploadFile(
      (attachments) => {
        data.newUploadContractAttachments = attachments;
        this.updateDocumentByUploadFileToServer(data);
      },
      () => {
        this.updateDocumentByUploadFileToServer(data);
      }
    );
  }

  /**
   * Update document to server.
   * @param data json data update to server.
   */
  private updateDocumentByUploadFileToServer(data) {
    const assignData: any = data;
    this.document = assignData;

    let navigatorParam = {};

    // get navigator params.
    if (this.pageSize > 0) {
      navigatorParam = {
        page: this.page,
        pageSize: this.pageSize,
        currentPage: this.currentPage,
        enterprise: this.enterpriseSearch,
        documentType: this.documentTypeSearch,
        nameOrCode: this.nameOrCode,
        customerName: this.customerName,
        status: this.status,
        serviceType: this.serviceType,
        taxCode: this.taxCode,
        createdUser: this.createdUser,
        createdTimeFrom: this.createdTimeFrom,
        createdTimeTo: this.createdTimeTo,
        finishDateFrom: this.finishDateFrom,
        finishDateTo: this.finishDateTo,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
      };
    }

    // if (this.flagCopy) {
    //   this.document.id = null;
    //   this.document.finishDate = null;
    // }

    if (this.flagCopy || !this.document.id) {
      // create.
      // Get customer contacter's email and phone
      this.document.email = this.panelDocumentComponent.customer.customerEmail;
      this.document.phone = this.panelDocumentComponent.customer.customerPhone;

      this.documentService
        .addDocument(
          this.document,
          this.documentCodeDuplicateHanlder.bind(this)
        )
        .subscribe((rs) => {
          if (rs && rs.success) {
            const updateNameSie = {
              fileName: this.document.fileNameUpdate,
              fileSize: this.document.fileSizeUpdate,
              contractId: rs.data,
            };
            // this.documentService.updateFileNameAndFileSize(updateNameSie).subscribe();
            this.show = false;
            // Show success message.
            this.toastr.success(
              this.message.getMessage("messages.add_success")
            );

            // navigate to list screen.
            this.router.navigate(
              ["/home-enterprise/search-my-created-document/"],
              {
                // queryParams: navigatorParam
                queryParams: {},
              }
            );
          } else if (rs.code == ErrorCode.MaxSizeError) {
            this.maxSize = rs.data > 0 ? rs.data : 10 * 1024 * 1024;
          }
        });
    } else {
      // update.
      // Get customer contacter's email and phone
      this.document.email = this.panelDocumentComponent.customer.customerEmail;
      this.document.phone = this.panelDocumentComponent.customer.customerPhone;
      this.documentService.updateDocumentUpdload(
        this.document,
        () => {
          this.show = false;
          // Show success message.
          this.toastr.success(
            this.message.getMessage("messages.update_success")
          );

          // navigate to list screen.
          this.router.navigate(
            ["/home-enterprise/search-my-created-document/"],
            {
              queryParams: navigatorParam,
            }
          );
        },
        () => {
          // reload screen if deprecate version.
          // this.getDocumentById(this.document.id);
        },
        this.documentCodeDuplicateHanlder.bind(this)
      );
    }
  }

  /**
   * Check code document duplicate
   * @param rs data after request api
   */
  private documentCodeDuplicateHanlder(rs: any) {
    if (!rs.success) {
      if (String(rs.code) === "0x001703") {
        this.panelDocumentComponent.documentCodeDuplicateHanlder(rs);
      } else {
        this.notificationService.notify(
          Utils.toErrorMessage(
            rs,
            this.message.getMessage("messages.error_message")
          )
        );
      }
    }
  }

  /**
   * submit document to server for saving.
   * @param documentJsonForm the json from of left panel.
   * @param documentReferences the reference document object of right panel.
   */
  private submitDocumentFormToServer(documentJsonForm, documentReferences) {
    // build data submision to server.
    const savedDocumentData = {
      ...documentReferences,
      id: documentReferences.id ? documentReferences.id : "",
      parentId: documentReferences.parentId ? documentReferences.parentId : "",
      code: documentReferences.code,
      name: documentReferences.name,
      customerId: documentReferences.customerId,
      version: documentReferences.version,
      documentTypeEnterpriseId: documentReferences.documentTypeEnterpriseId,
      jsonData: JSON.stringify(documentJsonForm),
      enterpriseId: this.enterprise.id,
      isSkipVersion: false,
      expiredDate: documentReferences.expiredDate
        ? documentReferences.expiredDate
        : "",
    };

    // Get email of customer's contacter
    savedDocumentData.email = documentReferences.customerEmail || "";

    // Get phone of customer's contacter
    savedDocumentData.phone = documentReferences.customerPhone || "";

    // For copy case - build data submision to server.
    const savedCopyDocumentData = {
      ...documentReferences,
      id: "",
      parentId: documentReferences.parentId || "",
      code: documentReferences.code,
      name: documentReferences.name,
      customerId: documentReferences.customerId,
      version: documentReferences.version,
      documentTypeEnterpriseId: documentReferences.documentTypeEnterpriseId,
      jsonData: JSON.stringify(documentJsonForm),
      enterpriseId: this.enterprise.id,
      isSkipVersion: false,
      expiredDate: documentReferences.expiredDate || "",
      cancelTime: null,
      cancelReason: null,
      cancelUserFullName: null,
    };

    // Get email of customer's contacter
    savedCopyDocumentData.email = documentReferences.customerEmail || "";

    // Get phone of customer's contacter
    savedCopyDocumentData.phone = documentReferences.customerPhone || "";

    let navigatorParam = {};

    // get navigator params.
    if (this.pageSize > 0) {
      navigatorParam = {
        page: this.page,
        pageSize: this.pageSize,
        currentPage: this.currentPage,
        enterprise: this.enterpriseSearch,
        documentType: this.documentTypeSearch,
        nameOrCode: this.nameOrCode,
        customerName: this.customerName,
        status: this.status,
        serviceType: this.serviceType,
        taxCode: this.taxCode,
        createdUser: this.createdUser,
        createdTimeFrom: this.createdTimeFrom,
        createdTimeTo: this.createdTimeTo,
        finishDateFrom: this.finishDateFrom,
        finishDateTo: this.finishDateTo,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
      };
    }
    // for copy case
    if (this.flagCopy) {
      savedDocumentData.id = null;
      savedCopyDocumentData.finishDate = null;
      savedCopyDocumentData.submitedToA = null;
      savedCopyDocumentData.submitedToB = null;
      savedCopyDocumentData.id = null;
    }

    // call to server for saving data.
    if (documentReferences.id && !this.flagCopy) {
      // update
      // debugger
      savedDocumentData.signatureResponses = this.createContractService.signatureResponse;
      this.documentService
        .updateDocumentByTemplate(
          savedDocumentData,
          this.documentCodeDuplicateHanlder.bind(this)
        )
        .subscribe((rs) => {
          this.onSubmitSuccess(rs, "messages.update_success", navigatorParam);
        });
    } else if (!savedCopyDocumentData.id && this.flagCopy) {
      // Check if template is locked or not
      this.documentService
        .checkTemplate(documentReferences.id)
        .subscribe((rs) => {
          // For copy case.
          // this.createDocumentByTemplate(savedCopyDocumentData, navigatorParam);
          this.createDocumentByTemplate(savedCopyDocumentData, {});
        });
    } else {
      // create.
      // this.createDocumentByTemplate(savedDocumentData, navigatorParam);
      this.createDocumentByTemplate(savedDocumentData, {});
    }
  }

  /**
   * Create document with template
   * @param savedDocumentData Obj document request
   * @param navigatorParam param of navigate
   */
  createDocumentByTemplate(savedDocumentData: any, navigatorParam: any) {
    this.documentService
      .createDocumentByTemplate(
        savedDocumentData,
        this.documentCodeDuplicateHanlder.bind(this)
      )
      .subscribe((rs) => {
        this.onSubmitSuccess(rs, "messages.add_success", navigatorParam);
      });
  }

  /**
   * Show message and navigate to search page
   * @param messageCode message code.
   *  @param navigatorParam navigator param.
   */
  private onSubmitSuccess(rs: any, messageCode: string, navigatorParam: any) {
    if (rs.success) {
      // Display success of creating.
      this.toastr.success(this.message.getMessage(messageCode));

      this.router.navigate(["/home-enterprise/search-my-created-document/"], {
        queryParams: navigatorParam,
      });

      // Set flag to false to deactive change detection
      this.show = false;
    }
  }

  /**
   * init form data.
   * @param date current date.
   */
  private initFormData() {
    // Get current date
    const today = new Date();
    const dd = today.getDate();
    const mm = today.getMonth() + 1; // January is 0!
    const yyyy = today.getFullYear();
    let currentDay = dd.toString();
    let currentMonth = mm.toString();

    // Add zero if day or month < 10
    if (dd < 10) {
      currentDay = "0" + dd;
    }

    if (mm < 10) {
      currentMonth = "0" + mm;
    }

    this.defaultDocumentData = {
      currentDay,
      currentMonth,
      currentYear: yyyy.toString(),
      currentShortYear: yyyy.toString().slice(2, 4),
      currentDate: currentDay + "/" + currentMonth + "/" + yyyy.toString(),
    };
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    const tenantId = localStorage.getItem("tenantId");
    if (
      this.panelDocumentComponent.isFormChanging &&
      this.show &&
      tenantId != null
    ) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: "350px",
        data: this.message.getMessage("messages.confirm_change_data"),
      });
      return dialogRe.afterClosed().pipe(
        map((result) => {
          if (result) {
            return true;
          } else {
            return false;
          }
        }),
        first()
      );
    } else {
      return true;
    }
  }

  /**
   * Load addresses
   */
  private loadAddresses() {
    /**
     * Get cities list from local storage
     */
    this.cities = JSON.parse(localStorage.getItem("cities"));
    /**
     * Get districts list from local storage
     */
    this.districts = JSON.parse(localStorage.getItem("districts"));
    /**
     * Get wards list from local storage
     */
    this.wards = JSON.parse(localStorage.getItem("wards"));
  }

  /**
   * Get data and bind to document template
   * @param data: any
   */
  private displayDataToForm(data) {
    const responsedData = data;

    if (
      responsedData.addresses == null ||
      responsedData.addresses.length === 0
    ) {
      responsedData.addresses = [this.defaultAddress];
    }

    // Load enterprise data
    this.enterprise = { ...responsedData };
    // Attachments
    this.enterprise.files = [];

    // Convert issuedDate from string to date
    if (this.enterprise.issuedDate != null) {
      this.enterprise.issuedDate = new Date(data.issuedDate);
    }

    // Convert representativeIssuedDate from string to date
    if (this.enterprise.representativeIssuedDate != null) {
      this.enterprise.representativeIssuedDate = new Date(
        data.representativeIssuedDate
      );
    }

    // Convert birthday from string to date
    if (this.enterprise.birthday != null) {
      this.enterprise.birthday = new Date(data.birthday);
    }
    // Get enterprise city
    const enterpriseCity = this.cities.find(
      (x) => x.id === this.enterprise.addresses[0].cityId
    )
      ? this.cities.find((x) => x.id === this.enterprise.addresses[0].cityId)
        .name
      : "";

    // Get enterprise district
    const enterpriseDistrict = this.districts.find(
      (x) => x.id === this.enterprise.addresses[0].districtId
    )
      ? this.districts.find(
        (x) => x.id === this.enterprise.addresses[0].districtId
      ).name
      : "";

    // Get enterprise district
    const enterpriseWard = this.wards.find(
      (x) => x.id === this.enterprise.addresses[0].wardId
    )
      ? this.wards.find((x) => x.id === this.enterprise.addresses[0].wardId)
        .name
      : "";

    // Load enterprise data to document data
    this.defaultDocumentData = {
      ...this.defaultDocumentData,
      supplierName: this.enterprise.name, // Enterprise's name
      // supplierAbbreviation: this.enterprise.abbreviation,
      supplierTaxCode: this.enterprise.taxCode,
      supplierPhone: this.enterprise.phone,
      supplierSupportPhone: this.enterprise.phone,
      supplierFax: this.enterprise.fax,
      supplierEmail: this.enterprise.email,
      supplierCertificateNo: this.enterprise.certificateNo,
      supplierIssuedDate: this.enterprise.issuedDate
        ? this.commonService.formatDate(new Date(this.enterprise.issuedDate))
        : "",
      supplierIssuedAt: this.enterprise.issuedAt,
      supplierExpiryDate: this.enterprise.expiryDate
        ? this.commonService.formatDate(new Date(this.enterprise.expiryDate))
        : "",
      supplierAccountNumber: this.enterprise.accountNumber,
      supplierBankName: this.enterprise.bankName,
      supplierBankBranch: this.enterprise.bankBranch,
      supplierRepresentative: this.enterprise.representative,
      supplierPosition: this.enterprise.position,
      supplierRepresentativeCertificateNo:
        this.enterprise.representativeCertificateNo,
      supplierRepresentativeIssuedDate: this.enterprise.representativeIssuedDate
        ? this.commonService.formatDate(
          new Date(this.enterprise.representativeIssuedDate)
        )
        : "",
      supplierRepresentativeIssuedDay: this.enterprise.representativeIssuedDate
        ? new Date(this.enterprise.representativeIssuedDate).getDate()
        : "",
      supplierRepresentativeIssuedMonth: this.enterprise
        .representativeIssuedDate
        ? new Date(this.enterprise.representativeIssuedDate).getMonth() + 1
        : "",
      supplierRepresentativeIssuedYear: this.enterprise.representativeIssuedDate
        ? new Date(this.enterprise.representativeIssuedDate)
          .getFullYear()
          .toString()
          .slice(-2)
        : "",
      supplierRepresentativeIssuedOn: this.enterprise.representativeIssuedOn,
      supplierBirthday: this.enterprise.birthday
        ? this.commonService.formatDate(new Date(this.enterprise.birthday))
        : "",
      supplierSex: this.enterprise.sex,
      supplierAddress: `${this.enterprise.addresses[0].address
        ? this.enterprise.addresses[0].address + ", "
        : ""
        }${enterpriseWard ? enterpriseWard + ", " : ""}${enterpriseDistrict ? enterpriseDistrict + ", " : ""
        }${enterpriseCity ? enterpriseCity : ""}`,
      supplierShortAddress: `${this.enterprise.addresses[0].address
        ? this.enterprise.addresses[0].address
        : ""
        }`,
      supplierWardName: enterpriseWard,
      supplierDistrictName: enterpriseDistrict,
      supplierCityName: enterpriseCity,
    };
    this.defaultDocumentData.supplierBank = `${this.defaultDocumentData.supplierBankName
      ? this.defaultDocumentData.supplierBankName + ", "
      : ""
      }${this.defaultDocumentData.supplierBankBranch
        ? this.defaultDocumentData.supplierBankBranch
        : ""
      }`;
    this.defaultDocumentData.supplierAccount = `${this.defaultDocumentData.supplierAccountNumber
      ? this.defaultDocumentData.supplierAccountNumber + ", "
      : ""
      } ${this.defaultDocumentData.supplierBankName
        ? this.defaultDocumentData.supplierBankName + ", "
        : ""
      } ${this.defaultDocumentData.supplierBankBranch
        ? this.defaultDocumentData.supplierBankBranch
        : ""
      }`;
  }

  /**
   * Load breadcrumb
   */
  loadBreadcrumb() {
    if (this.flagCopy) {
      this.breadcrumbsService.store([
        {
          label: "breadcrumbs.home",
          url: "analysis-report",
          params: [],
          highlight: false,
        },
        {
          label: "breadcrumbs.my_documents",
          url: "",
          params: [],
          highlight: false,
        },
        {
          label: "breadcrumbs.document_search_mine",
          url: "search-my-created-document",
          params: [],
          highlight: false,
        },
        {
          label: "breadcrumbs.document_create",
          url: "add-document",
          params: [],
          highlight: true,
        },
      ]);
    } else {
      this.breadcrumbsService.store([
        {
          label: "breadcrumbs.home",
          url: "analysis-report",
          params: [],
          highlight: false,
        },
        {
          label: "breadcrumbs.my_documents",
          url: "",
          params: [],
          highlight: false,
        },
        {
          label: "breadcrumbs.document_search_mine",
          url: "search-my-created-document",
          params: [],
          highlight: false,
        },
        // ,
        // {
        //   label: 'breadcrumbs.document_update',
        //   url: 'update-document/:id',
        //   params: [this.document.id],
        //   highlight: true
        // },
      ]);
    }
  }

  onPanelChange(event) {
    this.isFormChanging = event;
  }

  /**
   * Selected document upload file
   */
  async onSelectedUpload(e) {
    // if (this.panelDocumentComponent.valueSelect !== FileUploadType) {
    //   // this.panelDocumentComponent.valueSelect = FileUploadType;
    //   this.panelDocumentComponent.pdfSrc = '';
    //   this.resetInput();
    // }

    // this.panelDocumentComponent.getFile(e);
    await this.getFile(e);
    this.onClickSetColor("local");
    this.reset();
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  };

  async showPdf(blob: any, pdfFilePath: any) {
    const file = this.blobToFile(blob, 'application/pdf');
    const pdfSrc = await this.commonService.readFileAsync(file);
    this.listPdfSrc[pdfFilePath.path] = pdfFilePath.source == 'FORM' ? this.createContractService.pdfSrcForm.getValue() : pdfSrc;
    return pdfFilePath.source == 'FORM' ? this.createContractService.pdfSrcForm.getValue() : pdfSrc;
  }

  /**
   * Selected document form
   */
  onSelectedForm() {
    //
    const dialogRef = this.dialog.open(SelectDocumentTypeComponent, {
      width: "30%",
      disableClose: true,
      data: { mode: null }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result !== "undefined") {
        const documentType =
          this.createContractService.createContractType.getValue();
        if (
          this.createContractService.fieldData &&
          this.checkHaveDataForm(this.createContractService.fieldData)
        ) {
          const dialogConfirm = this.dialog.open(WarningComponent, {
            width: "40%",
            data: this.message.getMessage("messages.change_template_contract"),
          });
          dialogConfirm.afterClosed().subscribe((ref) => {
            if (ref) {
              //chon sang mau khac
              this.createContractService.isChangeTypeDocAndTemp.next(true);
              this.createContractService.recordsUserPerformSign.next([])
              this.isFormChanging = true;
              // this.onClickSetColor('server');
              this.reset();
              this.createContractService.isBack.next(true);
              this.createContractService.backView.next(true);
              this.createContractService.fieldData = null;
              this.createContractService.fileExport = null;
              this.createContractService.documentFileTemplate.next(null);
              this.createContractService.pdfSrc.next(null);
              this.createContractService.signatureData.next(null);
              this.document.templateFilePath = null;
              this.document.mainContractAttachments = null
              this.createContractService.document.next(this.document);
              this.createContractService.signPositions.next([]);
              this.createContractService.contractCodePositions.next([]);
              this.createContractService.listSignatureTable.next([]);
              this.createContractService.fileUploadArray.next([]);
              this.createContractService.fileUploadSrc.next([]);
              this.createContractService.refreshContractCode.next(false);
              this.getServiceTypeById(this.createContractService.selectedTemplate.getValue().serviceType, result.data.documentTypeEnterprise.serviceType).subscribe(result => {
                let oldServiceType = result[0].data;
                let currentServiceType  = result[1].data;
                if (this.createContractService.serviceTypes) {
                  let currentConfigAutoNumber = this.createContractService.serviceTypes.find(item => item.id === currentServiceType.id);
                  if(currentConfigAutoNumber.isOnAutoNumber) {
                    this.createContractService.configAutoNumber.next(this.commonService.convertConfigAutoNumber(currentConfigAutoNumber.configAutoNumber));
                  }
                }
                if(currentServiceType.isOnAutoNumber) {
                  this.createContractService.isOnAutoNumber.next(currentServiceType.isOnAutoNumber);
                }
                if(oldServiceType.isOnAutoNumber || currentServiceType.isOnAutoNumber) {
                  this.createContractService.document.next({
                    ...this.createContractService.document.getValue(),
                    code: this.createContractService.document.getValue().backUpCode || this.createContractService.document.getValue().code
                  });
                }
              });
              this.createContractService.selectedTemplate.next(
                result.data.documentTypeEnterprise
              );
              this.createContractService.mainContractAttactment.next(this.document.mainContractAttachments)
            }
          });
          return;
        } else if (documentType === FormActionType && !this.checkHaveDataForm(this.createContractService.fieldData)) {
          this.createContractService.isChangeTypeDocAndTemp.next(true);
          this.createContractService.recordsUserPerformSign.next([])
          this.isFormChanging = true;
          // this.onClickSetColor('server');
          this.reset();
          this.createContractService.isBack.next(true);
          this.createContractService.backView.next(true);
          this.createContractService.selectedTemplate.next(
            result.data.documentTypeEnterprise
          );
          this.createContractService.fieldData = null;
          this.createContractService.fileExport = null;
          this.createContractService.documentFileTemplate.next(null);
          this.createContractService.pdfSrc.next(null);
          this.createContractService.signatureData.next(null);
          this.document.templateFilePath = null;
          this.document.mainContractAttachments = null
          this.createContractService.document.next(this.document);
          this.createContractService.signPositions.next([]);
          this.createContractService.contractCodePositions.next([]);
          this.createContractService.listSignatureTable.next([]);
          this.createContractService.fileUploadArray.next([]);
          this.createContractService.fileUploadSrc.next([]);
          this.createContractService.mainContractAttactment.next(this.document.mainContractAttachments)
          this.createContractService.selectedTemplate.next(result.data.documentTypeEnterprise);
          return;
        }
        if (documentType === FileUploadType) {
          const dialogConfirm = this.dialog.open(WarningComponent, {
            width: '40%',
            data: this.message.getMessage('messages.confirm_change_type_document_to_template')
          });
          dialogConfirm.afterClosed().subscribe(ref => {
            if (ref) {
              //chon tu file sang mau khac
              this.createContractService.isChangeTypeDocAndTemp.next(true);
              //neu cap nhat va da an refresh khi doi sang mau phai hien ma ban dau, man 1 man 3 hien lai nut refresh
              if(this.isUpdate && this.createContractService.refreshContractCode && this.createContractService.refreshContractCode.getValue()) {
                this.createContractService.refreshContractCode.next(false);
                this.createContractService.document.next({
                  ...this.createContractService.document.getValue(),
                  code: this.createContractService.document.getValue().backUpCode || this.createContractService.document.getValue().code
                });
              }
              this.isFormChanging = true;
              // this.onClickSetColor('server');
              this.reset();
              this.createContractService.backView.next(true);
              this.createContractService.selectedTemplate.next(result.data.documentTypeEnterprise);
              this.createContractService.fieldData = null;
              this.createContractService.fileExport = null;
              this.createContractService.documentFileTemplate.next(null);
              this.createContractService.pdfSrc.next(null);
              this.createContractService.signatureData.next(null);
              this.document.templateFilePath = null;
              this.document.mainContractAttachments = null
              this.createContractService.document.next(this.document);
              this.createContractService.createContractType.next(FormActionType);
              this.createContractService.signPositions.next([]);
              this.createContractService.contractCodePositions.next([]);
              this.createContractService.listSignatureTable.next([]);
              this.createContractService.fileUploadArray.next([]);
              this.createContractService.fileUploadSrc.next([]);
              this.createContractService.mainContractAttactment.next( this.document.mainContractAttachments)
            }
          });
          return;
        }
        this.isFormChanging = true;
        // this.onClickSetColor('server');
        this.reset();
        this.createContractService.isBack.next(true);
        this.createContractService.backView.next(true);
        this.createContractService.selectedTemplate.next(
          result.data.documentTypeEnterprise
        );
        this.createContractService.fieldData = null;
        this.createContractService.fileExport = null;
        this.createContractService.documentFileTemplate.next(null);
        this.createContractService.signatureData.next(null);
        this.createContractService.pdfSrc.next(null);
        this.document.templateFilePath = null;
        this.createContractService.document.next(this.document);
        this.createContractService.signPositions.next([]);
        this.createContractService.contractCodePositions.next([]);
        this.createContractService.listSignatureTable.next([]);
        this.createContractService.fileUploadArray.next([]);
        this.createContractService.fileUploadSrc.next([]);
        this.document.mainContractAttachments = null
        this.createContractService.mainContractAttactment.next(this.document.mainContractAttachments)
      }
    });
  }

  /**
   *  Refresh input upload file
   */
  private reset() {
    this.inputUploadFile.nativeElement.value = "";
  }

  /**
   * Reset input when selected type document
   */
  resetInput() {
    // this.panelDocumentComponent.document.parentId = null;
    // this.panelDocumentComponent.selectedDocumentTypeParent = null;
    // this.panelDocumentComponent.document.serviceType = null;
    this.panelDocumentComponent.selectedDocumentType = null;
    this.panelDocumentComponent.document.documentTypeEnterpriseId = null;
  }

  onClickSetColor(value: string) {
    this.isShowMatRaised = value;
  }

  handleBack() { }
  maxPerMainFile: number = 150*1024*1024
  public async getFile(e) {
    this.blockUI.start();
    if (typeof FileReader !== "undefined") {
      const files = e.target.files;
      let size = 0;
      const filesUpload = this.createContractService.fileUploadArray.getValue() ? this.createContractService.fileUploadArray.getValue() : [];
      const filesSrc = this.createContractService.fileUploadSrc.getValue() ? this.createContractService.fileUploadSrc.getValue() : [];
      filesUpload.forEach(item => {
        size += item.size
      });
      const allFile = filesUpload.map(item => {
        return { name: item.name };
      });

      const fileSave = [];
      const fileSrc = [];
      const fileAttach = [];
      const limitSize = this.maxSize; // 10MB
      let error: 'type' | 'size' = null;
      for (let file of files) {
        if (file.type !== 'application/pdf') {
          error = 'type';
          break;
        } else if(file.size > this.maxPerMainFile) {
          error = 'size';
          break;
        } else {
          // if (file.size <= limitSize) {
            size += file.size;
            const fileName = file.name;
            const dotIndex = fileName.lastIndexOf('.');
            const namePart = fileName.substring(0, dotIndex);
            const extPart = fileName.substring(dotIndex + 1).toLowerCase();
            const newFileName  = `${namePart}.${extPart}`;
            file = new File([file], `${newFileName}`, { type: file.type });
            const src = await this.checkContentTypeThenAddFile(file);
            if (src) {
              const nameFileSplit = file.name.substring(0, file.name.length - 4);
              const find = allFile.find(item => {
                return item.name === file.name;
              });
              const specials = [
                '/', '.', '*', '+', '?', '|',
                '(', ')', '[', ']', '{', '}', '\\'
              ];
              const regSpe = new RegExp('(\\' + specials.join('|\\') + ')', 'gim');
              const nameFileReg = nameFileSplit.replace(regSpe, '\\$1');
              const sameName = allFile.filter(item => {
                return new RegExp(nameFileReg + '\\([0-9]{1,}\\)\.' + 'pdf').test(item.name);
              });
              const number = sameName.map(item => {
                const listNumber = item.name.match(/\([0-9]{1,}\)/g);
                return listNumber.length ? listNumber[listNumber.length - 1].replace('(', '').replace(')', '') : null;
              });
              if (find && !number.length) {
                file = new File([file], `${nameFileSplit}(1).pdf`, { type: file.type });
              } else if (find && number.length) {
                const numbers = Array.from({ length: 100 }, (v, i) => i + 1);
                let index;
                for (const iterator of numbers) {
                  if (!number.includes(iterator.toString())) {
                    index = iterator;
                    break;
                  }
                }
                file = new File([file], `${nameFileSplit}(${index}).pdf`, { type: file.type });
              }
              file.id = encodeURIComponent(file.name);
              file.source = 'FILE'
              fileSave.push(file);
              fileSrc.push(src);
              allFile.push(file);
              const path = +new Date() + ""
              fileAttach.push({
                file: file,
                id: file.id,
                src: src,
                path: path,
                source: 'FILE'
              })

            } else {
              error = 'type';
              break;
            }
          // } else {
          //   error = 'size';
          //   break;
          // }
          this.fileUploadSize = size;
          this.createContractService.currentTotalcapacityMainAttachments.next(size);
        }
      }
      if (error) {
        switch (error) {
          case 'type':
            if (!this.toastr.findDuplicate(this.message.getMessage('messages.only_accept_pdf'), true, true)) {
              this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
              this.blockUI.stop();
            }
            break;
          case 'size':
            if (!this.toastr.findDuplicate(this.message.getMessage('validation.max_size_file_upload'), true, true)) {
              this.toastr.error(this.message.getMessage('validation.max_size_file_upload').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024))));
              this.blockUI.stop();
            }
            break;
          default: break;
        }
      }
      // else if (size > limitSize) {
      //   if (!this.toastr.findDuplicate(this.message.getMessage('validation.file_config'), true, true)) {
      //     this.toastr.error(this.message.getMessage('validation.file_config').replace('{0}', String(Math.floor(this.maxSize / 1024 / 1024))));
      //     this.blockUI.stop();
      //   }
      // }
      else if (fileSave.length) {
        let totalSize = size;
        this.createContractService.dataDocumentParentNewUploadContractAttachments.getValue().forEach(attach => {
          if (attach.fileSize !== undefined) {
              totalSize = totalSize + attach.fileSize;
          } else {
              totalSize = totalSize + attach.size;
          }
        });
        // this.createContractService.mainContractAttactment.getValue().forEach(mainAttach => {
        //   if (mainAttach.fileSize !== undefined) {
        //     totalSize = totalSize + mainAttach.fileSize;
        //   } else if(mainAttach.size){
        //     totalSize = totalSize + mainAttach.size;
        //   } else if(mainAttach.file){
        //     totalSize = totalSize + mainAttach.file.size;
        //   } else {
        //     totalSize = totalSize
        //   }
        // })
        if(totalSize > this.maxSizeSystem){
          this.blockUI.stop();
          this.toastr.error(this.message.getMessage('validation.max_size_file_contract').replace('{0}', String(Math.floor(this.maxSizeSystem/1024/1024))));
          return true
        }
        // merge 21511
        let infoFile = this.createContractService.infoFile.getValue() || [];
        fileSave.forEach(file => {
          const reader = new FileReader();
          reader.readAsBinaryString(file);
          reader.onloadend = () => {
            let count = 0;
            let dataLoad:any = reader.result;
            let match = dataLoad.match(/Type\/Pages\/Count (\d+)/);
            if (match) {
              count = match[1];
            } else {
              count = dataLoad.match(/\/Type[\s]*\/Page[^s]/g) ? dataLoad.match(/\/Type[\s]*\/Page[^s]/g).length : 0;
            }
            if(count !== 0){
              infoFile.push({
              id: file.id,
              numberPage: Number(count)
            })
            this.createContractService.infoFile.next(infoFile);
            } else {
              const formData = new FormData;
              formData.append('file', file)
              this.documentService.getInfoFile(formData).pipe(finalize(()=>this.blockUI.stop())).subscribe(res => {
                if(res.success){
                  infoFile.push({
                    id: file.id,
                    numberPage: Number(res.data.numberPage) || 0
                  })
                  this.createContractService.infoFile.next(infoFile);
                } else {
                  this.toastr.error(res.message);
                }
              })
            }
          }
        });
        if (this.isBuyContract1Mb && !this.isBuyContract10Mb) {
          if (this.fileUploadSize <= this.size1MB) {
            const newFileArray = filesUpload.concat(fileSave);
            const newFileSrc = filesSrc.concat(fileSrc);
            // if (this.createContractService.createContractType.getValue() === FormActionType) {
            //   this.createContractService.signPositions.next([]);
            //   this.createContractService.contractCodePositions.next([]);
            //   this.createContractService.listSignatureTable.next([]);
            // }
            // this.createContractService.fieldData = null;
            // this.createContractService.fileExport = null;
            // this.createContractService.tableModel = null;
            // this.createContractService.signatureData.next(null);
            // this.createContractService.documentFileTemplate.next(null);
            this.createContractService.changeFileOutput = true;
            this.createContractService.fileUploadArray.next(newFileArray);
            this.createContractService.fileUploadSrc.next(newFileSrc);
            if (!this.document.mainContractAttachments) {
              this.document.mainContractAttachments = [];
            }
            fileAttach.forEach(file => {
              this.document.mainContractAttachments.push({
                attachmentOrder: this.document.mainContractAttachments.length,
                id: file.file.id,
                fileSize: file.file.size,
                fileName: file.file.name,
                path: file.path,
                active: true,
                src: file.src,
                source: file.source
              })
              this.listPdfSrc[file.path] = file.src
            });
            this.createContractService.mainContractAttactment.next(this.document.mainContractAttachments);
            // this.createContractService.createContractType.next(FileUploadType);
            if (!filesUpload.length) {
              this.createContractService.pdfSrc.next(newFileArray[0]);
            }

            if (!this.listDataSign.customer.length && !this.listDataSign.enterprise.length) {
              this.listDataSign.customer = this.createContractService.recordsPartySign.getValue().filter(item => {
                return !item.isCreatedSide
              });
              this.listDataSign.enterprise = this.createContractService.recordsUserPerformSign.getValue().filter(item => {
                const createSide = this.createContractService.recordsPartySign.getValue().find(item => item.isCreatedSide);
                item.enterpriseId = createSide && createSide.enterpriseId ? createSide.enterpriseId : null;
                return item.role === EnumRoleUser.USER_SIGN;
              });
              this.listApproverSign = this.createContractService.recordsUserPerformSign.getValue().filter(item => {
                return item.role === EnumRoleUser.USER_APPROVER && item.isSignDigitalCertificate && item.signConfig.showImage;
              });
            }
        } else {
          this.toastr.error(this.message.getMessage('messages.uploaded_file_exceeds_the_allowed_1MB_capacity'));
          this.blockUI.stop();
          return;
        }
        } else {
          if (this.fileUploadSize <= this.size10MB) {
            const newFileArray = filesUpload.concat(fileSave);
            const newFileSrc = filesSrc.concat(fileSrc);
            // if (this.createContractService.createContractType.getValue() === FormActionType) {
            //   this.createContractService.signPositions.next([]);
            //   this.createContractService.contractCodePositions.next([]);
            //   this.createContractService.listSignatureTable.next([]);
            // }
            // this.createContractService.fieldData = null;
            // this.createContractService.fileExport = null;
            // this.createContractService.tableModel = null;
            // this.createContractService.signatureData.next(null);
            // this.createContractService.documentFileTemplate.next(null);
            this.createContractService.changeFileOutput = true;
            this.createContractService.fileUploadArray.next(newFileArray);
            this.createContractService.fileUploadSrc.next(newFileSrc);
            if (!this.document.mainContractAttachments) {
              this.document.mainContractAttachments = [];
            }
            fileAttach.forEach(file => {
              this.document.mainContractAttachments.push({
                attachmentOrder: this.document.mainContractAttachments.length,
                id: file.id,
                fileSize: file.file.size,
                fileName: file.file.name,
                path: file.path,
                active: true,
                src: file.src,
                source: file.source
              })
              this.listPdfSrc[file.path] = file.src
            });
            this.createContractService.mainContractAttactment.next(this.document.mainContractAttachments);
            // this.createContractService.createContractType.next(FileUploadType);
            if (!filesUpload.length) {
              this.createContractService.pdfSrc.next(newFileArray[0]);
            }

            if (!this.listDataSign.customer.length && !this.listDataSign.enterprise.length) {
              this.listDataSign.customer = this.createContractService.recordsPartySign.getValue().filter(item => {
                return !item.isCreatedSide
              });
              this.listDataSign.enterprise = this.createContractService.recordsUserPerformSign.getValue().filter(item => {
                const createSide = this.createContractService.recordsPartySign.getValue().find(item => item.isCreatedSide);
                item.enterpriseId = createSide && createSide.enterpriseId ? createSide.enterpriseId : null;
                return item.role === EnumRoleUser.USER_SIGN;
              });
              this.listApproverSign = this.createContractService.recordsUserPerformSign.getValue().filter(item => {
                return item.role === EnumRoleUser.USER_APPROVER && item.isSignDigitalCertificate && item.signConfig.showImage;
              });
            }
          } else if (this.fileUploadSize > this.size10MB && this.fileUploadSize <= this.maxSizeSystem) {
            const residualCapacity = this.fileUploadSize - this.size10MB;
            if (!this.biggerThan10MBFileSize) {
              this.toastr.error(this.message.getMessage('messages.uploaded_files_exceed'));
              this.blockUI.stop();
              return;
            } else {
              if (this.isUpdate) {
                let sizeCheckUpload = 0;
                if (this.fileSizeUp > this.size10MB) {
                  sizeCheckUpload = (this.fileSizeUp - this.size10MB)
                }
                if ((this.biggerThan10MBFileSize + sizeCheckUpload) >= residualCapacity) {
                  const newFileArray = filesUpload.concat(fileSave);
                  const newFileSrc = filesSrc.concat(fileSrc);
                  // if (this.createContractService.createContractType.getValue() === FormActionType) {
                  //   this.createContractService.signPositions.next([]);
                  //   this.createContractService.contractCodePositions.next([]);
                  //   this.createContractService.listSignatureTable.next([]);
                  // }
                  // this.createContractService.fieldData = null;
                  // this.createContractService.fileExport = null;
                  // this.createContractService.tableModel = null;
                  // this.createContractService.signatureData.next(null);
                  // this.createContractService.documentFileTemplate.next(null);
                  this.createContractService.changeFileOutput = true;
                  this.createContractService.fileUploadArray.next(newFileArray);
                  this.createContractService.fileUploadSrc.next(newFileSrc);
                  if (!this.document.mainContractAttachments) {
                    this.document.mainContractAttachments = [];
                  }
                  fileAttach.forEach(file => {
                    this.document.mainContractAttachments.push({
                      attachmentOrder: this.document.mainContractAttachments.length,
                      id: file.id,
                      fileSize: file.file.size,
                      fileName: file.file.name,
                      path: file.path,
                      active: true,
                      src: file.src,
                      source: file.source
                    })
                    this.listPdfSrc[file.path] = file.src
                  });
                  this.createContractService.mainContractAttactment.next(this.document.mainContractAttachments);
                  // this.createContractService.createContractType.next(FileUploadType);
                  if (!filesUpload.length) {
                    this.createContractService.pdfSrc.next(newFileArray[0]);
                  }

                  if (!this.listDataSign.customer.length && !this.listDataSign.enterprise.length) {
                    this.listDataSign.customer = this.createContractService.recordsPartySign.getValue().filter(item => {
                      return !item.isCreatedSide
                    });
                    this.listDataSign.enterprise = this.createContractService.recordsUserPerformSign.getValue().filter(item => {
                      const createSide = this.createContractService.recordsPartySign.getValue().find(item => item.isCreatedSide);
                      item.enterpriseId = createSide && createSide.enterpriseId ? createSide.enterpriseId : null;
                      return item.role === EnumRoleUser.USER_SIGN;
                    });
                    this.listApproverSign = this.createContractService.recordsUserPerformSign.getValue().filter(item => {
                      return item.role === EnumRoleUser.USER_APPROVER && item.isSignDigitalCertificate && item.signConfig.showImage;
                    });
                  }
                } else {
                  this.toastr.error(this.message.getMessage('messages.account_Subscribe_File_Download_Capacity_resource'));
                  this.blockUI.stop();
                  return;
                }
              } else {
                if (this.biggerThan10MBFileSize >= residualCapacity) {
                  const newFileArray = filesUpload.concat(fileSave);
                  const newFileSrc = filesSrc.concat(fileSrc);
                  // if (this.createContractService.createContractType.getValue() === FormActionType) {
                  //   this.createContractService.signPositions.next([]);
                  //   this.createContractService.contractCodePositions.next([]);
                  //   this.createContractService.listSignatureTable.next([]);
                  // }
                  // this.createContractService.fieldData = null;
                  // this.createContractService.fileExport = null;
                  // this.createContractService.tableModel = null;
                  // this.createContractService.signatureData.next(null);
                  // this.createContractService.documentFileTemplate.next(null);
                  this.createContractService.changeFileOutput = true;
                  this.createContractService.fileUploadArray.next(newFileArray);
                  this.createContractService.fileUploadSrc.next(newFileSrc);
                  if (!this.document.mainContractAttachments) {
                    this.document.mainContractAttachments = [];
                  }
                  fileAttach.forEach(file => {
                    this.document.mainContractAttachments.push({
                      attachmentOrder: this.document.mainContractAttachments.length,
                      id: file.id,
                      fileSize: file.file.size,
                      fileName: file.file.name,
                      path: file.path,
                      active: true,
                      src: file.src,
                      source: file.source

                    })
                    this.listPdfSrc[file.path] = file.src
                  });
                  this.createContractService.mainContractAttactment.next(this.document.mainContractAttachments);
                  // this.createContractService.createContractType.next(FileUploadType);
                  if (!filesUpload.length) {
                    this.createContractService.pdfSrc.next(newFileArray[0]);
                  }

                  if (!this.listDataSign.customer.length && !this.listDataSign.enterprise.length) {
                    this.listDataSign.customer = this.createContractService.recordsPartySign.getValue().filter(item => {
                      return !item.isCreatedSide
                    });
                    this.listDataSign.enterprise = this.createContractService.recordsUserPerformSign.getValue().filter(item => {
                      const createSide = this.createContractService.recordsPartySign.getValue().find(item => item.isCreatedSide);
                      item.enterpriseId = createSide && createSide.enterpriseId ? createSide.enterpriseId : null;
                      return item.role === EnumRoleUser.USER_SIGN;
                    });
                    this.listApproverSign = this.createContractService.recordsUserPerformSign.getValue().filter(item => {
                      return item.role === EnumRoleUser.USER_APPROVER && item.isSignDigitalCertificate && item.signConfig.showImage;
                    });
                  }
                } else {
                  this.toastr.error(this.message.getMessage('messages.account_Subscribe_File_Download_Capacity_resource'));
                  this.blockUI.stop();
                  return;
                }
              }
            }
          } else {
            this.toastr.error(this.message.getMessage('validation.file_config').replace('{0}', String(Math.floor(this.maxSizeSystem/1024/1024))));
            this.blockUI.stop();
            return;
          }
          // merge 21511
        }
      }
    }
    this.blockUI.stop();
    this.changeDataToTable()
    return true;
  }

  private async checkContentTypeThenAddFile(file: File): Promise<boolean> {
    const ct = await FileUtils.getContentType(file);
    let r = null;
    if (ContentType.PDF === ct) {
      r = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        // tslint:disable-next-line:no-shadowed-variable
        reader.onload = (e: any) => {
          resolve(e.target.result);
        };
        reader.readAsArrayBuffer(file);
      })
    }
    return new Promise((resolve, reject) => resolve(r));
  }

  private checkHaveDataForm(fields: Field[]): boolean {
    const fieldsHaveValue = fields.filter((field) => {
      return field.value;
    });
    return fieldsHaveValue.length ? true : false;
  }


  public chooseFile() {
    // if (this.createContractService.createContractType.getValue() === 1) {
      document.getElementById('file').click();
      return;
    // }
    // const message = this.message.getMessage('messages.confirm_change_file');
    // const dialog = this.dialog.open(WarningComponent, {
    //   width: '40%',
    //   data: message
    // });
    // dialog.afterClosed().subscribe(ref => {
    //   if (ref) {
    //     this.createContractService.isChangeTypeDocAndTemp.next(true);
    //     this.createContractService.fieldData = null;
    //     this.createContractService.fileExport = null;
    //     this.createContractService.documentFileTemplate.next(null);
    //     this.createContractService.pdfSrc.next(null);
    //     this.createContractService.signatureData.next(null);
    //     this.document.templateFilePath = null;
    //     this.createContractService.signPositions.next([]);
    //     this.createContractService.contractCodePositions.next([]);
    //     this.createContractService.listSignatureTable.next([]);
    //     this.createContractService.fileUploadArray.next([]);
    //     this.createContractService.fileUploadSrc.next([]);
    //     this.document.mainContractAttachments = [];
    //     document.getElementById('file').click();

    //     return;
    //   }
    // })
  }

  // process sign
  textLayerRendered(e) {
    const element = e.source.textLayerDiv;
    const pageIndex = e.source.pageNumber
    // lấy các chữ ở trang pageNumber
    let signPosition;
    let signaturePosition;
    if ((this.listSign && this.listSign.length > 0) || (this.listSignature && this.listSignature.length > 0)) {
      const files = this.createContractService.fileUploadArray.getValue();
      let id;
      if (files && files.length && files[this.activeFile]) {
        const file = files[this.activeFile] as any;
        id = file.id ? file.id : null;
      }
      if (this.listSign && this.listSign.length > 0) {
        signPosition = this.listSign.filter((item) => {
          return item.pageIndex === pageIndex && item.fileId === id && !(item.id && item.id.includes('contract-code-config-'));
        });
      }
      if (this.listSignature && this.listSignature.length > 0) {
        signaturePosition = this.listSignature.filter((item) => {
          return item.pageIndex === pageIndex && item.fileId === id && (item.id && item.id.includes('contract-code-config-'));
        });
      }
    }

    if (signPosition && signPosition.length > 0) {

      for (const position of signPosition) {

        const x = position.positionX;
        const y = position.positionY;
        const _width = position.widthRectangle;
        const _height = position.heightRectangle;
        const name = position.name;
        const id = position.enterpriseId || position.customerId;
        const userId = position.userId;
        const elWidth = element.offsetWidth;
        const elHeight = element.offsetHeight;
        const htmlNode = this.getStampWrapper(x, y, _width, _height, name, id, elWidth, elHeight, userId, null, null, [], false, (position.contractSignId || position.idNumber), position.row_number);
        element.appendChild(htmlNode);
        if (position.enterpriseId) {
          if (position.enterpriseId === this.signNeedShow && position.userId === this.signApproverNeedShow) {
            const node = document.getElementById(`${position.contractSignId}-sign-${this.signNeedShow}-approver-${this.signApproverNeedShow}`);
            node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
          }
          this.signNeedShow = null;
          this.signApproverNeedShow = null;
        } else {
          if (position.customerId === this.signNeedShow && position.userId === this.signApproverNeedShow) {
            const node = document.getElementById(`${position.contractSignId}-sign-${this.signNeedShow}-approver-${this.signApproverNeedShow}`);
            node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });

          }
          this.signNeedShow = null;
          this.signApproverNeedShow = null;
        }

      }
    }

    // Da co chu ky anh tren he thong
    if (signaturePosition && signaturePosition.length > 0) {
      for (const position of signaturePosition) {
        const x = position.positionX;
        const y = position.positionY;
        const _width = position.widthRectangle;
        const _height = position.heightRectangle;
        const name = this.isOnAutoNumber ? this.configAutoNumber : (this.document.code ? this.document.code : this.message.getMessage('headertable.doc_code_required'));
        const id = position.id;
        const fontSize = position.fontSize;
        const fontFamily = position.fontFamily;
        const fontStyle = position.fontStyle;
        const elWidth = element.offsetWidth;
        const elHeight = element.offsetHeight;
        const htmlNode = this.getStampWrapper(x, y, _width, _height, name, id, elWidth, elHeight, '', fontSize, fontFamily, fontStyle, true, (position.contractSignId || position.idNumber), position.row_number);
        element.appendChild(htmlNode);
        if (position.id === this.signatureNeedShow) {
          const node = document.getElementById(`${this.signatureNeedShow}`);
          node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
          this.signatureNeedShow = null;
        }
      }
    }

    element.addEventListener('mousedown', (eventMousedown) => {
      if (!this.isSelectPosition) {
        const target: HTMLElement = eventMousedown.target;
        if (target.id && target.id.includes('contract-code-config-') || target.id.includes('sign-') || (target.parentElement && target.parentElement.id && (target.parentElement.id.includes('sign-') || target.parentElement.id.includes('contract-code-config-')))) {
          const id = target.id ? target.id : target.parentElement.id;
          const indexApprover = id.indexOf('-approver-');
          const indexSign = id.indexOf('-sign-');
          const signId = id.slice(indexSign + 6, indexApprover);
          const userId = id.slice(indexApprover + 10);
          const signUuid = id.slice(0, indexSign);

          if (target.className.includes('mat-icon')) {
            this.deleteSign(signId, userId, signUuid,null);
            if (target.id && target.id.includes('contract-code-config-') || (target.parentElement && target.parentElement.id && target.parentElement.id.includes('contract-code-config-'))) {
              this.deleteSignature(id);
            }
            return;
          }
          this.isSelectPosition = true;
          document.body.style.userSelect = 'none';
          const files = this.createContractService.fileUploadArray.getValue();
          let idFile;
          if (files && files.length && files[this.activeFile]) {
            const file = files[this.activeFile] as any;
            idFile = file.id ? file.id : null;
          }
          this.signSelected = this.listSign.find(item => (item.enterpriseId == signId || item.customerId == signId) && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
          if (this.listSign.length) {
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              this.signSelected = this.listSign.find(item => {
                return (item.enterpriseId == signId || item.customerId == signId) && item.userId === userId && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)
              });
            } else {
              this.signSelected = this.listSign.find(item => (item.enterpriseId === signId ||  item.customerId == signId) && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            }
          } if (this.listSignature.length) {
            if (target.id && target.id.includes('contract-code-config-') || (target.parentElement && target.parentElement.id && target.parentElement.id.includes('contract-code-config-'))) {
              if (id !== null && id !== undefined && id !== 'undefined') {
                this.signatureSelected = this.listSignature.find(item => item.id === id && item.fileId === idFile);
              } else {
                this.signatureSelected = this.listSignature.find(item => item.id === id && item.fileId === idFile);
              }
            };
          }

          let sign = null;

          if (target.id && target.id.includes('contract-code-config-') || (target.parentElement && target.parentElement.id && target.parentElement.id.includes('contract-code-config-'))){
            let idSign = target.id || target.parentElement.id;
            sign = document.getElementById(idSign);
          }else{
            let idSign = (this.signSelected.contractSignId || this.signSelected.idNumber) +  '-sign-' + (this.signSelected.enterpriseId || this.signSelected.customerId) + '-approver-' + this.signSelected.userId
            sign = document.getElementById(idSign)
          }

          let position = {
            top: Number(sign.style.top.slice(0, -2)),
            left: Number(sign.style.left.slice(0, -2))
          }

          const node = document.getElementById(id);
          this.currentNodeSelected = node;
          if (node) {
            node.remove();
          }
          if (Object.keys(this.signatureSelected || {}).length) {
            this.showFramesNotification(this.signatureSelected, position, true);

          }if (Object.keys(this.signSelected || {}).length) {
            this.showFramesNotification(this.signSelected, position);
          }
        }
      }
    });

    element.addEventListener('mouseup', (eventMouseup) => {
      for (let i = 0; i < element.childNodes.length; i++) {
        if (element.childNodes[i].nodeName == 'DIV' && element.childNodes[i]['id'] && element.childNodes[i]['id'].includes('contract-code-config-')) {
          if (this.listSignature && this.listSignature.length > 0) {
            this.listSignature.forEach((item) => {
              if (item.id == element.childNodes[i]['id']) {
                item.page === pageIndex;
              }

            });
            this.createContractService.contractCodePositions.next(this.listSignature);
          };
          if (this.listSignatureTable && this.listSignatureTable.length > 0) {
            this.listSignatureTable.forEach((item) => {
              if (item.id == element.childNodes[i]['id']) {
                item.page === pageIndex;
              }

            });
            this.createContractService.listSignatureTable.next(this.listSignatureTable);
          }
        }
      }

      if (this.isSelectPosition) {
        this.isSelectPosition = false;
        document.body.style.userSelect = 'auto';
        // xoá dòng chọn vị trí
        const framesNotification = document.getElementById('show-frames-notification');
        if (framesNotification) {
          framesNotification.remove();
        }
        const offsetParent = element.offsetParent.dataset;
        const { pageNumber } = offsetParent;
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight, widthHeightRatio;
        widthHeightRatio = this.widthRectangle / this.heightRectangle;
        if (Object.keys(this.signSelected || {}).length) {
          signatureWidth = this.signSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signSelected.heightRectangle * this.zoomLevel / 100;
        }
        else if (Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signatureSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signatureSelected.heightRectangle * this.zoomLevel / 100;
        }
        let signZoom = this.zoomLevel / 100;
        let wrapperLeft = eventMouseup.clientX - signatureWidth / 2 - left;
        let wrapperTop = eventMouseup.clientY - signatureHeight / 2 - top;
        const newDiv = document.createElement('div');
        if (Object.keys(this.signSelected || {}).length) {
          let contractSignId = this.signSelected.contractSignId || this.signSelected.idNumber

          newDiv.setAttribute('id', `${contractSignId}-sign-${this.signSelected.enterpriseId || this.signSelected.customerId}-approver-${this.signSelected.userId}`);
          newDiv.style.width = `${signatureWidth}px`;
          newDiv.style.height = `${signatureHeight}px`;
          newDiv.style.fontFamily = 'Roboto, sans-serif';
        }
        else if (Object.keys(this.signatureSelected || {}).length) {

          newDiv.setAttribute('id', `${this.signatureSelected.id}`);
          newDiv.style.width = `${signatureWidth}px`;
          newDiv.style.height = `${signatureHeight}px`;
          if (this.signatureSelected.fontSize) {
            newDiv.style.fontSize = `${this.signatureSelected.fontSize}px`;
          }
          if (this.signatureSelected.fontFamily) {
            newDiv.style.fontFamily = this.signatureSelected.fontFamily;
          }
          if (this.signatureSelected.fontStyle && this.signatureSelected.fontStyle.includes('bold')) {
            newDiv.style.fontWeight = 'bold';
          }
          if (this.signatureSelected.fontStyle && this.signatureSelected.fontStyle.includes('italic')) {
            newDiv.style.fontStyle = 'italic';
          }
          if (this.signatureSelected.fontStyle && this.signatureSelected.fontStyle.includes('underline')) {
            newDiv.style.textDecoration = 'underline';
          }
        }
        if (wrapperLeft > 0) {
          newDiv.style.left = `${wrapperLeft}px`;
        }
        if (wrapperTop > 0) {
          newDiv.style.top = `${wrapperTop}px`;
        }
        newDiv.style.background = 'rgb(0,0,0,0.2)';
        newDiv.style.zIndex = '1';
        newDiv.style.border = '1px solid #999999';
        newDiv.style.lineHeight = '1.9';
        newDiv.style.color = '#00f';
        if (this.documentCodeNull && !this.isOnAutoNumber) {
          newDiv.style.color = 'red';
        } else {
          newDiv.style.color = '#00f';
        }
        newDiv.style.padding = `${10 * signZoom}px`;
        newDiv.style.position = 'absolute';
        newDiv.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
        newDiv.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
        newDiv.className = 'no-user-select';
        if (Object.keys(this.signSelected || {}).length) {
          const mouseupImgContent = this.buildDefaultSignImageContent(
            this.signSelected.name, this.signSelected.widthRectangle, this.signSelected.heightRectangle);
          if (mouseupImgContent) {
            newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
          ${mouseupImgContent}
        `;
          } else {
            newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
          <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;">
            ${this.message.getMessage('signature')} ${this.signSelected.name} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}
          </div>
        `;
          }
        }
        else if (Object.keys(this.signatureSelected || {}).length) {
          // newDiv.style.whiteSpace = 'nowrap';
          // newDiv.style.minWidth ='fit-content';
          newDiv.style.wordBreak = 'break-word';

          if (this.documentCodeNull && !this.isOnAutoNumber) {
            newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
            <div class="text-danger" style="font-size: ${(this.signatureSelected.fontSize ? this.signatureSelected.fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; cursor: move;">
              ${this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required')}
            </div>
          `;
          } else {
            newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
            <div style="font-size: ${(this.signatureSelected.fontSize ? this.signatureSelected.fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; color: #00f; cursor: move;">
            ${this.isOnAutoNumber ? this.configAutoNumber : this.document.code}
            </div>
          `;
          }
        }
        this.changeDataToTable()
        //         Thay dổi kích thước chân ký
        const resizer = document.createElement('div');
        resizer.setAttribute('class', 'resize-div-bot-right');
        resizer.style.setProperty('--zoom', (signZoom).toString());
        newDiv.appendChild(resizer);
        element.appendChild(newDiv);

        let startX, startY;
        let signId;
        let indexApprover;
        let userId;
        let idSignature;
        let signUuid;

        resizer.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);
          const targetSignId = e.target as Element;
          if (targetSignId.parentElement.id && targetSignId.parentElement.id.includes('contract-code-config-')) {
            idSignature = targetSignId.parentElement.id;
          }

           indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
           const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
           signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
           userId = targetSignId.parentElement.id.slice(indexApprover + 10);
           signUuid = targetSignId.parentElement.id.slice(0, indexSign);
        });

        // const signSelected = this.listSign.filter(item => item.enterpriseId === signId);

        let baseWidth = newDiv.offsetWidth;
        let baseHeight = newDiv.offsetHeight;

        const rerenderSign = () => {
          let signSelected, signatureSelected;
          if (this.listSign.length) {
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            }
          } if (this.listSignature.length) {
            if (idSignature) {
              signatureSelected = this.listSignature.filter(item => item.id === idSignature);
            }
          }
          if (Object.keys(signSelected || {}).length && !Object.keys(signatureSelected || {}).length) {
            // resize: dùng size LIVE của khung (listSign chỉ được update ở stopDrag)
            const mouseupImgContent = signSelected[0]
              ? this.buildDefaultSignImageContentPx(signSelected[0].name, newDiv.offsetWidth, newDiv.offsetHeight)
              : null;
            if (mouseupImgContent) {
              newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
            ${mouseupImgContent}
        `;
            } else {
              newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
            <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;">
              ${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}
            </div>
        `;
            }
          } else if (Object.keys(this.signatureSelected || {}).length) {
            // newDiv.style.whiteSpace = 'nowrap';
            // newDiv.style.minWidth ='fit-content';
            newDiv.style.wordBreak = 'break-word';
            newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px;position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
            <div style="font-size: ${(this.signatureSelected.fontSize ? this.signatureSelected.fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; color: #00f; cursor: move;">
              ${this.isOnAutoNumber ? this.configAutoNumber : this.document.code}
            </div>
        `;
          }

          newDiv.appendChild(resizer);
          resizer.style.removeProperty('--zoom');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          return;
        }

        const doDrag = (e) => {
          e.stopPropagation();
          let signSelected, signatureSelected;
          if (this.listSign.length) {
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            };
          }
          if (this.listSignature.length) {
            if (idSignature) {
              signatureSelected = this.listSignature.filter(item => item.id === idSignature);
            }
          }
          if (Object.keys(signSelected || {}).length && !Object.keys(signatureSelected || {}).length) {
            signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
            signatureHeight = signSelected[0].heightRectangle * this.zoomLevel / 100;
            newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
            newDiv.style.height = (signatureHeight + e.clientY - startY) + 'px';
            let widthHeightRatio_Drag = newDiv.offsetWidth / newDiv.offsetHeight;
            if (widthHeightRatio !== widthHeightRatio_Drag) {
              newDiv.style.height = (newDiv.offsetWidth / widthHeightRatio) + 'px';
              newDiv.style.width = (newDiv.offsetHeight * widthHeightRatio) + 'px';
            }
          } else if (Object.keys(signatureSelected || {}).length) {
            signatureWidth = signatureSelected[0].widthRectangle * this.zoomLevel / 100;
            signatureHeight = signatureSelected[0].heightRectangle * this.zoomLevel / 100;
            newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
            newDiv.style.height = (signatureHeight + e.clientY - startY) + 'px';
          }

          newDiv.style.maxWidth = (element.offsetWidth - wrapperLeft) + 'px';
          newDiv.style.maxHeight = (element.offsetHeight - wrapperTop) + 'px';
          rerenderSign();
        }

        const stopDrag = (e) => {
          e.stopPropagation();
          if (newDiv.offsetWidth / 2 + wrapperLeft < 0 || newDiv.offsetHeight / 2 + wrapperTop < 0) {
            newDiv.style.width = baseWidth + 'px';
            newDiv.style.height = baseHeight + 'px';
          } else {
            baseWidth = newDiv.offsetWidth;
            baseHeight = newDiv.offsetHeight;
          }
          rerenderSign();
          if (this.listSign.length) {
            this.listSign.forEach(item => {
              if ((item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))) {
                item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
                item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
              }
            });
            this.createContractService.signPositions.next(this.listSign);
          }

          if (this.listSignature.length) {
            this.listSignature.forEach(item => {
              if (item.id === idSignature) {
                item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
                item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
              }
            });
            this.createContractService.contractCodePositions.next(this.listSignature);
          }
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        }

        const zoomLevel = this.zoomLevel;
        const files = this.createContractService.fileUploadArray.getValue();
        let id;
        if (files && files.length && files[this.activeFile]) {
          const file = files[this.activeFile] as any;
          id = file.id ? file.id : null;
        }
        if (this.listSign.length && Object.keys(this.signSelected || {}).length) {
          this.listSign.forEach(item => {
            if (((item.enterpriseId === this.signSelected.enterpriseId && this.signSelected.enterpriseId) ||
            (item.customerId === this.signSelected.customerId && this.signSelected.customerId)) &&
            item.userId === this.signSelected.userId && item.fileId === id  &&
            ((item.contractSignId && this.signSelected.contractSignId === item.contractSignId) || (this.signSelected.idNumber === item.idNumber && item.idNumber))) {


              item.stampPositionLeft = eventMouseup.clientX - signatureWidth / 2 - left;
              item.stampPositionTop = eventMouseup.clientY - signatureHeight / 2 - top;
              item.positionX = 100 * wrapperLeft / zoomLevel;
              item.positionY = 100 * wrapperTop / zoomLevel;
              item.pageIndex = pageIndex;
              item.zoom = this.zoomLevel / 100;
              item.pdfSrc = this.pdfSrc;
              item.pageNumber = pageNumber;
              item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
              item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
            }
          });
          this.signSelected = null;
          this.createContractService.signPositions.next(this.listSign);
        }
        if (this.listSignature.length && Object.keys(this.signatureSelected || {}).length) {
          this.listSignature.forEach((item, idx) => {
            if (item.id === this.signatureSelected.id && item.fileId === id) {
              item.stampPositionLeft = eventMouseup.clientX - signatureWidth / 2 - left;
              item.stampPositionTop = eventMouseup.clientY - signatureHeight / 2 - top;
              item.positionX = 100 * wrapperLeft / zoomLevel;
              item.positionY = 100 * wrapperTop / zoomLevel;
              item.pageIndex = pageIndex;
              item.zoom = this.zoomLevel / 100;
              item.pdfSrc = this.pdfSrc;
              item.pageNumber = pageNumber;
              item.page = pageIndex;
              item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
              item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
              this.listSignatureTable[idx].page = pageIndex;
            }
          });
          this.signatureSelected = null;
          this.createContractService.contractCodePositions.next(this.listSignature);
          this.createContractService.listSignatureTable.next(this.listSignatureTable);
        }
      }
      this.changeDataToTable()
    })
    element.addEventListener('click', (clickEvent) => {
      if (!this.isSelectPosition) {
        const target: HTMLElement = clickEvent.target;
        if (target.id && target.id.includes('contract-code-config-') || target.id.includes('sign-') || (target.parentElement && target.parentElement.id && (target.parentElement.id.includes('sign-') || target.parentElement.id.includes('contract-code-config-')))) {
          const id = target.id ? target.id : target.parentElement.id;
          // const indexApprover = id.indexOf('-approver-');
          // const signId = id.slice(5, indexApprover);
          // const userId = id.slice(indexApprover + 10);
          const indexApprover = id.indexOf('-approver-');
          const indexSign = id.indexOf('-sign-');
          const signId = id.slice(indexSign + 6, indexApprover);
          const userId = id.slice(indexApprover + 10);
          const signUuid = id.slice(0, indexSign); // todo


          if (target.className.includes('mat-icon')) {
            this.deleteSign(signId, userId, signUuid,null);
            if (target.id && target.id.includes('contract-code-config-') || (target.parentElement && target.parentElement.id && target.parentElement.id.includes('contract-code-config-'))) {
              this.deleteSignature(id);
            }
            return;
          }
        }
      }
    });
    element.addEventListener('mouseleave', (mouseoverEvent) => {
      this.isMouseLeave = true;
      if (this.isSelectPosition) {
        const nodeOther = document.getElementById('show-frames-notification');
        if (nodeOther) {
          nodeOther.remove();
        }
      }
    });
    element.addEventListener('mouseover', () => {
      this.isMouseLeave = false;
    });
    element.addEventListener('wheel', (wheelEvent) => {
      if (this.isSelectPosition) {
        let node = element.querySelector('#show-frames-notification');
        const nodeOther = document.getElementById('show-frames-notification');
        if (!node && nodeOther) {
          nodeOther.remove();
        }
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight;
        if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signSelected.heightRectangle * this.zoomLevel / 100;
        }
        else if (Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signatureSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signatureSelected.heightRectangle * this.zoomLevel / 100;
        }

        let signZoom = this.zoomLevel / 100;
        const widthHeightRatio = this.widthRectangle / this.heightRectangle;
        if (!node) {
          const stampNode = document.createElement('div');
          if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
            stampNode.innerHTML = `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
            <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(this.signSelected.widthRectangle / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
              ${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : null} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}
            </div>`;
            stampNode.style.width = `${signatureWidth}px`;
            stampNode.style.height = `${signatureHeight}px`;
          } else if (Object.keys(this.signatureSelected || {}).length) {
            // stampNode.style.whiteSpace = 'nowrap';
            // stampNode.style.minWidth ='fit-content';
            stampNode.style.wordBreak = 'break-word';
            stampNode.innerHTML = `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;">
            <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(this.signatureSelected.widthRectangle / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px">${this.currentNodeSelected ? "" : this.translateService.instant('messages.click_to_select_sign_position')}</div>
           ${this.isOnAutoNumber ? this.configAutoNumber : this.document.code}
            </div>`;
          }
          this.stampWrapper = stampNode;
          stampNode.style.width = `${signatureWidth}px`;
          stampNode.style.height = `${signatureHeight}px`;
          stampNode.style.position = 'absolute';
          stampNode.setAttribute('id', 'show-frames-notification');
          stampNode.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
          stampNode.style.top = `${(wheelEvent.clientY - signatureHeight / 2 - top)}px`;
          stampNode.style.zIndex = '1';
          stampNode.style.background = 'rgb(0,0,0,0.2)';
          stampNode.style.border = '1px solid';
          stampNode.style.lineHeight = '1.9';
          stampNode.style.color = '#00f';
          stampNode.style.fontFamily = 'Roboto, sans-serif';
          stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
          stampNode.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
          stampNode.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
          stampNode.className = 'no-user-select';
          //         Thay dổi kích thước chân ký
          const resizer = document.createElement('div');
          resizer.setAttribute('class', 'resize-div-bot-right');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          stampNode.appendChild(resizer);
          element.appendChild(stampNode);

          let startX;
          let startY;
          let signId;
          let indexApprover;
          let userId;
          let idSignature;
          let signUuid;
          resizer.addEventListener('mousedown', (e) => {
            e.stopPropagation();
            startX = e.clientX;
            startY = e.clientY;
            document.documentElement.addEventListener('mousemove', doDrag);
            document.documentElement.addEventListener('mouseup', stopDrag);
            const targetSignId = e.target as Element;
            if (targetSignId.parentElement.id && targetSignId.parentElement.id.includes('contract-code-config-')) {
              idSignature = targetSignId.parentElement.id;
            }
            // indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
            // signId = targetSignId.parentElement.id.slice(5, indexApprover);
            // userId = targetSignId.parentElement.id.slice(indexApprover + 10);

            indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
            const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
            signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
            userId = targetSignId.parentElement.id.slice(indexApprover + 10);
            signUuid = targetSignId.parentElement.id.slice(0, indexSign);
          });

          let baseWidth = stampNode.offsetWidth;
          let baseHeight = stampNode.offsetHeight;

          const rerenderSign = () => {
            let signSelected, signatureSelected;
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)));
            };
            if (idSignature) {
              signatureSelected = this.listSignature.filter(item => item.id === idSignature);
            }
            if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
              // resize: dùng size LIVE của khung (listSign chỉ được update ở stopDrag)
              const wheelImgContent = signSelected[0]
                ? this.buildDefaultSignImageContentPx(signSelected[0].name, stampNode.offsetWidth, stampNode.offsetHeight)
                : null;
              if (wheelImgContent) {
                stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
              ${wheelImgContent}
          `;
              } else {
                stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
              <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
                ${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}
              </div>
          `;
              }
            } else if (Object.keys(this.signatureSelected || {}).length) {
              // stampNode.style.whiteSpace = 'nowrap';
              // stampNode.style.minWidth ='fit-content';
              stampNode.style.wordBreak = 'break-word';
              stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
              <div style="font-size: ${(this.signatureSelected.fontSize ? this.signatureSelected.fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;">
             ${this.isOnAutoNumber ? this.configAutoNumber : this.document.code}
              </div>
          `;
            }

            stampNode.appendChild(resizer);
            resizer.style.removeProperty('--zoom');
            resizer.style.setProperty('--zoom', (signZoom).toString());
            return;
          }

          const doDrag = (e) => {
            e.stopPropagation();
            let signSelected, signatureSelected;
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)));
            }
            if (idSignature) {
              signatureSelected = this.listSignature.filter(item => item.id === idSignature);
            }
            if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
              signatureHeight = signSelected[0].heightRectangle * this.zoomLevel / 100;
              signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
            } else if (Object.keys(this.signatureSelected || {}).length) {
              signatureHeight = signatureSelected[0].heightRectangle * this.zoomLevel / 100;
              signatureWidth = signatureSelected[0].widthRectangle * this.zoomLevel / 100;
            }

            stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
            stampNode.style.height = (signatureWidth + e.clientY - startY) + 'px';
            stampNode.style.maxWidth = (element.offsetWidth - stampNode.offsetLeft) + 'px';
            stampNode.style.maxHeight = (element.offsetHeight - stampNode.offsetTop) + 'px';
            rerenderSign();
          }

          const stopDrag = (e) => {
            e.stopPropagation();
            if (stampNode.offsetWidth / 2 + stampNode.offsetLeft < 0 || stampNode.offsetHeight / 2 + stampNode.offsetTop < 0) {
              stampNode.style.width = baseWidth + 'px';
              stampNode.style.height = baseHeight + 'px';
            } else {
              baseWidth = stampNode.offsetWidth;
              baseHeight = stampNode.offsetHeight;
            }

            rerenderSign();
            if (this.listSign.length) {
              this.listSign.forEach(item => {
                if ((item.enterpriseId === signId || item.customerId === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)) {
                  item.widthRectangle = stampNode.offsetWidth * 100 / this.zoomLevel;
                  item.heightRectangle = stampNode.offsetHeight * 100 / this.zoomLevel;
                }
              });
              this.createContractService.signPositions.next(this.listSign);
            }
            if (this.listSignature.length) {
              this.listSignature.forEach(item => {
                if (item.id == idSignature) {
                  item.widthRectangle = stampNode.offsetWidth * 100 / this.zoomLevel;
                  item.heightRectangle = stampNode.offsetHeight * 100 / this.zoomLevel;
                }
              });
              this.createContractService.contractCodePositions.next(this.listSignature);
            }

            document.documentElement.removeEventListener('mousemove', doDrag);
            document.documentElement.removeEventListener('mouseup', stopDrag);
          }

          element.appendChild(stampNode);
        } else {
          node.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
          node.style.top = `${(wheelEvent.clientY - signatureHeight / 2 - top)}px`;
        }
      }
    });
    element.addEventListener('mousemove', (mousemoveEvent) => {
      if (this.isSelectPosition) {
        // xoá dòng chọn vị trí
        const node = element.querySelector('#show-frames-notification');
        const nodeOther = document.getElementById('show-frames-notification');
        if (!node && nodeOther) {
          nodeOther.remove();
        }
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight;
        if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signSelected.heightRectangle * this.zoomLevel / 100;
        } else if (Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signatureSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signatureSelected.heightRectangle * this.zoomLevel / 100;
        }

        let signZoom = this.zoomLevel / 100;
        if (!node) {
          const stampNode = document.createElement('div');
          if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
            stampNode.innerHTML = `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;">
            <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(this.signSelected.widthRectangle / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px"></div>
              ${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : null} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}
            </div>`;
          } else if (Object.keys(this.signatureSelected || {}).length) {
            // stampNode.style.whiteSpace = 'nowrap';
            // stampNode.style.minWidth ='fit-content';

            stampNode.style.wordBreak = 'break-word';
            if (this.documentCodeNull && !this.isOnAutoNumber) {
              stampNode.innerHTML = `<div class="text-danger" style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; cursor: move;">
             ${this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required')}
            </div>`;
            } else {
              stampNode.innerHTML = `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; color: #00f; height: 100%; cursor: move;">
              ${this.isOnAutoNumber ? this.configAutoNumber : this.document.code}
            </div>`;
            }

          }
          stampNode.style.width = `${signatureWidth}px`;
          stampNode.style.height = `${signatureHeight}px`;
          stampNode.style.position = 'absolute';
          stampNode.setAttribute('id', 'show-frames-notification');
          stampNode.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
          stampNode.style.top = `${(mousemoveEvent.clientY - signatureHeight / 2 - top)}px`;
          stampNode.style.zIndex = '1';
          stampNode.style.background = 'rgb(0,0,0,0.2)';
          stampNode.style.border = '1px solid';
          stampNode.style.lineHeight = '1.9';
          if (this.documentCodeNull && !this.isOnAutoNumber) {
            stampNode.style.color = 'red';
          } else {
            stampNode.style.color = '#00f';
          }
          stampNode.style.fontFamily = 'Roboto, sans-serif';
          stampNode.style.padding = `${10 * signZoom}px`;
          stampNode.className = 'no-user-select';

          element.appendChild(stampNode);

        } else {
          node.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
          node.style.top = `${(mousemoveEvent.clientY - signatureHeight / 2 - top)}px`;
        }
      }
    });
    element.style.opacity = '1';
    element.setAttribute('id', `text-pdf-layer-${pageIndex}-${this.activeFile}`);
    this.maxPageCurrent = pageIndex;
    this.changeDataToTable()
  }

  textLayerFormRendered(e) {
    const element = e.source.textLayerDiv;
    const pageIndex = e.source.pageNumber;
    // lấy các chữ ở trang pageNumber
    let signPosition = [];
    if (this.signaturesFormPositions && this.signaturesFormPositions.length > 0) {
      const users = this.createContractService.recordsPartySign.getValue();
      const approver = this.createContractService.recordsUserPerformSign.getValue();
      const approverCus = [];
      users.forEach(ele =>{
        if(!ele.isCreatedSide){
          if(ele.customerApproves)
          ele.customerApproves.forEach(ala =>{
            approverCus.push(ala);
          })
        }
      })
      this.signaturesFormPositions.forEach(sign => {
        if (sign.signature && sign.signature.positions) {
          const positions = sign.signature.positions.filter(item => {
            if (sign.customerId && sign.signature.object === 'CUSTOMER') {
              const customer = users.find(user => user.customerId === sign.customerId);
              item.name = customer ? customer.name : sign.signature.name;
            } else if (sign.userId && sign.signature.object === 'ENTERPRISEAPPROVER') {
              const approve = approver.find(user => user.userId === sign.userId);
              item.name = approve ? approve.name : sign.signature.name;
            } else if (sign.userId && sign.signature.object === 'CUSTOMERAPPROVER') {
              const approveCus = approverCus.find(user => user.userId === sign.userId);
              item.name = approveCus ? approveCus.name : sign.signature.name;
            }else {
              if (sign.signature.object === 'CUSTOMER') {
                item.name = sign.signature.name;
              } else if (sign.signature.object === 'ENTERPRISEAPPROVER') {
                item.name = sign.signature.name;
              }else if (sign.signature.object === 'CUSTOMERAPPROVER') {
                item.name = sign.signature.name;
              } else {
                const createSide = users.find(user => user.isCreatedSide);
                const userPerformSign = this.createContractService.recordsUserPerformSign.getValue();
                const userSign = userPerformSign.find(user => user.role === EnumRoleUser.USER_SIGN);
                if (createSide && userSign) {
                  item.name = userSign.name;
                } else {
                  item.name = this.message.getMessage('signature_tab.create_side');
                }
              }
            }
            return item.page == pageIndex
          });
          signPosition = signPosition.concat(positions);
        }
      })
    }
    element.addEventListener('mouseenter', () => {
      this.pageIndex = pageIndex;
    })

    if (signPosition && signPosition.length > 0) {
      for (const position of signPosition) {
        const x = position.x;
        const y = position.y;
        const _width = position.width;
        const _height = position.height;
        const name = position.name;
        const id = position.signaturePositionId;
        const elWidth = element.offsetWidth;
        const elHeight = element.offsetHeight;
        const htmlNode = this.getStampWrapperForm(x, y, _width, _height, name, id, elWidth, elHeight, element);
        element.appendChild(htmlNode);
      }
    }
    element.style.opacity = '1';
    element.setAttribute('id', `text-pdf-layer-${pageIndex}`);
    this.changeDataToTable()
  }
// tạo một thẻ điv với thông tin đc truyền vào để tạo ra khung ký
  getStampWrapper(positionX: number, positionY: number, width: number, height: number, name: string, id: number, elWidth: number, elHeight: number, idUser?: any, fontSize?: any, fontFamily?: any, fontStyle?: any[], isContractCodeConfig = false, uuid: string = '', row_number:any = '') {
    const stampNode = document.createElement('div');
    if (!isContractCodeConfig) {
      stampNode.setAttribute('id', `${uuid}-sign-${id}-approver-${idUser}`);
    } else {
      //neu la cau hinh ma hop dong
      stampNode.setAttribute('id', `${id}`);
    }


    // stampNode.innerHTML = this.genStampContent();
    let signatureWidth = width * this.zoomLevel / 100;
    let signatureHeight = height * this.zoomLevel / 100;

    const wrapperLeft = (positionX * this.zoomLevel) / 100;
    const wrapperTop = (positionY * this.zoomLevel) / 100;
    let signZoom = this.zoomLevel / 100;
    const widthHeightRatio = width / height;
    stampNode.style.position = 'absolute';
    stampNode.style.left = `${wrapperLeft}px`;
    stampNode.style.top = `${wrapperTop}px`;
    if (!isContractCodeConfig) {
      stampNode.style.width = `${signatureWidth}px`;
      stampNode.style.height = `${signatureHeight}px`;
      // stampNode.style.color = '#00f';
    }
    stampNode.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
    stampNode.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    stampNode.style.color = '#00f';

    if (fontSize) {
      stampNode.style.fontSize = fontSize;
    };
    if (fontFamily) {
      stampNode.style.fontFamily = fontFamily;
    } else {
      stampNode.style.fontFamily = 'Roboto, sans-serif';
    };
    if (fontStyle && fontStyle.includes('bold')) {
      stampNode.style.fontWeight = 'bold';
    }
    if (fontStyle && fontStyle.includes('italic')) {
      stampNode.style.fontStyle = 'italic';
    }
    if (fontStyle && fontStyle.includes('underline')) {
      stampNode.style.textDecoration = 'underline';
    }
    stampNode.style.padding = `${10 * signZoom}px`;
    stampNode.className = 'no-user-select';
    if (isContractCodeConfig) {
      stampNode.style.width = `${signatureWidth}px`;
      stampNode.style.height = `${signatureHeight}px`;
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        stampNode.style.color = 'red';
      }
      // stampNode.style.whiteSpace = 'nowrap';
      // stampNode.style.minWidth ='fit-content';
      stampNode.style.wordBreak = 'break-word';
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
        <div class="text-danger" style="font-size: ${(fontSize ? fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; cursor: move;">
          ${name}
        </div>
        `;
      } else {
        stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
        <div style="font-size: ${(fontSize ? fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;">
          ${name}
        </div>
        `;
      }

    } else {
      // ưu tiên ảnh ký mặc định (giống tab 1 màn ký); chưa có ảnh -> khung text như cũ
      const signImageContent = this.buildDefaultSignImageContent(name, width, height);
      if (signImageContent) {
        stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
    ${signImageContent}
    `;
      } else {
        this.ensureDefaultSignImage(name);
        stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
    <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
      ${this.message.getMessage('signature')} ${name} ${this.message.getMessage('number_sign')} ${row_number}
    </div>
    `;
      }
      stampNode.style.display = 'flex';
      stampNode.style.justifyContent = 'center';
      stampNode.style.flexDirection = 'column';
      stampNode.style.textAlign = 'center';
      stampNode.style.fontWeight = 'bold';
    };
    // stampNode.innerHTML = `${name}`
    //         Thay dổi kích thước chân ký

    const resizer = document.createElement('div');
    resizer.setAttribute('class', 'resize-div-bot-right');
    resizer.style.setProperty('--zoom', (signZoom).toString());
    stampNode.appendChild(resizer);
    let startX, startY, signId, userId, indexApprover, idSignature, signUuid;
    resizer.addEventListener('mousedown', (e) => {
      e.stopPropagation();
      startX = e.clientX;
      startY = e.clientY;
      document.documentElement.addEventListener('mousemove', doDrag);
      document.documentElement.addEventListener('mouseup', stopDrag);
      const targetSignId = e.target as Element;
      //la cau hinh ma hop dong
      if (isContractCodeConfig) {
        if (targetSignId.parentElement.id && targetSignId.parentElement.id.includes('contract-code-config-')) {
          idSignature = targetSignId.parentElement.id;
        }
      } else {
        indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
        const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
        signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
        userId = targetSignId.parentElement.id.slice(indexApprover + 10);
        signUuid = targetSignId.parentElement.id.slice(0, indexSign);
      }

    });

    let baseWidth = signatureWidth;
    let baseHeight = signatureHeight;

    const rerenderSign = () => {
      let signSelected, signatureSelected;
      if (this.listSign.length) {
        if (userId !== null && userId !== undefined && userId !== 'undefined') {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId ) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
        } else {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))));
        };
      } if (this.listSignature.length) {

        if (idSignature !== null && idSignature !== undefined && idSignature !== 'undefined') {
          signatureSelected = this.listSignature.filter(item => item.id == idSignature);
        };
      }
      if (isContractCodeConfig) {
        //   stampNode.style.whiteSpace = 'nowrap';
        //   stampNode.style.minWidth ='fit-content';
        const signSelected = this.listSignature.filter(item => item.id === id);
        stampNode.style.wordBreak = 'break-word';
        stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
        <div style="font-size: ${(fontSize === 12 ? signSelected[0].fontSize : fontSize) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;">
          ${this.isOnAutoNumber ? this.configAutoNumber : this.document.code}
        </div>
    `;
      } else {
        const signName = signSelected[0] ? signSelected[0].name : '';
        // resize: dùng size LIVE của khung (listSign chỉ được update ở stopDrag nên
        // render theo widthRectangle sẽ làm ảnh đứng size cũ đến khi thả chuột)
        const resizeImgContent = signSelected[0]
          ? this.buildDefaultSignImageContentPx(signName, stampNode.offsetWidth, stampNode.offsetHeight)
          : null;
        if (resizeImgContent) {
          stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
        ${resizeImgContent}
    `;
        } else {
          this.ensureDefaultSignImage(signName);
          stampNode.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
        <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
          ${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}
        </div>
    `;
        }
      }
      stampNode.appendChild(resizer);
      resizer.style.removeProperty('--zoom');
      resizer.style.setProperty('--zoom', (signZoom).toString());
      return;
    }

    const doDrag = (e) => {
      e.stopPropagation();
      let signSelected, signatureSelected;
      if (this.listSign.length) {
        if (userId !== null && userId !== undefined && userId !== 'undefined') {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId ) && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
        } else {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
        }
      } if (this.listSignature.length) {
        if (idSignature !== null && idSignature !== undefined && idSignature !== 'undefined') {
          signatureSelected = this.listSignature.filter(item => item.id == idSignature);
        };
      }
      //neu la cau hinh ma hop dong
      if (isContractCodeConfig) {
        signatureHeight = signatureSelected[0].heightRectangle * this.zoomLevel / 100;
        signatureWidth = signatureSelected[0].widthRectangle * this.zoomLevel / 100;
        stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
        stampNode.style.height = (signatureHeight + e.clientY - startY) + 'px';
      } else {
        signatureHeight = signSelected[0].heightRectangle * this.zoomLevel / 100;
        signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
        stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
        stampNode.style.height = (signatureHeight + e.clientY - startY) + 'px';
        let widthHeightRatio_Drag = stampNode.offsetWidth / stampNode.offsetHeight;
        if (widthHeightRatio !== widthHeightRatio_Drag) {
          stampNode.style.height = (stampNode.offsetWidth / widthHeightRatio) + 'px';
          stampNode.style.width = (stampNode.offsetHeight * widthHeightRatio) + 'px';
        }
      }

      stampNode.style.maxWidth = (elWidth - stampNode.offsetLeft) + 'px';
      stampNode.style.maxHeight = (elHeight - stampNode.offsetTop) + 'px';

      rerenderSign();
    }

    const stopDrag = (e) => {
      e.stopPropagation();
      if (stampNode.offsetWidth / 2 + wrapperLeft < 0 || stampNode.offsetHeight / 2 + wrapperTop < 0) {
        stampNode.style.width = baseWidth + 'px';
        stampNode.style.height = baseHeight + 'px';
      } else {
        baseWidth = stampNode.offsetWidth;
        baseHeight = stampNode.offsetHeight;
      }

      rerenderSign();
      //neu la cau hinh ma hop dong
      if (isContractCodeConfig && this.listSignature) {
        this.listSignature.forEach(item => {
          if (item.id === idSignature) {
            item.widthRectangle = stampNode.offsetWidth * 100 / this.zoomLevel;
            item.heightRectangle = stampNode.offsetHeight * 100 / this.zoomLevel;
          }
        });
        this.createContractService.contractCodePositions.next(this.listSignature);
      } else if (this.listSign.length) {
        this.listSign.forEach(item => {
          if ((item.enterpriseId === signId || item.customerId === signId ) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))) {
            item.widthRectangle = stampNode.offsetWidth * 100 / this.zoomLevel;
            item.heightRectangle = stampNode.offsetHeight * 100 / this.zoomLevel;
          }
        });
        this.createContractService.signPositions.next(this.listSign);
      }
      document.documentElement.removeEventListener('mousemove', doDrag);
      document.documentElement.removeEventListener('mouseup', stopDrag);
    }

    return stampNode;
  }

  // render a element signature
  getStampWrapperForm(positionX: number, positionY: number, width: number, height: number, name: string, id: number, elWidth: number, elHeight: number, element: Element) {
    const stampNode = document.createElement('div');
    stampNode.setAttribute('id', `sign-${id}`);
    // stampNode.innerHTML = this.genStampContent();
    let signatureWidth = width * this.zoomLevel / 100;
    let heightRectangle = height * this.zoomLevel / 100;

    const wrapperLeft = (positionX * this.zoomLevel) / 100;
    const wrapperTop = (positionY * this.zoomLevel) / 100;
    const signZoom = this.zoomLevel / 100;
    let { top, left } = element.getBoundingClientRect();
    const elementId = element.id.replace('text-pdf-layer-', '');
    const widthHeightRatio = this.widthRectangle / this.heightRectangle;
    stampNode.style.position = 'absolute';
    stampNode.style.left = `${wrapperLeft}px`;
    stampNode.style.top = `${wrapperTop}px`;
    stampNode.style.width = `${signatureWidth}px`;
    stampNode.style.height = `${heightRectangle}px`;
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    stampNode.style.color = '#00f';
    stampNode.style.fontFamily = 'Roboto, sans-serif';
    stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
    stampNode.style.display = 'flex';
    stampNode.style.justifyContent = 'center';
    stampNode.style.flexDirection = 'column';
    stampNode.style.textAlign = 'center';
    stampNode.style.fontWeight = 'bold';
    stampNode.style.minWidth = (this.widthRectangle / 10 * 3) + 'px';
    stampNode.style.minHeight = (this.heightRectangle / 10 * 3) + 'px';
    stampNode.style.userSelect = 'none';
    stampNode.style.cursor = 'move';
    const formImgContent = this.buildDefaultSignImageContent(name, width, height);
    stampNode.innerHTML = formImgContent ? formImgContent : `${name}`;
    if (!formImgContent) {
      this.ensureDefaultSignImage(name);
    }

    // move element
    let baseWrapperLeft;
    let baseWrapperTop;
    let basePageIndex;
    let signIndex;
    let positionIndex;
    let signSelected;
    stampNode.addEventListener('mousedown', (e) => {
      // target thường là div ảnh ký mặc định (default-sign-image-content) không có id
      // -> fallback về id của stampNode (sign-<signaturePositionId>) để tìm đúng position
      const targetEl = e.target as HTMLElement;
      const idEl = targetEl && targetEl.id && targetEl.id.includes('sign-') ? targetEl : stampNode;
      signId = idEl.id.replace('sign-', '');

      this.signaturesFormPositions.forEach((signature, index) => {
        signature.signature.positions.forEach((position, indexPosition) => {
          if (position.signaturePositionId.toString() === signId) {
            signIndex = index;
            positionIndex = indexPosition;
            signSelected = position;
            basePageIndex = parseInt(position.page);
          }
        })
      });
      baseWrapperLeft = stampNode.offsetLeft;
      baseWrapperTop = stampNode.offsetTop;
      stampNode.style.left = (stampNode.offsetLeft - stampNode.offsetWidth / 2 + e.offsetX) + 'px';
      stampNode.style.top = (stampNode.offsetTop - stampNode.offsetHeight / 2 + e.offsetY) + 'px';
      const formDragImgContent = this.buildDefaultSignImageContent(name, width, height);
      stampNode.innerHTML = formDragImgContent
        ? `${formDragImgContent}
      <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(stampNode.offsetWidth / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px">${this.translateService.instant('messages.click_to_select_sign_position')}</div>`
        : `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;">
      <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(stampNode.offsetWidth / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
        ${name}
      </div>`;

      document.documentElement.addEventListener('mousemove', doMove);
      document.documentElement.addEventListener('wheel', (wheelEvent) => {
        // stampNode.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
        // stampNode.style.top = `${(wheelEvent.clientY - heightRectangle / 2 - top)}px`;
        const elBounding = element.getBoundingClientRect();
        left = elBounding.left;
        top = elBounding.top;

      })
      document.documentElement.addEventListener('mouseup', stopMove);
    })

    const parentElement = document.getElementById('viewerContainer');

    // wheel element
    parentElement.addEventListener('wheel', (wheelEvent) => {
      // stampNode.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
      // stampNode.style.top = `${(wheelEvent.clientY - heightRectangle / 2 - top)}px`;
      const elBounding = element.getBoundingClientRect();
      left = elBounding.left;
      top = elBounding.top;

    })

    let goPage
    // Move element sign
    const doMove = (e) => {
      goPage = document.getElementById(`text-pdf-layer-${this.pageIndex}`)

      if (this.pageIndex.toString() !== elementId) {
        const elBounding = goPage.getBoundingClientRect();
        left = elBounding.left;
        top = elBounding.top;
        stampNode.remove();
        goPage.appendChild(stampNode)
      } else {
        const elBounding = element.getBoundingClientRect();
        left = elBounding.left;
        top = elBounding.top;
        stampNode.remove();
        goPage.appendChild(stampNode)
      }
      stampNode.style.left = (e.clientX - stampNode.offsetWidth / 2 - left) + 'px';
      stampNode.style.top = (e.clientY - stampNode.offsetHeight / 2 - top) + 'px';

    }

    // stop move and save position
    const stopMove = (e) => {
      e.stopPropagation();
      // gỡ listener TRƯỚC mọi xử lý: nếu body văng lỗi (lookup position fail...)
      // mà gỡ ở cuối thì mousemove bị treo -> khung ký bám theo chuột sau khi nhả
      document.documentElement.removeEventListener('mousemove', doMove);
      document.documentElement.removeEventListener('mouseup', stopMove);
      // click đơn (mousedown + mouseup không di chuyển): doMove chưa chạy lần nào
      // -> goPage undefined
      if (!goPage) {
        goPage = document.getElementById(`text-pdf-layer-${this.pageIndex}`);
      }
      if (stampNode.offsetWidth / 2 + stampNode.offsetLeft < 0
        || stampNode.offsetHeight / 2 + stampNode.offsetTop < 0
        || stampNode.offsetWidth / 2 + stampNode.offsetLeft > goPage.offsetWidth
        || stampNode.offsetHeight / 2 + stampNode.offsetTop > goPage.offsetHeight
      ) {
        stampNode.style.left = baseWrapperLeft + 'px';
        stampNode.style.top = baseWrapperTop + 'px';
        this.pageIndex = basePageIndex;
      } else {
        baseWrapperLeft = stampNode.offsetLeft;
        baseWrapperTop = stampNode.offsetTop;
      }
      const formStopImgContent = this.buildDefaultSignImageContent(name, width, height);
      stampNode.innerHTML = formStopImgContent ? formStopImgContent : `${name}`;
      stampNode.appendChild(resizer);
      const signItem = this.signaturesFormPositions[signIndex].signature.positions[positionIndex];
      signItem.x = stampNode.offsetLeft / signZoom;
      signItem.y = stampNode.offsetTop / signZoom;
      signItem.page = this.pageIndex.toString();

      // debugger
      if (this.createContractService.signatureResponse) {
        const responseSign = this.createContractService.signatureResponse[signIndex].positions[positionIndex];
        responseSign.x = stampNode.offsetLeft / signZoom;
        responseSign.y = stampNode.offsetTop / signZoom;
        responseSign.page = this.pageIndex.toString();
        this.createContractService.signatureResponse[signIndex].positions[positionIndex] = responseSign;
      } else {
        const signatureResponses = Object.assign(this.signaturesFormPositions);
        this.createContractService.signatureResponse = [];
        signatureResponses.map(item => {
          const signatureResponse = Object.assign(item.signature);
          this.createContractService.signatureResponse.push(signatureResponse);
        })
      }
      // Nó bắng thằng này đi thì ở đâu nhận???
      this.createContractService.signatureData.next(this.signaturesFormPositions);

      this.footNote.showSignatureFromData(1);
    }

    //    resize element
    const resizer = document.createElement('div');
    resizer.setAttribute('class', 'resize-div-bot-right');
    resizer.style.setProperty('--zoom', signZoom.toString());
    stampNode.appendChild(resizer);

    let startX, startY;
    let signId;
    let baseWidth;
    let baseHeight;
    resizer.addEventListener('mousedown', (e) => {
      e.stopPropagation();
      startX = e.clientX;
      startY = e.clientY;
      const targetSignId = e.target as Element;
      signId = targetSignId.parentElement.id.replace('sign-', '');

      this.signaturesFormPositions.forEach((signature, index) => {
        signature.signature.positions.forEach((position, indexPosition) => {
          if (position.signaturePositionId.toString() === signId) {
            signIndex = index;
            positionIndex = indexPosition;
            signSelected = position;
          }
        })
      });
      baseWidth = stampNode.offsetWidth;
      baseHeight = stampNode.offsetHeight;
      document.documentElement.addEventListener('mousemove', doDrag);
      document.documentElement.addEventListener('mouseup', stopDrag);

    });

    const rerenderSign = () => {
      stampNode.appendChild(resizer);
      resizer.style.removeProperty('--zoom');
      resizer.style.setProperty('--zoom', (signZoom).toString());
      return;
    }

    const doDrag = (e) => {
      e.stopPropagation();

      signatureWidth = signSelected.width * signZoom;
      heightRectangle = signSelected.height * signZoom;

      stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
      stampNode.style.height = (signatureWidth + e.clientY - startY) + 'px';
      stampNode.style.maxWidth = (elWidth - wrapperLeft) + 'px';
      stampNode.style.maxHeight = (elHeight - wrapperTop) + 'px';
      let widthHeightRatio_Drag = stampNode.offsetWidth / stampNode.offsetHeight;

      if (widthHeightRatio !== widthHeightRatio_Drag) {
        stampNode.style.height = (stampNode.offsetWidth / widthHeightRatio) + 'px';
        stampNode.style.width = (stampNode.offsetHeight * widthHeightRatio) + 'px';
      }
    }

    const stopDrag = (e) => {
      e.stopPropagation();
      if (stampNode.offsetWidth / 2 + wrapperLeft < 0 || stampNode.offsetHeight / 2 + wrapperTop < 0) {
        stampNode.style.width = baseWidth + 'px';
        stampNode.style.height = baseHeight + 'px';
      } else {
        baseWidth = stampNode.offsetWidth;
        baseHeight = stampNode.offsetHeight;
      }
      const signItem = this.signaturesFormPositions[signIndex].signature.positions[positionIndex];
      signItem.width = stampNode.offsetWidth / signZoom;
      signItem.height = stampNode.offsetHeight / signZoom;

      if (this.createContractService.signatureResponse) {
        const responseSign = this.createContractService.signatureResponse[signIndex].positions[positionIndex];
        responseSign.x = stampNode.offsetLeft / signZoom;
        responseSign.y = stampNode.offsetTop / signZoom;
        responseSign.page = this.pageIndex.toString();
        this.createContractService.signatureResponse[signIndex].positions[positionIndex] = responseSign;
      } else {
        const signatureResponses = Object.assign(this.signaturesFormPositions);
        this.createContractService.signatureResponse = [];
        signatureResponses.map(item => {
          const signatureResponse = Object.assign(item.signature);
          this.createContractService.signatureResponse.push(signatureResponse);
        });
      }
      this.createContractService.signatureData.next(this.signaturesFormPositions);

      // stampNode.appendChild(resizer);
      document.documentElement.removeEventListener('mousemove', doDrag);
      document.documentElement.removeEventListener('mouseup', stopDrag);
    };
    return stampNode;
  }

  onStamped() {
    this.isSelectPosition = true;
    this.signSelected = {
      id: this.listSign.length
    }
    this.listSign.push({
      id: this.listSign.length
    });
    this.signatureSelected = {
      id: this.listSignature.length
    }
    this.listSignature.push({
      id: this.listSignature.length
    });
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    if (Object.keys(this.signSelected || {}).length) {
      this.showFramesNotification(this.signSelected,null,false);
    }
    if (Object.keys(this.signatureSelected || {}).length) {
      this.showFramesNotification(this.signatureSelected, null, true);
    }
  }

  showFramesNotification(signSelected, position = null, isContractCodeConfig = false) {
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    const element: any = document.getElementById(`text-pdf-layer-${signSelected.pageIndex}-${this.activeFile}`);
    const signatureWidth = signSelected.widthRectangle * this.zoomLevel / 100;
    const heightRectangle = signSelected.heightRectangle * this.zoomLevel / 100;
    const newTop = position.top ? position.top : 0
    const newLeft = position.left ? position.left : 0
    const stampNode = document.createElement('div');
    const signZoom = this.zoomLevel / 100;
    stampNode.setAttribute('id', 'show-frames-notification');
    let contentNode;
    // keo chan ky
    if (!isContractCodeConfig) {
      const dragFrameImgContent = this.signSelected
        ? this.buildDefaultSignImageContent(this.signSelected.name, this.signSelected.widthRectangle, this.signSelected.heightRectangle)
        : null;
      if (dragFrameImgContent) {
        contentNode = `${dragFrameImgContent}
      <div id="notify_outside" style="position: absolute;font-size: ${16 * signZoom}px;top: -${35 * signZoom}px;left: ${(signSelected.widthRectangle / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px">${this.translateService.instant('messages.click_to_select_sign_position')}</div>`;
      } else {
        this.ensureDefaultSignImage(this.signSelected && this.signSelected.name);
        contentNode = `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;">
      <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(signSelected.widthRectangle / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
        ${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : null} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}
      </div>`;
      }
    } else {
      // stampNode.style.whiteSpace = 'nowrap';
      stampNode.style.wordBreak = 'break-word';
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        contentNode = `
        <div class="text-danger" style="font-size: ${(signSelected.fontSize ? signSelected.fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; cursor: move;">
          ${this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required')}
        </div>
      `;
      } else {
        contentNode = `
        <div style="font-size: ${(signSelected.fontSize ? signSelected.fontSize : 12) * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; color: #00f; cursor: move;">
          ${this.isOnAutoNumber ? this.configAutoNumber : this.document.code}
        </div>
      `;
      }

      //stampNode.style.minWidth = (300 / 10 * 3 * signZoom) + 'px';
      stampNode.style.minHeight = (136 / 10 * 3 * signZoom) + 'px';
      // stampNode.style.minWidth ='fit-content';
      stampNode.style.wordBreak = 'break-word';
    }
    stampNode.style.position = 'absolute';
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.innerHTML = contentNode;
    stampNode.style.left = `${newLeft}px`;
    stampNode.style.top = `${newTop}px`;
    stampNode.style.width = `${signatureWidth}px`;
    stampNode.style.height = `${heightRectangle}px`;
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    if (this.documentCodeNull && !this.isOnAutoNumber) {
      stampNode.style.color = 'red';
    } else {
      stampNode.style.color = '#00f';
    };
    if (signSelected.fontSize) {
      stampNode.style.fontSize = signSelected.fontSize;
    };
    if (signSelected.fontFamily) {
      stampNode.style.fontFamily = signSelected.fontFamily;
    } else {
      stampNode.style.fontFamily = 'Roboto, sans-serif';
    };
    if (signSelected.fontStyle && signSelected.fontStyle.includes('bold')) {
      stampNode.style.fontWeight = 'bold';
    }
    if (signSelected.fontStyle && signSelected.fontStyle.includes('italic')) {
      stampNode.style.fontStyle = 'italic';
    }
    if (signSelected.fontStyle && signSelected.fontStyle.includes('underline')) {
      stampNode.style.textDecoration = 'underline';
    }
    stampNode.style.padding = `${10 * signZoom}px`;
    stampNode.className = 'no-user-select';
    this.stampWrapper = stampNode;
    element.appendChild(stampNode);
  }

  onChangeZoom(event: any) {
    this.zoomLevel = event * 100;
  }

  checkHaveSign(item: any, signData) {
    const files = this.createContractService.fileUploadArray.getValue();
    let id;
    let check;
    let idSign = signData.contractSignId || signData.idNumber
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    if (item.enterpriseId) {
      check = this.listSign.find(sign =>
        (sign.enterpriseId === item.enterpriseId || sign.customerId === item.customerId) && sign.userId === item.userId && sign.fileId === id && (idSign === sign.contractSignId || idSign === sign.idNumber)
       );
       return check ? true : false;
    }
    check = this.listSign.find(sign =>
      sign.customerId === item.customerId && sign.userId === item.userId && sign.fileId === id && (idSign === sign.contractSignId || idSign === sign.idNumber)
    );
    return check ? true : false;
  }

  checkHaveSignature(item: any) {
    const files = this.createContractService.fileUploadArray.getValue();
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    const check = this.listSignature.find(sign =>
      sign.id === item.id && sign.fileId === id
    );
    return check ? true : false;
  }
  index = 1;

  //Thêm khung ký tên doanh nghiệp
  addSign(item: any) {
    // Lay so thu tu chan ky
    const idNumber = uuid.v4();
    // if(item.customerId){
    //   idNumber = this.listSign.filter(res=> res.customerId == item.customerId).length + 1
    // } else {
    //   idNumber = this.listSign.filter(res=> res.enterpriseId == item.enterpriseId).length + 1
    // }
    if (!item.enterpriseId && item.enterpriseSignId ) {
      item.enterpriseId = item.enterpriseSignId
    }
    if (!this.pdfSrc) {
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.error_contract'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.error_contract'));
      }
      const listBtn = document.querySelectorAll("button");
      listBtn.forEach((btn) => {
        if (btn.className.includes('mat-stroked-button-create-document')) {
          btn.classList.add("btn_glowing");
        }
      });
      setTimeout(() => {
        listBtn.forEach((btn) => {
          btn.classList.remove("btn_glowing");
        });
      }, 5000);
      return;
    }
    // console.log(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`);
    if (!document.getElementById(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`)) {
      setTimeout(() => {
        this.addSign(item);
      }, 100);
      return;
    }
    this.returnToPrevPosition();
    if (!this.isSelectPosition) {
      const itemNew = JSON.parse(JSON.stringify(item));
      itemNew.idNumber = idNumber
      itemNew.row_number = 1
      const element: any = document.getElementById(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`);
      const view: any = document.getElementById('viewerContainer');
      const elementBounding = element.getBoundingClientRect();
      const viewBounding = view.getBoundingClientRect();
      const offsetParent = element.offsetParent.dataset;
      const { pageNumber } = offsetParent;
      let signatureWidth = this.widthRectangle * this.zoomLevel / 100;
      let heightRectangle = this.heightRectangle * this.zoomLevel / 100;
      let signZoom = this.zoomLevel / 100;
      const widthHeightRatio = this.widthRectangle / this.heightRectangle;
      const wrapperLeft = 0;
      let wrapperTop = 0;
      if (viewBounding.y - elementBounding.y > heightRectangle) {
        wrapperTop = viewBounding.y - elementBounding.y;
      }
      const newDiv = document.createElement('div');
      // Sua Id chu ky

      newDiv.setAttribute('id', `${idNumber}-sign-${itemNew.enterpriseId || itemNew.customerId }-approver-${itemNew.userId}`);
      newDiv.style.left = `${wrapperLeft}px`;
      newDiv.style.top = `${wrapperTop}px`;
      newDiv.style.width = `${signatureWidth}px`;
      newDiv.style.height = `${heightRectangle}px`;
      newDiv.style.background = 'rgb(0,0,0,0.2)';
      newDiv.style.zIndex = '1';
      newDiv.style.border = '1px solid #999999';
      newDiv.style.lineHeight = '1.9';
      newDiv.style.color = '#00f';
      newDiv.style.fontFamily = 'Roboto, sans-serif';
      newDiv.style.padding = `${10 * signZoom}px`;
      newDiv.style.position = 'absolute';
      newDiv.style.minWidth = (300 / 10 * 3 * signZoom) + 'px';
      newDiv.style.minHeight = (136 / 10 * 3 * signZoom) + 'px';
      const addSignImgContent = this.buildDefaultSignImageContent(itemNew.name, this.widthRectangle, this.heightRectangle);
      if (addSignImgContent) {
        newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
      ${addSignImgContent}
          `;
      } else {
        newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
      <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
            ${this.message.getMessage('signature')} ${itemNew.name} ${this.message.getMessage('number_sign')} ${itemNew.row_number}
          </div>
          `;
      }
      // <div class="resize-div-bot-right" style="--zoom: ${this.zoomLevel}"></div>
      newDiv.className = 'no-user-select';
      const zoomLevel = this.zoomLevel;
      itemNew.stampPositionLeft = 0;
      itemNew.stampPositionTop = 0;
      itemNew.positionX = 100 * wrapperLeft / zoomLevel;
      itemNew.positionY = 100 * wrapperTop / zoomLevel;
      itemNew.pageIndex = this.pageIndex;
      itemNew.zoom = this.zoomLevel / 100;
      itemNew.pdfSrc = this.pdfSrc;
      itemNew.pageNumber = pageNumber;
      itemNew.widthRectangle = this.widthRectangle;
      itemNew.heightRectangle = this.heightRectangle;
      const files = this.createContractService.fileUploadArray.getValue();
      let find;
      if (files && files.length && files[this.activeFile]) {
        const file = files[this.activeFile] as any;
        itemNew.fileId = file.id ? file.id : null;
        // Them nhieu chan ky
        // if (file) {
        //   if (item.enterpriseId) {
        //     find = this.listSign.find(sign => sign.fileId === file.id && sign.enterpriseId === item.enterpriseId && sign.userId === item.userId);
        //   } else {
        //     find = this.listSign.find(sign => sign.fileId === file.id &&  sign.customerId === item.customerId && sign.userId === item.userId);
        //   }
        // }
      }
      if (!find) {
        const resizer = document.createElement('div');
        resizer.setAttribute('class', 'resize-div-bot-right');
        resizer.style.setProperty('--zoom', signZoom.toString());
        newDiv.appendChild(resizer);
        element.appendChild(newDiv);

        let startX, startY;
        let signId;
        let userId;
        let indexApprover;
        let idNumber;
        let signUuid;
        resizer.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);
          const targetSignId = e.target as Element;


          indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
          const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
          signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
          userId = targetSignId.parentElement.id.slice(indexApprover + 10);
          signUuid = targetSignId.parentElement.id.slice(0, indexSign);

        });

        // const signSelected = this.listSign.filter(item => item.enterpriseId === signId);

        let baseWidth = newDiv.offsetWidth;
        let baseHeight = newDiv.offsetHeight;
        const rerenderSign = () => {
          const signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId || item.enterpriseSignId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId)));
          // resize: dùng size LIVE của khung (listSign chỉ được update ở stopDrag nên
          // render theo widthRectangle sẽ làm ảnh đứng size cũ đến khi thả chuột)
          const dragImgContent = signSelected[0]
            ? this.buildDefaultSignImageContentPx(signSelected[0].name, newDiv.offsetWidth, newDiv.offsetHeight)
            : null;
          if (dragImgContent) {
            newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
              ${dragImgContent}
          `;
          } else {
            this.ensureDefaultSignImage(signSelected[0] && signSelected[0].name);
            newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
              <div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;">
                ${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}
              </div>
          `;
          }
          newDiv.appendChild(resizer);
          resizer.style.removeProperty('--zoom');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          return;
        }

        const doDrag = (e) => {
          e.stopPropagation();
          const signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId)));
          signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
          heightRectangle = signSelected[0].heightRectangle * this.zoomLevel / 100;

          newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
          newDiv.style.height = (signatureWidth + e.clientY - startY) + 'px';
          newDiv.style.maxWidth = (element.offsetWidth - wrapperLeft) + 'px';
          newDiv.style.maxHeight = (element.offsetHeight - wrapperTop) + 'px';
          let widthHeightRatio_Drag = newDiv.offsetWidth / newDiv.offsetHeight;
          if (widthHeightRatio !== widthHeightRatio_Drag) {
            newDiv.style.height = (newDiv.offsetWidth / widthHeightRatio) + 'px';
            newDiv.style.width = (newDiv.offsetHeight * widthHeightRatio) + 'px';
          }
          rerenderSign();
        }

        const stopDrag = (e) => {
          e.stopPropagation();
          if (newDiv.offsetWidth / 2 + wrapperLeft < 0 || newDiv.offsetHeight / 2 + wrapperTop < 0) {
            newDiv.style.width = baseWidth + 'px';
            newDiv.style.height = baseHeight + 'px';
          } else {
            baseWidth = newDiv.offsetWidth;
            baseHeight = newDiv.offsetHeight;
          }
          rerenderSign();

          this.listSign.forEach(item => {
            if ((item.enterpriseId === signId || item.customerId === signId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId))) {
              item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
              item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
            }
          });
          this.createContractService.signPositions.next(this.listSign);
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        }

        this.listSign.push(itemNew);
        this.createContractService.signPositions.next(this.listSign);
        // gen lazy SAU KHI push (listSign đã chứa khung mới): phân loại đúng
        // creator/người khác và prepareDefaultSignImages sau đó thấy được tên mới
        this.ensureDefaultSignImage(itemNew.name);
        this.changeDataToTable()
      }
    }
  }

  deleteSign(enterpriseId: string, userId: string, signUuid ,customerId) {
    this.returnToPrevPosition();
    const files = this.createContractService.fileUploadArray.getValue();
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    if (userId === undefined || userId === '' || userId === null || userId === 'undefined') {
      // la khach hang ca nnhan + doannh nghiep
      if(customerId){
        this.listSign = this.listSign.filter(sign => {
          return (sign.enterpriseId !== enterpriseId && sign.customerId !== customerId && sign.fileId === id) || sign.fileId !== id ||
            ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
        });
      }
      else{
        this.listSign = this.listSign.filter(sign => {
          return (sign.enterpriseId !== enterpriseId && sign.customerId !== enterpriseId && sign.fileId === id) || sign.fileId !== id ||
            ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
        });
      }
    } else {
      this.listSign = this.listSign.filter(sign => {
        return (sign.userId !== userId && sign.fileId === id) || sign.fileId !== id ||  ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
      });
    }
    this.createContractService.signPositions.next(this.listSign);
    if(enterpriseId){
      const nodeOther = document.getElementById(`${signUuid}-sign-${enterpriseId}-approver-${userId}`);

      if (nodeOther) {
        nodeOther.remove();
      }
    }
    if(customerId){
      const nodeOther = document.getElementById(`${signUuid}-sign-${customerId}-approver-${userId}`);

      if (nodeOther) {
        nodeOther.remove();
      }
    }

    this.changeDataToTable()
  }

  deleteSignature(idSignature: string) {
    this.returnToPrevPositionSignContract();
    const files = this.createContractService.fileUploadArray.getValue();
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    this.listSignature = this.listSignature.filter(sign => sign.id != idSignature);
    this.listSignatureTable = this.listSignatureTable.filter(sign => sign.id != idSignature);
    this.createContractService.contractCodePositions.next(this.listSignature);
    if (this.listSignatureTable && this.listSignatureTable.length) {
      this.createContractService.listSignatureTable.next(this.listSignatureTable);
    }
    let listHeaderTabs = [];
    this.listSignatureHeadRows.forEach(headerTitle => {
      this.listSignatureTable.forEach(item => {
        if ((item.fileName ? item.fileName : this.getDecodeUri(item.fileId)) == headerTitle) {
          listHeaderTabs.push({ headerTitle });
        }
      })
    })

    //for list chi lay header co trong list
    this.listSignatureHeadRows = this.listSignatureHeadRows.filter(item => listHeaderTabs.map(x => x.headerTitle).includes(item));
    const nodeOther = document.getElementById(idSignature);
    if (nodeOther) {
      nodeOther.remove();
    }
  }

  goToPage(enterpriseId: string, userId: string, signData ,customerId) {
    this.returnToPrevPosition();
    const files = this.createContractService.fileUploadArray.getValue();
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    let idSign = signData.contractSignId || signData.idNumber
    const node =enterpriseId ? document.getElementById(`${idSign}-sign-${enterpriseId}-approver-${userId}`) : document.getElementById(`${idSign}-sign-${customerId}-approver-${userId}`);
    const sign = this.listSign.find(sign => (sign.enterpriseId === enterpriseId || sign.customerId === enterpriseId ||sign.customerId === customerId) && sign.userId === userId && sign.fileId === id);
    this.pageIndex = sign ? sign.pageIndex : 1;
    if (node) {
      setTimeout(() => {
        node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      });
    } else {
      this.signNeedShow = sign.enterpriseId || sign.customerId;
      this.signApproverNeedShow = sign.userId;
    }
  }

  goToPageSignature(item) {
    this.returnToPrevPositionSignContract();
    const files = this.createContractService.fileUploadArray.getValue();
    let id, idx, file;
    if (files && files.length) {
      file = files.find(file => file.name == (item.fileName ? item.fileName : decodeURI(item.fileId))) as any;
      idx = files.findIndex(file => file.name == (item.fileName ? item.fileName : decodeURI(item.fileId)));
      id = file.id ? file.id : null;
    }
    // if (files && files.length && files[this.activeFile]) {
    //   const file = files[this.activeFile] as any;
    //   id = file.id ? file.id : null;
    // }
    // this.activeFile = idx;
    this.changeFileAddContractCode(idx, 'goToPage');
    const node = document.getElementById(item.id);
    const sign = this.listSignature.find(sign => sign.id === item.id && sign.fileId === id);
    this.pageIndex = sign ? sign.pageIndex : 1;
    if (node) {
      setTimeout(() => {
        node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      });
    } else {
      this.signatureNeedShow = sign.id;
    }
  }

  openTabSign() {
    this.createContractService.recordsUserPerformSign.next(this.recordPartySignComponent.RECORD_USER_PERFORM_SIGN);
    this.documentCodeNull = (this.document.code.length == 0);
    this.isOnAutoNumber = this.createContractService.isOnAutoNumber.getValue();
    this.configAutoNumber = this.createContractService.exampleContractCodeAutoNumber.getValue() ? this.createContractService.exampleContractCodeAutoNumber.getValue() : this.createContractService.configAutoNumber.getValue();
    this.tabMode = 'sign';
    if (this.createContractType === 1) {
      const files = this.createContractService.fileUploadArray.getValue();
      let id;
      if (files.length) {
        const file = files[this.activeFile] as any;
        id = file && file.id ? file.id : null;
      }
      this.listSign = this.listSign.filter(sign => {
        let findInListDataCustomer;
        if (sign.enterpriseId) {
          findInListDataCustomer = this.listDataSign.customer.find(cus => cus.enterpriseId === sign.enterpriseId);
        } else {
          findInListDataCustomer = this.listDataSign.customer.find(cus => cus.customerId === sign.customerId );
        }
        const findInListDataEnterprise = this.listDataSign.enterprise.find(ent => ent.enterpriseId === sign.enterpriseId && ent.userId === sign.userId);
        const findInListDataApprover = this.listApproverSign.find(ent => ent.enterpriseId === sign.enterpriseId && ent.userId === sign.userId);
        if (!findInListDataCustomer && !findInListDataEnterprise && !findInListDataApprover && sign.fileId === id) {
          const nodeOther = document.getElementById(`sign-${sign.enterpriseId || sign.customerId}-approver-${sign.userId}`);

          if (nodeOther) {
            nodeOther.remove();
          }
        }
        if (findInListDataEnterprise) {
          const userSign = this.createContractService.recordsUserPerformSign.getValue().find(user => user.role === "1");
          const name = userSign && userSign.name ? userSign.name : null;
          if (name) {
            const nodeOther = document.getElementById(`sign-${sign.enterpriseId || sign.customerId}-approver-${sign.userId}`);


            if (nodeOther) {
              const elements = nodeOther.getElementsByTagName('div');
              if (elements.length) {
                elements.item(0).innerHTML = `${this.message.getMessage('signature')} ${name}`;
              }
            }
          }
        }
        return findInListDataCustomer || findInListDataEnterprise || findInListDataApprover;
      });
      this.listSignature.forEach(sign => {
        const nodeOther = document.getElementById(sign.id);
        if (nodeOther) {
          const elements = nodeOther.getElementsByTagName('div');
          if (elements.length) {
            let nameCode = this.message.getMessage('headertable.doc_code_required');
            if (this.isOnAutoNumber && this.configAutoNumber) {
              elements.item(0).innerHTML = ` ${this.isOnAutoNumber ? this.configAutoNumber : nameCode}`;
              elements.item(0).className = ''
              if (this.documentCodeNull || (!this.configAutoNumber && !this.documentCodeNull)) {
                nodeOther.style.color = 'red';
              }
            } else {
              if (this.document.code !== '') {
                nameCode = this.document.code;
                elements.item(0).innerHTML = ` ${this.isOnAutoNumber ? this.configAutoNumber : nameCode}`;
                elements.item(0).className = ''
                nodeOther.style.color = '#00f';
              } else {
                elements.item(0).innerHTML = ` ${this.isOnAutoNumber ? this.configAutoNumber : nameCode}`;
                elements.item(0).className = 'text-danger'
                if (this.documentCodeNull || (!this.configAutoNumber && !this.documentCodeNull)) {
                  nodeOther.style.color = 'red';
                }
              }
            }


          }
        }
      })
    } else {
      this.footNote.showSignatureFromData();
    }
  }

  returnToPrevPositionSignContract() {
    if (Object.keys(this.signatureSelected || {}).length) {
      const position = this.signatureSelected;
      const element = document.getElementById(`text-pdf-layer-${position.pageIndex}-${this.activeFile}`);
      const x = position.positionX;
      const y = position.positionY;
      const _width = position.widthRectangle;
      const _height = position.heightRectangle;
      const name = this.isOnAutoNumber ? this.configAutoNumber : this.document.code; //add configAutoNumber or code
      const id = position.id;
      const fontSize = position.fontSize;
      const fontFamily = position.fontFamily;
      const fontStyle = position.fontStyle;
      const elWidth = element.offsetWidth;
      const elHeight = element.offsetHeight;

      const htmlNode = this.getStampWrapper(x, y, _width, _height, name, id, elWidth, elHeight, '', fontSize, fontFamily, fontStyle, true, (position.contractSignId || position.idNumber), position.row_number);
      element.appendChild(htmlNode);
      this.signatureSelected = null;
      this.isSelectPosition = false;
      document.body.style.userSelect = 'none';
    }
  }

  returnToPrevPosition() {
    if (Object.keys(this.signSelected || {}).length) {
      const position = this.signSelected;
      const element = document.getElementById(`text-pdf-layer-${position.pageIndex}-${this.activeFile}`);
      const x = position.positionX;
      const y = position.positionY;
      const _width = position.widthRectangle;
      const _height = position.heightRectangle;
      const name = position.name;
      const id = position.enterpriseId || position.customerId;
      const userId = position.userId;
      const elWidth = element.offsetWidth;
      const elHeight = element.offsetHeight;
      const htmlNode = this.getStampWrapper(x, y, _width, _height, name, id, elWidth, elHeight, userId, null, null, [], false, (this.signSelected.idNumber || this.signSelected.contractSignId), this.signSelected.row_number);
      element.appendChild(htmlNode);
      this.signSelected = null;
      this.isSelectPosition = false;
      document.body.style.userSelect = 'none';
    }
  }

  renderSignViewWhenDataChange() {
    const users = this.createContractService.recordsPartySign.getValue();
    const approver = this.createContractService.recordsUserPerformSign.getValue();
    const approverCus = [];
    users.forEach(ele =>{
      if(ele && !ele.isCreatedSide){
        if(ele.customerApproves)
          ele.customerApproves.forEach(ala =>{
            approverCus.push(ala);
          })
      }
    })
    if (!this.signaturesFormPositions || !this.signaturesFormPositions.length) {
      return;
    }
    this.signaturesFormPositions.forEach(sign => {
      if (sign.signature && sign.signature.positions) {
        sign.signature.positions.forEach(item => {
          const element = document.getElementById(`text-pdf-layer-${item.page}`);
          if (element) {
            let name = null;
            if (sign.customerId && sign.signature.object === 'CUSTOMER') {
              const customer = users.find(user => user.customerId === sign.customerId);
              if (customer && customer.name) {
                name = customer.name;
              } else {
                name = sign.signature.name;
              }
            } else if (sign.userId && sign.signature.object === 'ENTERPRISEAPPROVER') {
              const approve = approver.find(user => user.userId === sign.userId);
              if (approve && approve.name && approve.isSignDigitalCertificate && approve.signConfig.showImage) {
                name = approve.name;
              } else {
                name = sign.signature.name;
              }
            } else if (sign.userId && sign.signature.object === 'CUSTOMERAPPROVER') {
              const approveCus = approverCus.find(user => user.userId === sign.userId);
              if (approveCus && approveCus.name ) {
                name = approveCus.name;
              } else {
                name = sign.signature.name;
              }
            }
            else {
              if (sign.signature.object === 'CUSTOMER') {
                name = sign.signature.name;
              } else if (sign.signature.object === 'ENTERPRISEAPPROVER') {
                name = sign.signature.name;
              }else if (sign.signature.object === 'CUSTOMERAPPROVER') {
                name = sign.signature.name;
              }  else {
                const createSide = users.find(user => user.isCreatedSide);
                const userPerformSign = this.createContractService.recordsUserPerformSign.getValue();
                const userSign = userPerformSign.find(user => user.role === EnumRoleUser.USER_SIGN);
                if (createSide && userSign) {
                  name = userSign.name;
                } else {
                  name = this.message.getMessage('signature_tab.create_side');
                }
              }
            }
            const id = item.signaturePositionId;
            const signBox = document.getElementById(`sign-${id}`);
            if (signBox) {
              signBox.remove();
            }
            const x = item.x;
            const y = item.y;
            const _width = item.width;
            const _height = item.height;
            const elWidth = element.offsetWidth;
            const elHeight = element.offsetHeight;
            const htmlNode = this.getStampWrapperForm(x, y, _width, _height, name, id, elWidth, elHeight, element);
            element.appendChild(htmlNode);
          }
        })
      }
    })
  }

  async genSignatureData() {
    const body: any = {
      code: this.createContractService.key
    }
    // console.log("key", this.createContractService.key);
    const res = await this.documentTemplateService.getSignaturePosition(body, this.createContractService.selectedTemplate.getValue() ? this.createContractService.selectedTemplate.getValue().id : '').toPromise();
    this.renderSignOnce = 1
    this.blockUI.reset();
    this.blockUI.start('');
    if (!res || !res.data) {
      this.blockUI.stop();
      return;
    }
    // if (!this.createContractService.signatureData.getValue()) {
    //   this.createContractService.signatureResponse = res.data;
    // }
    this.createContractService.signatureResponse = res.data;


    if (!this.createContractService.signatureData.getValue() || (this.createContractService.signatureData.getValue() && this.handsontableService.dirty.value)) {
      const data = res.data.map(item => {
        const signature: any = { signature: item };
        return signature;
      });
      this.signaturesFormPositions = this.genSignature(data);
      // debugger
      this.createContractService.signatureResponse = res.data;
      this.createContractService.signatureData.next(this.signaturesFormPositions);
      this.footNote.showSignatureFromData();
    } else if (this.flagCopy) {
      // Keep the copied signer assignments, but use positions resolved on the new file.
      this.signaturesFormPositions.forEach(sign => {
        if (!sign.signature) {
          return;
        }
        const signature = res.data.find(item => item.signatureId === sign.signature.signatureId);
        if (signature && signature.positions) {
          const savedPositions = sign.signature.positions || [];
          sign.signature.positions = signature.positions.map(position => {
            const savedPosition = savedPositions.find(item =>
              item.signaturePositionId === position.signaturePositionId);
            return { ...savedPosition, ...position };
          });
          sign.signature.page = Array.from(new Set(sign.signature.positions
            .filter(position => position.page).map(position => position.page))).join(', ');
        }
      });
      this.createContractService.signatureData.next(this.signaturesFormPositions);
      this.footNote.showSignatureFromData();
    } else { //Map  chân ký ở chỗ này! An!
      this.signaturesFormPositions.map(sign => {
        if (sign.signature && sign.signature.positions) {
          const page = [];
          const signature = res.data.find(item => item.signatureId === sign.signature.signatureId);
          if (signature && signature.positions) {
            sign.signature.positions.map(position => {
              const positionData = sign.signature.positions.find(pos => pos.signaturePositionId === position.signaturePositionId);
              if (positionData) {
                position.x = positionData.x;
                position.y = positionData.y;
                position.page = positionData.page ? positionData.page : null;
              }
              if (position.page && !page.includes(position.page)) {
                page.push(position.page);
              }
            })
          }
          sign.signature.page = page.join(', ');
        }
      })
    }
    setTimeout(() => {
      this.blockUI.stop();
    })
  }

  genSignature(signature: any) {
    const users = this.createContractService.recordsPartySign.getValue();
    const listUsers = this.createContractService.recordsUserPerformSign.getValue();
    const enterprise = users.find(item => item.isCreatedSide);
    const customers = users.filter(user => {
      return !user.isCreatedSide
    }).sort((a, b) => (Number(a.order) || 0) - (Number(b.order) || 0));
    const participants = this.createContractService.getCustomerFootnoteParticipants(signature);
    const customerSigners = participants.filter(person => String(person.role) === '1');
    const customerApprovers = participants.filter(person =>
      String(person.role) === '2' || String(person.role) === '7');
    const hasFootnote = this.createContractService.hasCurrentCustomerFootnote(signature);
    const approver = listUsers.filter(item => {
      return item.role === EnumRoleUser.USER_APPROVER && item.isSignDigitalCertificate && item.signConfig.showImage;
    })
    let indexCustomer = 0;
    let indexCustomerApprover = 0;
    let indexApprover = 0;
    const data = signature.map(item => {
      if (item.signature) {
        const page = [];
        if (item.signature.positions) {
          item.signature.positions.forEach(pos => {
            if (pos.page && !page.includes(pos.page)) {
              page.push(pos.page);
            }
          });
        }
        item.signature.page = page.join(', ');
        if (item.signature.object && item.signature.object === 'ENTERPRISE') {
          item.customerId = enterprise && (enterprise.enterpriseId || enterprise.customerId ) ? (enterprise.enterpriseId || enterprise.customerId) : localStorage.getItem('enterpriseId');
        } else if (item.signature.object && item.signature.object === 'ENTERPRISEAPPROVER') {
          item.userId = approver && approver[indexApprover] && approver[indexApprover].userId ? approver[indexApprover].userId : null;
          indexApprover++;
          //An
        // } else if (item.signature.object && item.signature.object !== 'CUSTOMERAPPROVER') {
        //   item.customerId = customers && customers[indexCustomer] && customers[indexCustomer].customerId ? customers[indexCustomer].customerId : null;
        //   indexCustomer++;
        // }

        } else if (item.signature.object === 'CUSTOMER' || item.signature.object === 'CUSTOMERAPPROVER') {
          if (item.signature.object === 'CUSTOMER') {
            const assignedSigner = customerSigners.find(person => person.signatureId != null &&
              String(person.signatureId) === String(item.signature.signatureId));
            item.customerId = assignedSigner ? assignedSigner.customerId : hasFootnote
              ? null : customerSigners[indexCustomer] && customerSigners[indexCustomer].customerId || null;
            indexCustomer++;
          } else {
            const assignedApprover = customerApprovers.find(person => person.signatureId != null &&
              String(person.signatureId) === String(item.signature.signatureId));
            const selectedApprover = assignedApprover || (hasFootnote ? null : customerApprovers[indexCustomerApprover]);
            item.userId = selectedApprover && selectedApprover.userId || null;
            indexCustomerApprover++;
          }
        } else {
          item.customerId = customers[indexCustomer] && customers[indexCustomer].customerId || null;
          indexCustomer++;
        }
      }
      return item;
    });
    return data;
  }

  changeFile(path: string, index: number) {
    this.selectedFileSign = index
    this.pageIndex = 1;
    this.activeFile = index;
    if (this.listPdfSrc) {
      // this.pdfSrc = this.fileSrc[index];
      this.pdfSrc = this.listPdfSrc[path]
    }
  }

  changeFileAddContractCode(event: any, type?: string) {
    this.documentCodeNull = (this.document.code.length == 0);
    let idx = 0;
    if (type && type == 'selectFile') {
      idx = event.value;
      this.selectedNumberPage = 1;
    } else {
      if (type == 'goToPage') {
        this.selectedNumberPage = null;
      }
      idx = event;
    }

    this.pageIndex = 1;
    this.document.mainContractAttachments.forEach((file, index) => {
      if (file.fileName == this.fileUploads[idx].name) {
        this.activeFile = index;
      }
    });
    //this.activeFile = idx;
    const file = this.createContractService.fileUploadSrc.getValue();
    this.selectFile = this.fileUploads[idx];
    if (file.length) {
      this.pdfSrc = file[idx];
      this.isCheckFile = false;
    }
  }

  removeFile(index: number) {
    // let fileSizeStamp = 0;
    // this.document.mainContractAttachments.forEach(e => {
    //   fileSizeStamp = fileSizeStamp + Number(e.fileSize)
    // });
    // this.fileUploadSize = fileSizeStamp;
    if (index == this.activeFile) {
      if (this.activeFile > 0) {
        this.activeFile = this.activeFile - 1;
      } else {
        this.activeFile = 0;
      }

    } else if (index < this.activeFile) {
      this.activeFile = this.activeFile - 1;
    }

    const oldDataMainContractAttachments = [...this.document.mainContractAttachments];
    const fileDelete = oldDataMainContractAttachments[index] ? oldDataMainContractAttachments[index] : null as any;
    // if (fileDelete.id.length > 0) {
    //   this.biggerThan10MBFileSize = this.biggerThan10MBFileSize + fileDelete.fileSize;
    //   this.fileUploadSize = this.fileUploadSize - fileDelete.fileSize;
    // }
    this.document.mainContractAttachments.splice(index, 1);
    this.document.mainContractAttachments = [...this.document.mainContractAttachments.map((data, index) => ({
      ...data,
      attachmentOrder: index
    }))];
    if (this.document.mainContractAttachments.length == 0) {
      this.pdfSrc = null;
      this.activeFile = 0;
      this.listSignatureHeadRows = [];
      this.listSignature = [];
      this.listSignatureTable = [];
      this.fileUploads = [];
      this.createContractService.pdfSrc.next(null);
      this.document.templateFilePath = null;
      this.createContractService.contractCodePositions.next([]);
      this.createContractService.listSignatureTable.next([]);
      this.createContractService.fileUploadArray.next([]);
      this.createContractService.fileUploadSrc.next([]);
    } else {
      this.pdfSrc = this.listPdfSrc[this.document.mainContractAttachments[this.activeFile].path]
    }
    let newFile = [];
    let file = [...this.createContractService.fileUploadArray.getValue()];
    let fileSrc = this.createContractService.fileUploadSrc.getValue();

    this.document.mainContractAttachments.forEach((mainAttachment) => {
      file.forEach((fileNew) => {
        if(mainAttachment.fileName === fileNew.name) {
          newFile.push(fileNew);
        }
      })
    });
    file = [...newFile];

    // file.splice(index, 1);
    fileSrc.splice(index, 1);
    // console.log(file);
    this.createContractService.fileUploadArray.next(file);
    this.createContractService.mainContractAttactment.next(this.document.mainContractAttachments)
    this.createContractService.fileUploadSrc.next(fileSrc);
    if (fileDelete) {
      if (this.listSign.length) {
        this.listSign = this.listSign.filter(item => {
          return item.fileId !== fileDelete.id
        });
        this.createContractService.signPositions.next(this.listSign);
      }
      if (this.listSignature.length) {
        this.listSignature = this.listSignature.filter(item => {
          return (item.fileName ? item.fileName : decodeURI(item.fileId)) !== fileDelete.fileName
        });
        this.listSignatureTable = this.listSignatureTable.filter(item => {
          return (item.fileName ? item.fileName : decodeURI(item.fileId)) !== fileDelete.fileName
        });
        this.createContractService.contractCodePositions.next(this.listSignature);
        if (this.listSignatureTable && this.listSignatureTable.length) {
          this.createContractService.listSignatureTable.next(this.listSignatureTable);
        }
      }
      this.removeListSignHeadRows(fileDelete.fileName);
    }
    this.selectedFile = '';
    this.selectedFileSign = this.activeFile;
    this.selectedNumberPage = null;
  }

  renderNameFile() {
    const files = this.createContractService.fileUploadArray.getValue();
    let name;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      name = file.name ? file.name : null;
    }
    return name;
  }

  //doi font chu
  onChangeFont(event, item) {
    //const nodeOther = document.getElementById(`sign-${enterpriseId}-approver-${userId}`);
    const objSignature = this.listSignature.find(element => element.id == item.id); //lay chan ky thu i
    const nodeOther = document.getElementById(`${objSignature.id}`);
    if (nodeOther) {
      nodeOther.style.fontFamily = event.value;
    }
    //them thuoc tinh vao param
    this.listSignature.forEach(item => {
      if (item.id == objSignature.id) {
        item.fontFamily = event.value;
      }
    })
    this.createContractService.contractCodePositions.next(this.listSignature);
  }
  //doi font size
  onChangeFontSize(event, item) {
    setTimeout(_ => {
      let fontSize = event;
      if (fontSize > 30) fontSize = 30;
      if (fontSize < 10) fontSize = 10;
      const objSignature = this.listSignature.find(element => element.id == item.id); //lay chan ky thu i
      this.listSignatureTable.forEach(element => {
        if (element.id == item.id) {
          item.fontSize = fontSize;
        }
      })
      const nodeOther = document.getElementById(`${objSignature.id}`);
      if (nodeOther) {
        nodeOther.children[1]['style'].fontSize = (this.zoomLevel / 100 * fontSize * (4 / 3)).toString() + 'px';
      }
      //them thuoc tinh vao param
      this.listSignature.forEach(item => {
        if (item.id == objSignature.id) {
          item.fontSize = fontSize;
        }
      })
      this.createContractService.contractCodePositions.next(this.listSignature);
      if (this.listSignatureTable && this.listSignatureTable.length) {
        this.createContractService.listSignatureTable.next(this.listSignatureTable);
      }
    }, 300);

  }
  onKeyChangeFontSize() {
    let item: any;
    let fontSize = 10;
    this.listSignatureTable.forEach(element => {
      item = element;
      fontSize = element.fontSize;
      if (element.fontSize > 30) {
        element.fontSize = 30;
        fontSize = 30;
      }
      if (element.fontSize < 10) {
        element.fontSize = 10;
        fontSize = 10;
      }
      const objSignature = this.listSignature.find(element => element.id == item.id); //lay chan ky thu i
      this.listSignatureTable.forEach(element => {
        if (element.id == item.id) {
          item.fontSize = fontSize;
        }
      })
      if (objSignature) {
        const nodeOther = document.getElementById(`${objSignature.id}`);
        if (nodeOther) {
          //nodeOther.style.fontSize = fontSize.toString() +'px';
          nodeOther.children[1]['style'].fontSize = (this.zoomLevel / 100 * fontSize * (4 / 3)).toString() + 'px';
        }
        //them thuoc tinh vao param
        this.listSignature.forEach(item => {
          if (item.id == objSignature.id) {
            item.fontSize = fontSize;
          }
        })
        this.createContractService.contractCodePositions.next(this.listSignature);
        if (this.listSignatureTable && this.listSignatureTable.length) {
          this.createContractService.listSignatureTable.next(this.listSignatureTable);
        }
      }
    });



  }

  // them param chan ky
  addSignatureToTable() {
    if (this.selectedFile === '') {
      this.toastr.error(this.message.getMessage('messages.add_file_deleted'));
      return;
    }
    let id = `contract-code-config-${this.listSignature.length}`;
    if (this.listSignatureTable.filter(item => item.id === id).length) {
      id = `contract-code-config-${this.listSignature.length + 1}`;
    }
    let item = {
      id,//genId
      name: this.document.code,
      page: Number(this.selectedNumberPage),
      fontSize: 12,
      fontFamily: "Times-Roman",
      fontStyle: []
    };

    // this.listSignatureTable.push(
    //   {
    //     id: item.id,//set id vao listTable
    //     fileName: this.selectFile['name'],
    //     fontFamily: 'Times-Roman',
    //     fontSize: 12,
    //     page: Number(this.selectedNumberPage),
    //     fontStyle: []
    //   });
    this.addListSignHeadRows(this.selectFile['name']);
    this.pageIndex = Number(this.selectedNumberPage);
    if (this.listSignatureTable && this.listSignatureTable.length) {
      this.createContractService.listSignatureTable.next(this.listSignatureTable);
    }
    //this.selectedFont = this.listFont[0].value;
    this.addSignature(item);
    this.selectedFile = null || '';
    this.selectedNumberPage = null;
    this.isCheckFile = true
  }

  // them chan ky vao trang
  addSignature(item) {
    const arr = document.querySelectorAll('.page')
    if (arr) {
      setTimeout(() => {
        arr.item(item.page - 1).scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })
      });
    }
    if (!this.pdfSrc) {
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.error_contract'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.error_contract'));
      }
      const listBtn = document.querySelectorAll("button");
      listBtn.forEach((btn) => {
        if (btn.className.includes('mat-stroked-button-create-document')) {
          btn.classList.add("btn_glowing");
        }
      });
      setTimeout(() => {
        listBtn.forEach((btn) => {
          btn.classList.remove("btn_glowing");
        });
      }, 5000);
      return;
    }

    if (!document.getElementById(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`)) {
      setTimeout(() => {
        this.addSignature(item);
      }, 100);
      return;
    }

    this.returnToPrevPositionSignContract();
    if (!this.isSelectPosition) {
      const itemNew = JSON.parse(JSON.stringify(item));
      const element: any = document.getElementById(`text-pdf-layer-${item.page}-${this.activeFile}`);
      const view: any = document.getElementById('viewerContainer');
      const elementBounding = element.getBoundingClientRect();
      const viewBounding = view.getBoundingClientRect();
      const offsetParent = element.offsetParent.dataset;
      const { pageNumber } = offsetParent;
      let signatureWidth = this.widthRectangleSignature * this.zoomLevel / 100;
      let signatureHeight = this.heightRectangleSignature * this.zoomLevel / 100;
      let signZoom = this.zoomLevel / 100;
      const wrapperLeft = 0;
      let wrapperTop = 0;
      if (viewBounding.y - elementBounding.y > signatureHeight) {
        wrapperTop = viewBounding.y - elementBounding.y;
      }
      const newDiv = document.createElement('div');
      newDiv.setAttribute('id', `${itemNew.id}`);//tao div co id
      newDiv.style.left = `${wrapperLeft}px`;
      newDiv.style.top = `${wrapperTop}px`;
      newDiv.style.width = `${signatureWidth}px`;
      newDiv.style.height = `${signatureHeight}px`;
      newDiv.style.background = 'rgb(0,0,0,0.2)';
      newDiv.style.zIndex = '1';
      newDiv.style.border = '1px solid #999999';
      newDiv.style.lineHeight = '1.9';
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        newDiv.style.color = 'red';
      } else {
        newDiv.style.color = '#00f';
      }
      newDiv.style.fontFamily = 'Roboto, sans-serif';
      newDiv.style.padding = `${10 * signZoom}px`;
      newDiv.style.position = 'absolute';
      newDiv.style.fontSize = '12px';
      newDiv.style.minWidth = (300 / 10 * 3 * signZoom) + 'px';
      newDiv.style.minHeight = (136 / 10 * 3 * signZoom) + 'px';
      // newDiv.style.whiteSpace = 'nowrap';
      // newDiv.style.minWidth ='fit-content';
      newDiv.style.wordBreak = 'break-word';
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
        <div class="text-danger" style="font-size: ${12 * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%;  cursor: move;">
              ${this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required')}
            </div>
            `;
      } else {
        newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
        <div style="font-size: ${12 * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;">
              ${this.isOnAutoNumber ? this.configAutoNumber : this.document.code}
            </div>
            `;
      }

      // <div class="resize-div-bot-right" style="--zoom: ${this.zoomLevel}"></div>
      newDiv.className = 'no-user-select';
      const zoomLevel = this.zoomLevel;
      itemNew.stampPositionLeft = 0;
      itemNew.stampPositionTop = 0;
      itemNew.positionX = 100 * wrapperLeft / zoomLevel;
      itemNew.positionY = 100 * wrapperTop / zoomLevel;
      itemNew.pageIndex = item.page;
      itemNew.zoom = this.zoomLevel / 100;
      itemNew.pdfSrc = this.pdfSrc;
      itemNew.pageNumber = item.page;
      itemNew.widthRectangle = this.widthRectangleSignature;
      itemNew.heightRectangle = this.heightRectangleSignature;
      const files = this.createContractService.fileUploadArray.getValue();
      let find;
      if (files && files.length && files[this.activeFile]) {
        const file = files[this.activeFile] as any;
        itemNew.fileId = file.id ? file.id : null;
        if (file) {
          //tim item theo fieldId va id
          find = this.listSignature.find(sign => sign.fileId === file.id && sign.id === item.id);
        }
      }
      if (!find) {
        const resizer = document.createElement('div');
        resizer.setAttribute('class', 'resize-div-bot-right');
        resizer.style.setProperty('--zoom', signZoom.toString());
        newDiv.appendChild(resizer);
        element.appendChild(newDiv);

        let startX, startY;
        let id;
        let signId;
        let userId;
        let indexApprover;
        resizer.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);
          const targetSignId = e.target as Element;
          indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
          id = targetSignId.parentElement.id;
          //signId = targetSignId.parentElement.id.slice(5, indexApprover);
          //userId = targetSignId.parentElement.id.slice(indexApprover + 10);
        });

        // const signSelected = this.listSign.filter(item => item.enterpriseId === signId);

        let baseWidth = newDiv.offsetWidth;
        let baseHeight = newDiv.offsetHeight;

        const rerenderSign = () => {
          //tim theo id roi render lai
          const signSelected = this.listSignature.filter(item => item.id === id);
          if (this.documentCodeNull && !this.isOnAutoNumber) {
            newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
              <div class="text-danger" style="font-size: ${12 * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; cursor: move;">
                ${this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required')}
              </div>
          `;
          } else {
            newDiv.innerHTML = `<span class="mat-icon material-icons"style="font-size: ${30 * signZoom}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;">close</span>
            <div style="font-size: ${signSelected[0].fontSize * (4 / 3) * signZoom}px;display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;">
              ${this.isOnAutoNumber ? this.configAutoNumber : this.document.code}
            </div>
        `;
          }

          newDiv.appendChild(resizer);
          resizer.style.removeProperty('--zoom');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          return;
        }

        const doDrag = (e) => {
          this.currentNodeSelected = newDiv;
          e.stopPropagation();
          //tim chu ky do roi set thong so
          const signSelected = this.listSignature.filter(item => item.id == id);
          signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
          signatureHeight = signSelected[0].heightRectangle * this.zoomLevel / 100;
          newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
          newDiv.style.height = (signatureHeight + e.clientY - startY) + 'px';
          newDiv.style.maxWidth = (element.offsetWidth - wrapperLeft) + 'px';
          newDiv.style.maxHeight = (element.offsetHeight - wrapperTop) + 'px';
          rerenderSign();
        }

        const stopDrag = (e) => {
          e.stopPropagation();
          if (newDiv.offsetWidth / 2 + wrapperLeft < 0 || newDiv.offsetHeight / 2 + wrapperTop < 0) {
            newDiv.style.width = baseWidth + 'px';
            newDiv.style.height = baseHeight + 'px';
          } else {
            baseWidth = newDiv.offsetWidth;
            baseHeight = newDiv.offsetHeight;
          }
          rerenderSign();

          this.listSignature.forEach(item => {
            if (item.id === id) {
              item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
              item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
            }
          });
          this.createContractService.contractCodePositions.next(this.listSignature);
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        }

        this.listSignature.push(itemNew);
        this.createContractService.contractCodePositions.next(this.listSignature);
      }
    }
  }

  // chọn định dạng chữ
  chooseFormatFont(formats: string[], item) {
    const objSignature = this.listSignature.find(element => element.id == item.id); //lay chan ky thu i
    const nodeOther = document.getElementById(`${objSignature.id}`);
    if (nodeOther) {
      if (formats.includes('bold')) {
        nodeOther.style.fontWeight = 'bold';
      } else {
        nodeOther.style.fontWeight = 'normal';
      }
      if (formats.includes('italic')) {
        nodeOther.style.fontStyle = 'italic';
      } else {
        nodeOther.style.fontStyle = 'normal';
      }
      if (formats.includes('underline')) {
        nodeOther.style.textDecoration = 'underline';
      } else {
        nodeOther.style.textDecoration = 'none';
      }
    }
    //them thuoc tinh vao param
    this.listSignature.forEach(item => {
      if (item.id == objSignature.id) {
        item.fontStyle = formats;
      }
    });
    this.createContractService.contractCodePositions.next(this.listSignature);
  }
  // fillFieldContractCodePositions(contractCodePositions: any[], mainContractAttachments) {
  //   return contractCodePositions.map(sign => {
  //     const fileDoc = mainContractAttachments.find(file => encodeURIComponent(file['fileName']) === sign['fileId']);
  //     if (fileDoc && fileDoc['id']) {
  //       sign['fileId'] = fileDoc['id'];
  //     }
  //     return sign;
  //   });
  // };
  onPagesLoaded(pagecount: PagesLoadedEvent): void {
    this.totalPage = pagecount.pagesCount;

  }

  validateInput(event: any) {
    const value = event.target.value;

    // Kiểm tra giá trị đầu vào là số nguyên dương và không bắt đầu bằng 0
    if (value && (value < 1 || /^0/.test(value))) {
      // Nếu không hợp lệ, gán giá trị rỗng cho ô input
      event.target.value = '';
    } else {
      // Nếu hợp lệ, cập nhật giá trị mới
      this.selectedNumberPage = value;
    }
  }

  limitValue() {
    // Kiểm tra nếu giá trị lớn hơn totalPage, gán giá trị là totalPage
    if (this.selectedNumberPage > this.totalPage) {
      this.selectedNumberPage = this.totalPage;
    }
    // Kiểm tra nếu ô input trống, đặt giá trị mặc định là 1
    else if (!this.selectedNumberPage) {
      this.selectedNumberPage = 1;
    }
  }

  getContractCodeView() {
    if (this.isOnAutoNumber) {
      return this.configAutoNumber;
    } else {
      if (this.document.code) {
        return this.document.code;
      } else {
        return `<span class="text-danger-code">[${this.message.getMessage('search_form.doc_code')}]</span>`;
      }
    };

  }
  convertConfigAutoNumber(dataApi: any) {
    let dataApiCopy;
    let template = ''

    dataApiCopy = JSON.parse(JSON.stringify(dataApi));
    dataApiCopy['template'].sort((a, b) => a.order - b.order);
    dataApiCopy['template'].forEach(item => {
      if (item.configKey === 'NUMBER_RANGE') {
        item.value = dataApi.fromNumber + '-' + dataApi.toNumber,
          item.type = 1,
          item.viewValue = this.message.getMessage('search_form.component_number')
      }
      if (item.configKey === 'SERVICE_TYPE_CODE') {
        item.value = item.configValue,
          item.type = 3,
          item.viewValue = this.message.getMessage('search_form.service_type_code')
      }
      if (item.configKey === 'dd') {
        item.value = String(new Date().getDate()).padStart(2, '0'),
          item.type = 2,
          item.viewValue = this.message.getMessage('analysis.analysis_report_consumption.options.day'),
          item.displayValue = "DD"
      }
      if (item.configKey === 'MM') {
        item.value = String(new Date().getMonth() + 1).padStart(2, '0'),
          item.type = 2,
          item.viewValue = this.message.getMessage('analysis.analysis_report_consumption.options.month'),
          item.displayValue = "MM"
      }
      if (item.configKey === 'YY') {
        item.value = String(new Date().getFullYear() % 100),
          item.type = 2,
          item.viewValue = this.message.getMessage('service_type.config_contract_code.year'),
          item.displayValue = "YY"
      }
      if (item.configKey === 'YYYY') {
        item.value = String(new Date().getFullYear()),
          item.type = 2,
          item.viewValue = this.message.getMessage('service_type.config_contract_code.year'),
          item.displayValue = "YYYY"
      }
      if (item.configKey === 'CUSTOMER_INPUT') {
        item.value = item.configValue,
          item.type = 4,
          item.viewValue = item.configValue
      }
    })
    for (const i of dataApiCopy.template) {
      if (i.value) {
        if (i.configKey === "NUMBER_RANGE") {
          template = template + `${i.value.split("-")[0]}`
        } else {
          template = template + `${i.value}`
        }
      }
    }
    return template;
  }
  addListSignHeadRows(fileName) {
    if (!this.listSignatureHeadRows.find(s => s === fileName)) {
      this.listSignatureHeadRows.push(fileName);
    }
  }
  removeListSignHeadRows(fileName) {
    this.listSignatureHeadRows.forEach((value, index) => {
      if (value === fileName) this.listSignatureHeadRows.splice(index, 1);
    });
  }
  getDecodeUri(item) {
    return decodeURI(item);
  }
  countIndexTable(idContractCode, fileName) {
    let arrContractCode = [];
    this.listSignatureTable.forEach(item => {
      if (fileName === (item.fileName ? item.fileName : this.getDecodeUri(item.fileId))) {
        arrContractCode.push(item);
      }
    });
    arrContractCode = arrContractCode.map((item, index) => {
      return { index: index + 1, ...item };
    });
    return arrContractCode.find(element => element.id === idContractCode).index;
  }
  getServiceTypeById(idOld, idCurrent) {
    const serviceTypeOld = this.commonService.getServiceType(idOld);
    const serviceTypeCurrent = this.commonService.getServiceType(idCurrent);
    return forkJoin([serviceTypeOld, serviceTypeCurrent]);
  }

  changeFileAddSign(event: any, type?: string){
    this.documentCodeNull = (this.document.code.length == 0);
    let idx = 0;
    if (type && type == 'selectFileSign') {
      idx = event.value;
      this.selectedNumberPage = 1;
    } else {
      if (type == 'goToPage') {
        this.selectedNumberPage = null;
      }
      idx = event;
    }

    this.pageIndex = 1;
    this.document.mainContractAttachments.forEach((file, index) => {
      if (file.fileName == this.fileUploads[idx].name) {
        this.activeFile = index;
      }
    });
    const file = this.createContractService.fileUploadSrc.getValue();
    this.selectFile = this.fileUploads[idx];
    if (file.length) {
      this.pdfSrc = file[idx];
    }
  }

  changeDataApprove(user:any) {
    if (user.isSignDigitalCertificate && !user.signConfig.showImage || !user.isSignDigitalCertificate || user.isDelete && user.isDelete == true) {
      this.pdfSrc = null;
      setTimeout(() => {
        if(this.generalFormInfoComponent.valueSelect === 1) {
          this.pdfSrc = this.listPdfSrc[this.document.mainContractAttachments[this.activeFile].path];
        } else {
          this.pdfSrc = this.oldPdfSrc;
          this.footNote.showSignatureFromData();
        }
      }, 100);
      this.changeDataToTable();
    }
  }

  changeDataEnterprise(isChange:boolean) {
    if (isChange) {
      this.pdfSrc = null;
      setTimeout(() => {
        if(this.generalFormInfoComponent.valueSelect === 1) {
          this.pdfSrc = this.listPdfSrc[this.document.mainContractAttachments[this.activeFile].path];
        } else {
          this.pdfSrc = this.oldPdfSrc;
          this.footNote.showSignatureFromData();
        }
      }, 100);
      this.changeDataToTable();
    }
  }

  resetSignPosition() {
    this.pdfSrc = null;
    setTimeout(() => {
      if(this.generalFormInfoComponent.valueSelect === 1) {
        this.pdfSrc = this.listPdfSrc[this.document.mainContractAttachments[this.activeFile].path];
      } else {
        this.pdfSrc = this.oldPdfSrc;
        this.footNote.showSignatureFromData();
      }
    }, 100);
  }

  // ============ ảnh ký mặc định fill khung chân ký (clone logic view-document) ============

  /** gen ảnh mặc định (tên + tick xanh + giờ ký) cho 1 tên chủ thể, cache theo tên */
  async genDefaultSignImage(name: string): Promise<string> {
    if (!name) {
      return '';
    }
    if (this.defaultSignImageCache.has(name)) {
      return this.defaultSignImageCache.get(name);
    }
    if (this.pendingSignImageGens.has(name)) {
      return this.pendingSignImageGens.get(name);
    }
    const task = this.doGenDefaultSignImage(name);
    this.pendingSignImageGens.set(name, task);
    const result = await task;
    this.pendingSignImageGens.delete(name);
    return result;
  }

  async doGenDefaultSignImage(name: string): Promise<string> {
    // clone config riêng vì genImage đọc enabled/value trực tiếp
    const config = SignatureConfig.build();
    config.enterpriseName.enabled = true;
    config.enterpriseName.value = name;
    config.greenTick.enabled = true;
    // ngày giờ ký: BE định dạng "HH:mm DD/MM/YYYY" (xem genImage lineNumber 3);
    // gọi getDateAsync lấy đúng format hệ thống như màn ký
    config.signingTime.enabled = true;
    config.signingTime.value = format(new Date(), 'HH:mm DD/MM/YYYY');
    config.phoneNumber.enabled = false;
    config.position.enabled = false;
    config.address.enabled = false;
    config.email.enabled = false;
    config.confirmBy.enabled = false;
    config.signatureImage.enabled = false;
    config.fontFamily.value = 'Roboto';
    config.contentPosition.value = ContentPosition.left;
    try {
      // PHẢI gen đúng kích thước hiển thị (300x136): API không scale chữ theo
      // canvas — truyền canvas to hơn thì chữ giữ nguyên cỡ px -> chiếm 1/4 khung
      const blob = await this.imageGenerateService
        .genImage(config, {width: '300px', height: '136px'})
        .toPromise();
      const file = new File([blob], 'signatureImage.png', {type: 'image/png'});
      const imgUrl = (await this.commonService.getBase64(file)) as string;
      this.defaultSignImageCache.set(name, imgUrl);
      return imgUrl;
    } catch (e) {
      console.log('gen default sign image error, fallback to text frame', e);
      // đánh dấu đã thử và thất bại -> các lần render sau dùng text, không gen lại
      this.defaultSignImageCache.set(name, '');
      return '';
    }
  }

  /**
   * gen ảnh cho mọi tên chủ thể trong listSign. Bên lập HĐ (isCreatedSide) dùng
   * ảnh ký từ phương thức ký gần nhất (get-certificate-lastest) thay cho ảnh gen
   * mặc định. Xong hết mới set defaultSignImageReady cho các khung dùng ảnh.
   */
  async prepareDefaultSignImages() {
    const previousCache = this.defaultSignImageCache;
    this.defaultSignImageCache = new Map();
    this.defaultSignImageReady = false;
    const names: string[] = [];
    (this.listSign || []).forEach((s: any) => {
      const n = String(s && s.name || '').trim();
      if (n && !names.includes(n)) {
        names.push(n);
      }
    });
    // listSign rỗng (mới vào màn chưa thêm khung) vẫn gen trước tên bên lập từ
    // listDataSign.enterprise -> get-certificate-lastest được gọi ngay, khi user
    // bấm "+" thì ảnh đã sẵn sàng đúng loại
    (this.listDataSign.enterprise || []).forEach((e: any) => {
      const n = String(e && e.name || '').trim();
      if (n && !names.includes(n)) {
        names.push(n);
      }
    });
    // HĐ tạo từ mẫu: tên khách hàng/người thẩm định chỉ có trong cấu hình mẫu
    // (signaturesFormPositions), listSign không chứa -> gom thêm để gen ngay lúc load
    (this.signaturesFormPositions || []).forEach((s: any) => {
      const positions = (s && s.signature && s.signature.positions) || [];
      positions.forEach((p: any) => {
        const n = String((p && p.name) || (s.signature && s.signature.name) || '').trim();
        if (n && !names.includes(n)) {
          names.push(n);
        }
      });
    });
    if (!names.length) {
      this.defaultSignImageReady = true;
      return;
    }
    const creatorNames = new Set<string>();
    names.forEach(n => {
      if (this.isCreatorName(n)) {
        creatorNames.add(n);
      }
    });
    const customerNames = names.filter(n => !creatorNames.has(n));
    // ảnh gen khách hàng tái dùng cache lần prepare trước nếu có (gen tốn API, cùng
    // kết quả); reset cache mỗi lần phát lại của recordsUserPerformSign từng làm mất
    // ảnh gen lazy -> khung về text. Ảnh bên lập luôn load mới (cấu hình có thể đổi);
    // ảnh gen lỗi ('' falsy) vẫn được thử lại như cũ
    const tasks: Promise<any>[] = customerNames.map(n => {
      const cached = previousCache.get(n);
      if (cached) {
        this.defaultSignImageCache.set(n, cached);
        return Promise.resolve(cached);
      }
      return this.genDefaultSignImage(n);
    });
    if (creatorNames.size) {
      tasks.push(this.loadCreatorSignImages(Array.from(creatorNames)));
    }
    await Promise.all(tasks);
    this.defaultSignImageReady = true;
    // các khung đang render text -> render lại thành ảnh
    this.changeDataToTable();
    this.reRenderFormSignFrames();
  }

  /** base64 thô -> data URL (đã có prefix thì giữ nguyên); rỗng -> '' */
  toDataUrlCert(base64: string): string {
    if (!base64) {
      return '';
    }
    return base64.indexOf('base64,') >= 0 ? base64 : 'data:image/png;base64,' + base64;
  }

  /**
   * ảnh ký cho khung bên lập: theo phương thức ký gần nhất (get-certificate-lastest).
   * defaultSignImageType: 1 upload (imagePath), 2 vẽ (drawSignImagePath),
   * 0 hệ thống (gen theo signConfig user), null -> theo ảnh CTS lưu sẵn.
   * Mọi case lỗi/không có ảnh -> trả '' để caller fallback ảnh gen mặc định.
   */
  async loadCreatorSignImages(names: string[]) {
    let cert: any = null;
    try {
      // signImage=true: BE bổ sung ảnh ký mặc định (defaultSignImageType/Config, imagePath/draw base64)
      const res = await this.documentService.getCertificateLastest(true).toPromise();
      cert = res && res.data ? res.data : null;
    } catch (e) {
      console.log('get-certificate-lastest error', e);
    }
    // email (get-email-user) + giờ ký (get-date) lấy từ server như màn ký, fetch 1 lần
    // cho mọi tên; email không có sẵn trong defaultSignConfig/user-config
    let emailValue = '';
    let dateValue = '';
    try {
      const [email, date] = await Promise.all([
        this.signDocumentService.getEmailAsync().toPromise(),
        this.signDocumentService.getDateAsync().toPromise()
      ]);
      emailValue = email && email.success ? email.data : '';
      dateValue = date && date.success ? date.data.date : '';
    } catch (e) {
      console.log('read email/date for sign image error', e);
    }
    await Promise.all(names.map(async n => {
      let img = '';
      try {
        img = await this.resolveCreatorSignImage(cert, n, emailValue, dateValue);
      } catch (e) {
        console.log('creator sign image error', e);
        img = '';
      }
      if (img) {
        this.defaultSignImageCache.set(n, img);
      } else {
        // lỗi/không có ảnh -> fallback ảnh mặc định giống customer
        await this.genDefaultSignImage(n);
      }
    }));
  }

  async resolveCreatorSignImage(cert: any, name: string, emailValue: string, dateValue: string): Promise<string> {
    if (!cert) {
      return '';
    }
    const type = cert.defaultSignImageType;
    if (type === 1 && cert.imagePath) {
      return this.toDataUrlCert(cert.imagePath);
    }
    if (type === 2 && cert.drawSignImagePath) {
      return this.toDataUrlCert(cert.drawSignImagePath);
    }
    if (type === 0) {
      // hệ thống gen: cert đã cấu hình -> gen theo defaultSignConfig của chứng thư
      return await this.genCreatorSystemImage(cert, name, emailValue, dateValue);
    }
    // null/chưa cấu hình: theo ảnh CTS lưu sẵn (nếu có)
    if (cert.imagePath) {
      return this.toDataUrlCert(cert.imagePath);
    }
    if (cert.imageUrl) {
      const blob = await fetch(cert.imageUrl).then(r => r.blob());
      const file = new File([blob], 'cert.png', {type: 'image/png'});
      return (await this.commonService.getBase64(file)) as string;
    }
    return '';
  }

  /**
   * defaultSignImageType = 0 (gen hệ thống): cert đã cấu hình -> gen CHỈ các trường
   * defaultSignConfig của chứng thư bật (áp qua applyCertDefaultSignConfig như màn ký,
   * KHÔNG đọc user-config); cert chưa cấu hình / config hỏng -> gen theo user-config.
   * lỗi đọc / lỗi gen -> gen giống customer (genDefaultSignImage).
   */
  async genCreatorSystemImage(cert: any, name: string, emailValue: string, dateValue: string): Promise<string> {
    const config = SignatureConfig.build();
    if (this.imageGenerateService.applyCertDefaultSignConfig(config, cert)) {
      // tên chủ thể theo tên bên lập trong tài liệu, không theo cert
      config.enterpriseName.value = name;
      // email + giờ ký từ server như màn ký (email không lưu trong defaultSignConfig)
      config.email.value = emailValue;
      if (dateValue) {
        config.signingTime.value = dateValue;
      }
      try {
        const blob = await this.imageGenerateService
          .genImage(config, {width: '300px', height: '136px'})
          .toPromise();
        const file = new File([blob], 'signatureImage.png', {type: 'image/png'});
        return (await this.commonService.getBase64(file)) as string;
      } catch (e) {
        // lỗi gen -> gen giống customer
        return await this.genDefaultSignImage(name);
      }
    }
    let readConfigOk = false;
    try {
      const res = await this.signDocumentService.getUserConfigAsync().toPromise();
      if (res && res.success && res.data) {
        const d = res.data;
        config.enterpriseName.value = name;
        config.enterpriseName.enabled = !!d.enterpriseName;
        config.greenTick.enabled = d.greenTick !== false;
        config.signingTime.enabled = !!d.signingTime;
        config.signingTime.value = dateValue;
        config.phoneNumber.enabled = !!d.phoneNumber;
        config.phoneNumber.value = d.signature || '';
        config.position.enabled = !!d.position && !!d.positionDetail;
        config.position.value = d.positionDetail || '';
        config.address.enabled = !!d.address && !!d.addressDetail;
        config.address.value = d.addressDetail || '';
        config.confirmBy.enabled = false;
        config.email.enabled = !!d.email;
        config.email.value = emailValue;
        config.signatureImage.enabled = !!d.signatureImage && !!d.signatureImageBase64;
        if (config.signatureImage.enabled) {
          config.signatureImageBase64.value = d.signatureImageBase64;
        }
        if (d.fontFamily) {
          config.fontFamily.value = d.fontFamily;
        }
        if (d.contentPosition) {
          config.contentPosition.value = d.contentPosition;
        }
        readConfigOk = true;
      }
    } catch (e) {
      console.log('read user sign config error', e);
    }
    if (!readConfigOk) {
      // signConfig null / lỗi đọc -> gen giống customer
      return await this.genDefaultSignImage(name);
    }
    try {
      const blob = await this.imageGenerateService
        .genImage(config, {width: '300px', height: '136px'})
        .toPromise();
      const file = new File([blob], 'signatureImage.png', {type: 'image/png'});
      return (await this.commonService.getBase64(file)) as string;
    } catch (e) {
      // lỗi gen -> gen giống customer
      return await this.genDefaultSignImage(name);
    }
  }

  /** ảnh mặc định của 1 tên chủ thể (sync từ cache; chưa có -> null để fallback text) */
  getDefaultSignImage(name: string): string {
    if (!name || !this.defaultSignImageReady) {
      return null;
    }
    return this.defaultSignImageCache.get(name) || null;
  }

  /**
   * nội dung khung ký kiểu ảnh mặc định (giống tab 1 màn ký): box ảnh bằng vùng
   * content của khung — cùng công thức generateStampContentWidthHeight bên màn ký
   * (khung trừ 2*padding*zoom + 2px border). Khung box-sizing: border-box toàn cục
   * (Bootstrap), để box ảnh full khung thì tràn khỏi vùng padding -> lệch phải +
   * tràn trên/dưới (nhìn như zoom in)
   */
  buildDefaultSignImageContent(name: string, widthRect: number, heightRect: number): string {
    const signZoom = this.zoomLevel / 100;
    return this.buildDefaultSignImageContentPx(name, widthRect * signZoom, heightRect * signZoom);
  }

  /** như trên nhưng nhận sẵn kích thước px hiển thị (dùng size live của khung khi resize) */
  buildDefaultSignImageContentPx(name: string, widthPx: number, heightPx: number): string {
    const imgUrl = this.getDefaultSignImage(name);
    if (!imgUrl) {
      return null;
    }
    // khung padding 10*zoom mỗi phía + border 1px mỗi phía -> content box nhỏ hơn
    // box khung đúng phần đó; div ảnh phải nằm gọn trong content box như màn ký
    const frameInset = 20 * (this.zoomLevel / 100) + 2;
    const innerWidth = Math.max(1, widthPx - frameInset);
    const innerHeight = Math.max(1, heightPx - frameInset);
    // pointer-events: none để click xuyên qua img xuống div cha: handler chọn/move khung
    // chỉ check target/parentElement id 1 cấp, img chặn sẽ làm mất khả năng chọn khung.
    // class default-sign-image-content: marker để changeDataToTable thay đúng div này
    return `<div class="default-sign-image-content" style="width: ${innerWidth}px; height: ${innerHeight}px; display: flex; align-items: center; justify-content: center; cursor: move;">
      <img draggable="false" src="${imgUrl}" style="width: 100%; height: 100%; object-fit: contain; margin: auto; pointer-events: none;"/>
    </div>`;
  }

  /**
   * tên chưa có ảnh trong cache -> gen lazy (không chặn render hiện tại).
   * Bên lập (isCreatedSide hoặc enterpriseId khớp party bên lập) dùng ảnh CTS
   * gần nhất; nếu tên đã bị cache nhầm bằng ảnh gen thì xóa cache để load lại đúng.
   */
  ensureDefaultSignImage(name: string) {
    const n = String(name || '').trim();
    if (!n || this.defaultSignImageCache.has(n) || this.pendingSignImageGens.has(n)) {
      return;
    }
    if (this.isCreatorName(n)) {
      // dọn cache nhầm loại: trước fix tên creator có thể đã bị cache bằng ảnh gen
      // mặc định -> xóa để loadCreatorSignImages load đúng ảnh CTS rồi re-render
      if (this.defaultSignImageCache.has(n)) {
        this.defaultSignImageCache.delete(n);
      }
      this.loadCreatorSignImages([n]).then(() => {
        this.changeDataToTable();
        this.reRenderFormSignFrames();
      });
      return;
    }
    this.genDefaultSignImage(n).then(img => {
      if (img) {
        this.changeDataToTable();
        this.reRenderFormSignFrames();
      }
    });
  }

  /**
   * vẽ lại các khung form đang hiển thị (id sign-<signaturePositionId>, dữ liệu
   * signaturesFormPositions) khi ảnh trong cache sẵn sàng. changeDataToTable chỉ
   * dò khung thường (listSign + id compound <contractSignId>-sign-...-approver-...)
   * nên khung form không bao giờ được re-render sau khi gen xong -> kẹt text cho
   * tới khi user click vào khung (trigger renderSignViewWhenDataChange).
   */
  reRenderFormSignFrames() {
    (this.signaturesFormPositions || []).forEach((sign: any) => {
      const positions = (sign && sign.signature && sign.signature.positions) || [];
      positions.forEach((pos: any) => {
        const frame = document.getElementById(`sign-${pos.signaturePositionId}`);
        if (!frame) {
          return;
        }
        const imgContent = this.buildDefaultSignImageContent(
          pos.name || (sign.signature && sign.signature.name), pos.width, pos.height);
        if (!imgContent) {
          return;
        }
        // thay trọn div ảnh (outerHTML) để giữ cấu trúc phẳng; giữ nguyên resizer/
        // notify đang tồn tại dưới dạng node anh em nếu có
        const existingImgDiv = frame.querySelector('div.default-sign-image-content');
        if (existingImgDiv) {
          existingImgDiv.outerHTML = imgContent;
        } else {
          frame.innerHTML = imgContent;
        }
      });
    });
  }

  /** 1 tên có phải của bên lập HĐ không: theo party isCreatedSide (enterpriseId
   * hoặc userId khớp với khung có tên đó) + các item user-perform-sign isCreatedSide */
  isCreatorName(name: string): boolean {
    const n = String(name || '').trim();
    if (!n) {
      return false;
    }
    const parties = this.createContractService.recordsPartySign.getValue() || [];
    const creatorParty = parties.find((item: any) => item && item.isCreatedSide);
    if (creatorParty && creatorParty.enterpriseId) {
      const inListSign = (this.listSign || []).some((s: any) =>
        s && s.enterpriseId === creatorParty.enterpriseId && String(s.name || '').trim() === n);
      if (inListSign) {
        return true;
      }
      // khung mới chưa nằm trong listSign lúc addSign gọi: itemNew có isCreatedSide
      const hasCreatorFlag = (this.listSign || []).some((s: any) =>
        s && s.isCreatedSide && String(s.name || '').trim() === n);
      if (hasCreatorFlag) {
        return true;
      }
      // bên lập theo listDataSign.enterprise (user USER_SIGN của party bên lập)
      const creatorEnterprise = (this.listDataSign.enterprise || []).find((e: any) =>
        e && e.enterpriseId === creatorParty.enterpriseId);
      if (creatorEnterprise && String(creatorEnterprise.name || '').trim() === n) {
        return true;
      }
    }
    return false;
  }

  // ============ end ============

  changeDataToTable(){
    this.listSign.forEach(ele =>{
      if(!ele.name){
        this.listDataSign.enterprise.forEach(res=>{
          let changeDataUser = this.listSign.filter(sign => sign.userId == res.userId);
          this.tranformDataUser(changeDataUser)
        })
        this.listDataSign.customer.forEach(res=>{
          let changeDataCustomer = this.listSign.filter(sign => sign.customerId == res.customerId)
          this.tranformDataUser(changeDataCustomer)
        })
        this.listApproverSign.forEach(res=>{
          let changeDataApprover = this.listSign.filter(sign => sign.userId == res.userId)
          this.tranformDataUser(changeDataApprover)
        })
        if(this.listCusApproverSign.length > 0){
          let changeDataApproverCus = this.listSign.filter(sign => {return sign.CTS && sign.image});
          if(changeDataApproverCus.length >0){
            const dataOther = changeDataApproverCus.filter(item => !this.listCusApproverSign.some(i => i.userId === item.userId));
            const dataDuplicate = this.listCusApproverSign.filter(item => changeDataApproverCus.some(i => i.userId === item.userId));
            if(dataOther.length > 0){
              this.listSign = this.listSign.filter(item => !dataOther.some(i => i.userId === item.userId));
            }
            if(dataDuplicate.length){
              const dataDelete = dataDuplicate.filter(item => {return !item.CTS || !item.image});
              if(dataDelete.length > 0){
                this.listSign = this.listSign.filter(item => !dataDelete.some(i => i.userId === item.userId));
              }
            }
              }
          this.listCusApproverSign.forEach(res=>{
            let changeDataApprover  = this.listSign.filter(sign => sign.userId == res.userId)
            this.tranformDataUser(changeDataApprover)
          })
        }
      }
    })
    this.listDataSign.enterprise.map(res=>{
      let changeDataUser = this.listSign.filter(sign => sign.userId == res.userId)
      this.tranformDataUser(changeDataUser)
    })
    this.listDataSign.customer.map(res=>{
      let changeDataCustomer = this.listSign.filter(sign => sign.customerId == res.customerId)
      this.tranformDataUser(changeDataCustomer)
    })
    this.listApproverSign.map(res=>{
      let changeDataApprover = this.listSign.filter(sign => sign.userId == res.userId)
      this.tranformDataUser(changeDataApprover)
    })
    if(this.listCusApproverSign.length > 0){
      let changeDataApproverCus = this.listSign.filter(sign => {return sign.CTS && sign.image});
      this.listCusApproverSign.map(res=>{
        // this.listSign = this.listSign.filter(sign => {return sign.userId == res.userId && res.CTS && res.image});
        let changeDataApproverCus = this.listSign.filter(sign => {return sign.CTS && sign.image});
        if(changeDataApproverCus.length >0){
          const dataOther = changeDataApproverCus.filter(item => !this.listCusApproverSign.some(i => i.userId === item.userId));
          const dataDuplicate = this.listCusApproverSign.filter(item => changeDataApproverCus.some(i => i.userId === item.userId));
          if(dataOther.length > 0){
            this.listSign = this.listSign.filter(item => !dataOther.some(i => i.userId === item.userId));
          }
          if(dataDuplicate.length){
            const dataDelete = dataDuplicate.filter(item => {return !item.CTS || !item.image});
            if(dataDelete.length > 0){
              this.listSign = this.listSign.filter(item => !dataDelete.some(i => i.userId === item.userId));
            }
          }
        }
        let changeDataApprover = this.listSign.filter(sign => sign.userId == res.userId)
        this.tranformDataUser(changeDataApprover)
      })
    }
    // sortData
    this.listSign.sort((a, b) => a.positionX - b.positionX);
    this.listSign.sort((a, b) => a.positionY - b.positionY);
    this.listSign.sort((a, b) => a.pageIndex - b.pageIndex);
    // render lai khung chan ky
    this.listSign.map(res=>{
      let idSign = (res.contractSignId || res.idNumber) +  '-sign-' + (res.enterpriseId || res.customerId) + '-approver-' + res.userId
      let sign = document.getElementById(idSign)
      if (sign) {
        const elements = sign.getElementsByTagName('div');
        if (elements.length) {
          const rerenderImgContent = this.buildDefaultSignImageContent(res.name, res.widthRectangle, res.heightRectangle);
          if (rerenderImgContent) {
            // div bọc ảnh có class default-sign-image-content: thay TRỌN div này
            // (outerHTML) thay vì ghi innerHTML vào div khác -> tránh lồng div ảnh
            // vào div text/div bọc ảnh cũ làm hỏng cấu trúc id 1 cấp của handler chọn.
            // Frame text chuyển sang ảnh cũng phải thay trọn div text (item(0)) —
            // ghi innerJSON vào div text sẽ lồng 2 tầng -> khung không chọn/move được
            const existingImgDiv = sign.querySelector('div.default-sign-image-content');
            if (existingImgDiv) {
              existingImgDiv.outerHTML = rerenderImgContent;
            } else if (elements.length) {
              (<HTMLElement>elements.item(0)).outerHTML = rerenderImgContent;
            }
          } else {
            this.ensureDefaultSignImage(res.name);
            const firstDiv = <HTMLDivElement>elements.item(0);
            if (firstDiv && firstDiv.classList.contains('default-sign-image-content')) {
              // frame còn div bọc ảnh cũ (cache bị reset) -> thay trọn div bằng text
              firstDiv.outerHTML = `<div style="font-size: ${16 * (this.zoomLevel / 100)}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;">${this.message.getMessage('signature')} ${res.name} ${this.message.getMessage('number_sign')} ${res.row_number}</div>`;
            } else if (firstDiv) {
              firstDiv.innerHTML = `${this.message.getMessage('signature')} ${res.name} ${this.message.getMessage('number_sign')} ${res.row_number}`;
            }
          }
        }
      }
    })
  }

  tranformDataUser(data){
    this.sortData(this.fileUploads,data)
    return data
  }

  orderAcy(data,id){
    const a = data.filter(ele => {return (ele.CTS && ele.image) || ele.isCreatedSide || ele.role == 1})
    if(a.length > 0){
    a.forEach((ala,i) =>{
      ala.orderAcy = i +1;
    });
    const b = a.filter(ala => {return ala.userId == id || ala.customerId == id || ala.enterpriseId == id});
    if(b){
      return b[0].orderAcy
    }
    else {
      return
    }
    }
    else {
      return
    }
  }

  // Sap xep thu tu chan ky
  sortData(listFile, listSignSort){
    const getFileIndex = (fileId: string): number => {
      return listFile.findIndex((file) => file.id === fileId);
    };

    const listSign: any[] = [];

    if (Array.isArray(listSignSort)) {
      listSign.push(...listSignSort);
    }

    listSign.sort((a, b) => a.positionX - b.positionX);
    listSign.sort((a, b) => a.positionY - b.positionY);
    listSign.sort((a, b) => a.pageIndex - b.pageIndex);

    listSign.sort((prev, next) => {
      return (
        getFileIndex(prev.fileId) - getFileIndex(next.fileId)
      );
    });
    this.fileUploads.map((res: any)=>{
      let signFile = listSign.filter(sign => sign.fileId == res.id)
      signFile.forEach((row, index) =>{
        row.row_number = index +1;
    });
    })
    return listSign;
  }

  drop(event: CdkDragDrop<string[]>) {
    const filesSrc = this.createContractService.fileUploadSrc.getValue();
    let arraySrcBeforeMoveFile = [...[]];
    let arraySrcAfterMoveFile = [...[]];

    this.document.mainContractAttachments.forEach((data, indexFileName) => {
      filesSrc.forEach((fileSrc, indexFileSrc) => {
        if(indexFileName === indexFileSrc) {
          arraySrcBeforeMoveFile.push({
            src: fileSrc,
            fileName: data.fileName
          });
        }
      })
    });

    const checkIndexFile = !!(this.activeFile === event.previousIndex);
    const activeFileOld = this.activeFile;

    moveItemInArray(this.document.mainContractAttachments, event.previousIndex, event.currentIndex);
    if(this.activeFile === event.previousIndex) {
      this.activeFile = event.currentIndex;
    } else if(event.previousIndex > this.activeFile && event.currentIndex <= this.activeFile) {
      this.activeFile = this.activeFile + 1;
    } else if(event.previousIndex < this.activeFile && event.currentIndex >= this.activeFile) {
      this.activeFile = this.activeFile - 1;
    } else {
      // console.log(this.document.mainContractAttachments)
    }
    this.document.mainContractAttachments = [...this.document.mainContractAttachments.map((file, index) => ({
      ...file,
      attachmentOrder: index
    }))];

    this.selectedFileSign = this.activeFile;
    this.selectedFile = '';
    this.selectedNumberPage = null;

    const filesUploadNew = [];
    this.document.mainContractAttachments.forEach((file) => {
      this.fileUploads.forEach((fileUpload) => {
        if(file.fileName === fileUpload.name) {
          filesUploadNew.push(fileUpload);
        }
      })
    });
    this.fileUploads = filesUploadNew;
    this.createContractService.fileUploadArray.next(filesUploadNew);

    this.document.mainContractAttachments.forEach((data) => {
      arraySrcBeforeMoveFile.forEach((fileSrc) => {
        if(data.fileName === fileSrc.fileName) {
          arraySrcAfterMoveFile.push(fileSrc.src);
        }
      })
    });

    this.createContractService.fileUploadSrc.next(arraySrcAfterMoveFile);
    for (let i=1; i <= this.maxPageCurrent; i++) {
      // console.log(`text-pdf-layer-${i}-${checkIndexFile ? event.previousIndex : this.activeFile}`)
      const element: any = document.getElementById(`text-pdf-layer-${i}-${checkIndexFile ? event.previousIndex : activeFileOld}`);
      if (element) {
        element.setAttribute('id', `text-pdf-layer-${i}-${this.activeFile}`);
      }
    }
    this.createContractService.mainContractAttactment.next(this.document.mainContractAttachments);
    if(this.createContractType == FileUploadType){
      this.createContractService.pdfSrc.next(arraySrcAfterMoveFile[0]);
    } else {
      this.createContractService.pdfSrc.next(arraySrcAfterMoveFile[this.activeFile]);
    }
    this.changeDataToTable()
    setTimeout(() => {
      const tabs = document.getElementsByClassName('tab');
      if (tabs) {
        Array.from({ length: tabs.length }, (v, i) => i).forEach(index => {
          const tab = tabs.item(index) as HTMLElement;
          tab.style.width = 100 / this.document.mainContractAttachments.length + '%';
        })
      }
    }, 0);
  }

  changeDataSign(event: any, data: any, type: 'userSign' | 'enterpriseSign') {
    if(type === 'userSign') {
      let userSign = [...this.createContractService.recordsUserPerformSign.getValue()];
      userSign = [...userSign.map((userSignItem) => ({
        ...userSignItem,
        signConfig: JSON.stringify({ resize: data.userId === userSignItem.userId ? event.checked : (userSignItem.signConfig && userSignItem.signConfig.length ? JSON.parse(userSignItem.signConfig).resize : false) })
      }))];
      this.createContractService.recordsUserPerformSign.next(userSign);
      return;
    }

    if(type === 'enterpriseSign') {
      let enterpriseSign = [...this.createContractService.recordsPartySign.getValue()];
      enterpriseSign = [...enterpriseSign.map((enterpriseSignItem) => ({
        ...enterpriseSignItem,
        signConfig: JSON.stringify({ resize: data.customerId === enterpriseSignItem.customerId ? event.checked : (enterpriseSignItem.signConfig && enterpriseSignItem.signConfig.length ? JSON.parse(enterpriseSignItem.signConfig).resize : false) })
      }))];
      this.createContractService.recordsPartySign.next(enterpriseSign);
      return;
    }
  }
  onClickResize(j,i){
this.listData[j].customerApproves[i].resize = !this.listData[j].customerApproves[i].resize;
const listDataCustomerApproveResize = [];
    this.listData.forEach(ele =>{
      ele.customerApproves.forEach(ala =>{
        listDataCustomerApproveResize.push(ala);
      })
    })
    this.createContractService.listDataCustomerApproveResize.next(listDataCustomerApproveResize);
// localStorage.setItem("listDataCustomerApproveResize",JSON.stringify(listDataCustomerApproveResize));
  }
getUnique(arr){
    const unique = {};
    for (const item of arr){
      unique[item.contractUserId] = item;
  }
    return Object.values(unique);
}
  getListData(){
    localStorage.removeItem('userSignAllCustomer');
    this.listData= [];
      const listDataSignEnterprise = JSON.parse(localStorage.getItem('listDataSignEnterprise')) ;
      const listDataApproverSign = JSON.parse(localStorage.getItem('listDataApproverSign')) ;
      const listDataSignCustomerNoParent = JSON.parse(localStorage.getItem('listDataSignCustomer')) ;
      const listData = JSON.parse(localStorage.getItem('listDataSignApprove')) ;
      listDataSignCustomerNoParent.forEach((ele,i) =>{
        if(ele && ele.customerApproves){
          delete listDataSignCustomerNoParent[i].customerApproves;
        }
      })
      listData.forEach(ele =>{
        if(ele && ele.isCreatedSide){
          ele.customerApproves = [];
          ele.customerApproves.push(listDataSignEnterprise[0]);
          listDataApproverSign.forEach(ale => {
            ele.customerApproves.push(ale);
          });
        }
        else {
          if(ele.customerApproves){
            const a = listDataSignCustomerNoParent.filter(ala =>{ return ala.customerId == ele.customerId})
            ele.customerApproves.push(a[0]);
          }
          else {
            ele.customerApproves = [];
            const a = listDataSignCustomerNoParent.filter(ala =>{ return ala.customerId == ele.customerId})
            ele.customerApproves.push(a[0]);
          }
        }
      });
      listData.forEach(ele =>{
        ele.customerApproves.forEach(ala =>{
          if(ala && !ala.resize){
            ala.resize = false;
          }

        })
      });
      listData.forEach(ele =>{
        ele.customerApproves.sort((a, b) => a.order - b.order);
      });
      this.listData.forEach(ala =>{
        ala.customerApproves.forEach(ele =>{
          if(ele && !ele.resize){
            ele.resize = false;
          }

        })
      })
      this.listSign.forEach(ele =>{
        if(ele.enterpriseId){
          listData.forEach(ala =>{
            ala.customerApproves.forEach(bla =>{
              if(bla && ele.enterpriseId === bla.enterpriseId && bla.customerId){
                ele.userId = bla.userId
                ele.enterpriseId = bla.enterpriseId
                ele.customerId = bla.customerId
                ele.name = bla.name
                ele.phone = bla.phoneNumber ? bla.phoneNumber : bla.phone
                ele.email = bla.email
              }
            })
          })
        }
        if(!ele.userId){
          listData.forEach(ala =>{
            ala.customerApproves.forEach(bla =>{
              if(bla && ele.contractUserId === bla.contractUserId && bla.contractUserId){
                ele.userId = bla.userId
                ele.enterpriseId = bla.enterpriseId
                ele.customerId = bla.customerId
                ele.name = bla.name
                ele.phone = bla.phoneNumber ? bla.phoneNumber : bla.phone
                ele.email = bla.email
              }
            })
          })
        }
        if(ele.userId){
          listData.forEach(ala =>{
            ala.customerApproves.forEach(bla =>{
              if(bla && ele.userId === bla.userId){
                ele.userId = bla.userId
                ele.name = bla.name
                ele.phone = bla.phoneNumber ? bla.phoneNumber : bla.phone
                ele.email = bla.email
              }
            })
          })
        }
        if(ele.customerId){
          listData.forEach(ala =>{
            ala.customerApproves.forEach(bla =>{
              if(bla && ele.customerId === bla.customerId){
                ele.customerId = bla.customerId
                ele.name = bla.name
                ele.phone = bla.phoneNumber ? bla.phoneNumber : bla.phone
                ele.email = bla.email
              }
            })
          })
        }
      })
      this.listData = listData.sort((a, b) => a.order - b.order);
    this.listData.forEach(ala =>{
      ala.customerApproves.forEach(ele =>{
        if(ele && ele.signConfig){
          if(typeof ele.signConfig == 'string' ){
            const a = JSON.parse(ele.signConfig);
            ele.resize = a.resize
          }
          else{
            ele.resize = ele.signConfig.resize
          }
        }

      })
    })
      this.listData.forEach(ala =>{
        ala.customerApproves.forEach(x =>{
          if(x && x.customerType && !x.isCreatedSide){
            x.role = 1
          }
        })
      })
      this.listData.forEach(ala =>{
       if(!ala.isCreatedSide){
         const index = ala.customerApproves.findIndex(item => item && item.role == 1)
         if(index !==-1){
           const removedItem = ala.customerApproves.splice(index,1)[0];
           ala.customerApproves.push(removedItem);
         }
       }
      })
      this.listCusApproverSign = [];
      this.listData.forEach(ele =>{
        if(ele && !ele.isCreatedSide){
          ele.customerApproves.forEach((ala,i) =>{
            if(i+1 < ele.customerApproves.length){
              this.listCusApproverSign.push(ala);
            }
          })
        }
      })
      const listDataCustomerApproveResize = [];
      this.listData.forEach(ele =>{
        ele.customerApproves.forEach(ala =>{
          listDataCustomerApproveResize.push(ala);
        })
      })
      const listDataCustomerApproveResizeCheck = this.createContractService.listDataCustomerApproveResize.getValue();
      if(!listDataCustomerApproveResizeCheck){
        this.createContractService.listDataCustomerApproveResize.next(listDataCustomerApproveResize);
        // localStorage.setItem("listDataCustomerApproveResize",JSON.stringify(listDataCustomerApproveResize));
      }
      else {
        this.listData.forEach(ele => {
          ele.customerApproves.forEach(ala =>{
            const checkResize = listDataCustomerApproveResizeCheck.filter(item => {
              return ala && ala.customerId == item.customerId && ala.enterpriseId == item.enterpriseId && ala.userId == item.userId
            })
            if(checkResize.length >0){
              ala.resize = checkResize[0].resize;
            }
          })
        })
      }
      // localStorage.setItem("listDataCustomerApproveResize",JSON.stringify(listDataCustomerApproveResize));
      if(this.listSign.length > 0){
        this.changeDataToTable();
      }
      // console.log( this.listData)

    // this.removeDuplicatesByIDs(this.listDataSign.customer);
  }
   removeDuplicatesByIDs(arr) {
    return arr.map(item => ({
      ...item,
      customerApproves: item.customerApproves.filter((customer, index, self) =>
        index === self.findIndex((t) => (
          t.contractUserId === customer.contractUserId
        ))
      )
    }));
  }
  toggleResize(value) {
    console.log(value)
    console.log(this.listData)
  }

  addFileTemplate(){
    if (this.createContractService.createContractType.getValue() == 0) {
      setTimeout(()=>{
        if(!this.document.mainContractAttachments){
          this.document.mainContractAttachments = []
        }
        if(!this.document.mainContractAttachments.map(item => item.source || 'FORM').includes('FORM')){
          const templateFile: ContractAttachments = {
            attachmentOrder: 0,
            active: true,
            fileName: this.createContractService.selectedTemplate.getValue().name + '.pdf',
            fileSize: this.templateSize,
            id: this.createContractService.selectedTemplate.getValue().id,
            path: 'template_path',
            src: this.createContractService.pdfSrcForm.getValue(),
            source: 'FORM'
          }

          const pdfFile: any = {
            size: templateFile.fileSize,
            name: templateFile.fileName,
            type: "application/pdf",
            webkitRelativePath: "",
            source: "FORM",
            id: templateFile.fileName
          }
          this.document.mainContractAttachments.push(templateFile)
          this.createContractService.fileUploadArray.next([pdfFile])
          this.createContractService.fileUploadSrc.next([templateFile.src])
          this.listPdfSrc[templateFile.path] = templateFile.src
          this.createContractService.mainContractAttactment.next(this.document.mainContractAttachments);
          this.createContractService.fileFormTemplate.next(templateFile);
        }

      })
    }
  }

  currentUserId = localStorage.getItem('userId');
  messages: MessageNegotiate[] = [

  ];
  newMessage = '';
  fileList: File[] = [];

  formatFileSize(bytes: number, decimals = 2): string {
    if (bytes == 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const size = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals));
    return `${size} ${sizes[i]}`;
  }

  intervalChat: any;
  isNegotiate: boolean = false
  isCallChatOnce: boolean = false
  getHistoryChat(isScroll: boolean = false){
    this.documentService.getHistoryNegotiate(this.document.id).pipe(finalize(()=> {
      if(isScroll) {
        this.zone.onStable.pipe(take(1)).subscribe(() => {
          this.scrollToBottom();
        });
      }
    })).subscribe(res =>{
      if (res.success) {
        console.log(res.data);
        const emptyValueLabel = this.message.getMessage1('negotiate_contract.chat.empty_value');
        this.messages = (res.data || []).map(item => mapNegotiateMessage(item, emptyValueLabel));
        this.cdr.detectChanges()
      } else {
        this.toastr.error(res.message)
      }
    })
  }
  private expandedMergeHistories = new Set<string>();

  public getNegotiateCopyText = getNegotiateCopyText;

  isMergeHistoryExpanded(entry: MessageNegotiate): boolean {
    return this.expandedMergeHistories.has(this.document.id + ':' + entry.id);
  }

  toggleMergeHistory(entry: MessageNegotiate): void {
    const key = this.document.id + ':' + entry.id;
    if (this.expandedMergeHistories.has(key)) {
      this.expandedMergeHistories.delete(key);
    } else {
      this.expandedMergeHistories.add(key);
    }
  }

  downLoadFileNegotiate(file: any) {
    this.documentService.downLoadFileNegotiate(file.filePath).subscribe(rs => {
      console.log(rs);
      if(rs.type == 'application/json') {
        this.toastr.error(this.message.getMessage('messages.no_permission_on_document'))
        return;
      }
      let type: string = '';
      if (file.fileName.slice(-3).toLowerCase() === 'pdf') {
        type = 'pdf';
        const reader = new FileReader();
        reader.readAsDataURL(rs);
        reader.onload = (event) => {
          const path = event.target == null ? '' : (event.target as any).result;
          const filePath = path as string;
          const filePathBase64 = filePath.split(',')[1];
          this.previewPdf({filePath: file.filePath, filePathBase64: filePathBase64, fileName: file.fileName, type: type, fileId: file.id});
        }
      } else if(['png','jpg', 'bmp'].includes(file.fileName.slice(-3).toLowerCase()) || file.fileName.slice(-4).toLowerCase() == 'jpeg'){
        type = 'image'
        // const image = new Blob([rs], { type: 'image/png' });
        const imageURL = URL.createObjectURL(rs);
        this.previewPdf({type: type, fileName: file.fileName, fileId: file.id, imageURL: imageURL, filePath: file.filePath});
      } else {
        this.downLoadFile(rs, 'application/octet-stream', file.fileName)

      }

    });
  }
  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], {type});
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  @ViewChild('textAreaRef', { static: false }) textAreaRef!: ElementRef;
  scrollToBottom(): void {
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
    }
  }
  previewPdf(dataFile: any) {
    const data = {
      ...dataFile
    };
    this.isShowReferencePdf = true
    const dialogRef = this.dialog.open(ViewFilePdfImgComponent, {
      width: '1000px',
      data,
      minWidth: '365px'
    });
    dialogRef.afterClosed().subscribe(rs => {
      this.isShowReferencePdf = false
    });
  }
  scrollToMessage(data){
    if (data.id) {
      const element = document.getElementById(`message-id-${data.id}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.classList.add('focused');
        setTimeout(() => {
          element.classList.remove('focused');
        }, 1000);
      }
    } else {
      alert('Không tìm thấy tin nhắn!');
    }
  }
  getTailFile(name: string){
    return name.split('.').pop()
  }
}
